/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const LS_listAvailableShops = /* GraphQL */ `
  query LS_listAvailableShops($storeId: ID!) {
    LS_listAvailableShops(storeId: $storeId)
  }
`;
export const LS_listCsTasks = /* GraphQL */ `
  query LS_listCsTasks(
    $storeId: ID!
    $status: String
    $types: [String]
    $start: String
    $end: String
    $assigneeId: ID
    $orderId: ID
    $page: Int
    $size: Int
  ) {
    LS_listCsTasks(
      storeId: $storeId
      status: $status
      types: $types
      start: $start
      end: $end
      assigneeId: $assigneeId
      orderId: $orderId
      page: $page
      size: $size
    )
  }
`;
export const LS_countCsTasks = /* GraphQL */ `
  query LS_countCsTasks($storeId: ID!) {
    LS_countCsTasks(storeId: $storeId)
  }
`;
export const LS_listCsActivities = /* GraphQL */ `
  query LS_listCsActivities(
    $storeId: ID!
    $orderId: ID
    $taskId: ID
    $start: String
    $end: String
    $page: Int
    $size: Int
  ) {
    LS_listCsActivities(
      storeId: $storeId
      orderId: $orderId
      taskId: $taskId
      start: $start
      end: $end
      page: $page
      size: $size
    )
  }
`;
export const LS_searchCsOrders = /* GraphQL */ `
  query LS_searchCsOrders($storeId: ID!, $keyword: String!, $limit: Int) {
    LS_searchCsOrders(storeId: $storeId, keyword: $keyword, limit: $limit)
  }
`;
export const LS_listPreConfirmOrders = /* GraphQL */ `
  query LS_listPreConfirmOrders(
    $storeId: ID!
    $search: String
    $origins: [String]
  ) {
    LS_listPreConfirmOrders(
      storeId: $storeId
      search: $search
      origins: $origins
    )
  }
`;
export const LS_findExistingChannelOrderIds = /* GraphQL */ `
  query LS_findExistingChannelOrderIds(
    $storeId: ID!
    $channelOrderIds: [String]!
  ) {
    LS_findExistingChannelOrderIds(
      storeId: $storeId
      channelOrderIds: $channelOrderIds
    )
  }
`;
export const LS_listProvisionOrders = /* GraphQL */ `
  query LS_listProvisionOrders($storeId: ID!, $start: String, $end: String) {
    LS_listProvisionOrders(storeId: $storeId, start: $start, end: $end)
  }
`;
export const LS_listPrintTargets = /* GraphQL */ `
  query LS_listPrintTargets(
    $storeId: ID!
    $batchId: ID
    $start: String
    $end: String
    $states: [String]
    $origins: [String]
    $csReasons: [String]
  ) {
    LS_listPrintTargets(
      storeId: $storeId
      batchId: $batchId
      start: $start
      end: $end
      states: $states
      origins: $origins
      csReasons: $csReasons
    )
  }
`;
export const LS_listDeliveryStageOrdersByTab = /* GraphQL */ `
  query LS_listDeliveryStageOrdersByTab($storeId: ID!, $tab: String) {
    LS_listDeliveryStageOrdersByTab(storeId: $storeId, tab: $tab)
  }
`;
export const LS_listPrintBatches = /* GraphQL */ `
  query LS_listPrintBatches(
    $storeId: ID!
    $limit: Int
    $start: String
    $end: String
    $shippingCompanyCodes: [String]
    $statuses: [String]
    $seq: String
    $employeeId: ID
  ) {
    LS_listPrintBatches(
      storeId: $storeId
      limit: $limit
      start: $start
      end: $end
      shippingCompanyCodes: $shippingCompanyCodes
      statuses: $statuses
      seq: $seq
      employeeId: $employeeId
    )
  }
`;
export const LS_checkDeliveryDelays = /* GraphQL */ `
  query LS_checkDeliveryDelays($storeId: ID!) {
    LS_checkDeliveryDelays(storeId: $storeId)
  }
`;
export const LS_trackShipment = /* GraphQL */ `
  query LS_trackShipment(
    $storeId: ID!
    $trackingNumber: String!
    $carrierCode: String
  ) {
    LS_trackShipment(
      storeId: $storeId
      trackingNumber: $trackingNumber
      carrierCode: $carrierCode
    )
  }
`;
export const LS_listDeliveryStageOrders = /* GraphQL */ `
  query LS_listDeliveryStageOrders($storeId: ID!) {
    LS_listDeliveryStageOrders(storeId: $storeId)
  }
`;
export const LS_listConfirmBatches = /* GraphQL */ `
  query LS_listConfirmBatches(
    $storeId: ID!
    $limit: Int
    $start: String
    $end: String
    $origins: [String]
    $employeeId: ID
  ) {
    LS_listConfirmBatches(
      storeId: $storeId
      limit: $limit
      start: $start
      end: $end
      origins: $origins
      employeeId: $employeeId
    )
  }
`;
export const LS_listItemLinks = /* GraphQL */ `
  query LS_listItemLinks(
    $storeId: ID!
    $skuId: ID
    $originId: ID
    $productName: String
    $limit: Int
    $origin: String
    $originProductCode: String
    $skuName: String
    $skuCode: String
    $isSet: Boolean
    $start: String
    $end: String
    $page: Int
    $size: Int
  ) {
    LS_listItemLinks(
      storeId: $storeId
      skuId: $skuId
      originId: $originId
      productName: $productName
      limit: $limit
      origin: $origin
      originProductCode: $originProductCode
      skuName: $skuName
      skuCode: $skuCode
      isSet: $isSet
      start: $start
      end: $end
      page: $page
      size: $size
    )
  }
`;
export const LS_getWorkOrderSheet = /* GraphQL */ `
  query LS_getWorkOrderSheet($storeId: ID!, $batchId: ID!, $employeeId: ID) {
    LS_getWorkOrderSheet(
      storeId: $storeId
      batchId: $batchId
      employeeId: $employeeId
    )
  }
`;
export const LS_listSwapCandidates = /* GraphQL */ `
  query LS_listSwapCandidates(
    $storeId: ID!
    $fromSku: ID!
    $start: String
    $end: String
    $limit: Int
  ) {
    LS_listSwapCandidates(
      storeId: $storeId
      fromSku: $fromSku
      start: $start
      end: $end
      limit: $limit
    )
  }
`;
export const LS_listCanceledWaybills = /* GraphQL */ `
  query LS_listCanceledWaybills(
    $storeId: ID!
    $start: String
    $end: String
    $page: Int
    $size: Int
  ) {
    LS_listCanceledWaybills(
      storeId: $storeId
      start: $start
      end: $end
      page: $page
      size: $size
    )
  }
`;
export const LS_listCsOrders = /* GraphQL */ `
  query LS_listCsOrders(
    $storeId: ID!
    $retailStates: [String]
    $csTypes: [String]
    $csStatus: String
    $provision: Boolean
    $mergeGroupId: ID
    $orderId: ID
    $merged: Boolean
    $start: String
    $end: String
    $page: Int
    $size: Int
  ) {
    LS_listCsOrders(
      storeId: $storeId
      retailStates: $retailStates
      csTypes: $csTypes
      csStatus: $csStatus
      provision: $provision
      mergeGroupId: $mergeGroupId
      orderId: $orderId
      merged: $merged
      start: $start
      end: $end
      page: $page
      size: $size
    )
  }
`;
export const LS_listReturnSettlements = /* GraphQL */ `
  query LS_listReturnSettlements(
    $storeId: ID!
    $arrival: String
    $fee: String
    $settled: Boolean
    $payType: String
    $start: String
    $end: String
    $page: Int
    $size: Int
  ) {
    LS_listReturnSettlements(
      storeId: $storeId
      arrival: $arrival
      fee: $fee
      settled: $settled
      payType: $payType
      start: $start
      end: $end
      page: $page
      size: $size
    )
  }
`;
export const LS_exportPendingRefundsExcel = /* GraphQL */ `
  query LS_exportPendingRefundsExcel(
    $storeId: ID!
    $start: String
    $end: String
  ) {
    LS_exportPendingRefundsExcel(storeId: $storeId, start: $start, end: $end)
  }
`;
export const LS_listSkuMergeRules = /* GraphQL */ `
  query LS_listSkuMergeRules(
    $storeId: ID!
    $field: String
    $keyword: String
    $status: String
    $page: Int
    $size: Int
  ) {
    LS_listSkuMergeRules(
      storeId: $storeId
      field: $field
      keyword: $keyword
      status: $status
      page: $page
      size: $size
    )
  }
`;
export const LS_exportItemLinksExcel = /* GraphQL */ `
  query LS_exportItemLinksExcel(
    $storeId: ID!
    $origin: String
    $originProductCode: String
    $productName: String
    $skuName: String
    $skuCode: String
    $isSet: Boolean
    $start: String
    $end: String
  ) {
    LS_exportItemLinksExcel(
      storeId: $storeId
      origin: $origin
      originProductCode: $originProductCode
      productName: $productName
      skuName: $skuName
      skuCode: $skuCode
      isSet: $isSet
      start: $start
      end: $end
    )
  }
`;
export const LS_listUnusedTrackings = /* GraphQL */ `
  query LS_listUnusedTrackings(
    $storeId: ID!
    $start: String
    $end: String
    $dateType: String
    $trackingNumber: String
    $number: String
    $minHours: Int
  ) {
    LS_listUnusedTrackings(
      storeId: $storeId
      start: $start
      end: $end
      dateType: $dateType
      trackingNumber: $trackingNumber
      number: $number
      minHours: $minHours
    )
  }
`;
export const LS_exportUnusedTrackingsExcel = /* GraphQL */ `
  query LS_exportUnusedTrackingsExcel(
    $storeId: ID!
    $start: String
    $end: String
    $trackingNumber: String
  ) {
    LS_exportUnusedTrackingsExcel(
      storeId: $storeId
      start: $start
      end: $end
      trackingNumber: $trackingNumber
    )
  }
`;
export const retrieveSmsAuthStatus = /* GraphQL */ `
  query RetrieveSmsAuthStatus($phone: String!) {
    retrieveSmsAuthStatus(phone: $phone)
  }
`;
export const getBillingCost = /* GraphQL */ `
  query GetBillingCost($storeId: ID!, $locationId: ID) {
    getBillingCost(storeId: $storeId, locationId: $locationId)
  }
`;
export const listCustomersByGroupId = /* GraphQL */ `
  query ListCustomersByGroupId(
    $id: ID!
    $filter: CustomerFilterInput
    $filterRefusal: Boolean
  ) {
    listCustomersByGroupId(
      id: $id
      filter: $filter
      filterRefusal: $filterRefusal
    )
  }
`;
export const getCampaignWithReport = /* GraphQL */ `
  query GetCampaignWithReport($id: ID!, $start: String, $end: String) {
    getCampaignWithReport(id: $id, start: $start, end: $end) {
      id
      enterpriseId
      storeId
      locationId
      type
      name
      trigger
      agency
      triggerTiming
      triggerCondition {
        type
        operation
        value
      }
      startDate
      endDate
      couponProvider
      couponId
      description
      recipientProvider
      recipientId
      campaignRecipientId
      recipient {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      campaignRecipientTagId
      campaignRecipientLocationIds
      recipientList
      recipientCount
      filter {
        type
        operation
        value
      }
      includes
      sendNow
      sendAfterDays
      sendAtTime
      reserveDate
      sentAt
      title
      message
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      imageType
      imageLink
      buttons {
        order
        type
        name
        linkMo
        linkPc
        target
      }
      params {
        key
        value
      }
      templateCode
      templateId
      method
      tracking
      trackingLink
      block
      ads
      duplicatable
      sender
      success
      failure
      pending
      cost
      status
      creditTransactionId
      results {
        items {
          id
          enterpriseId
          storeId
          locationId
          customerId
          campaignResultCustomerId
          customerProvider
          providerCustomerId
          linkId
          requestId
          title
          message
          phone
          msgStatus
          reservedAt
          campaignResultsId
          requestedAt
          resultCode
          resultCodeName
          templateId
          statusCode
          method
          sendType
          sender
          sentAt
          creditTransactionId
          messageType
          failureReason
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      report
      system
      messageType
      sendTarget
      brandMessageType
      listItems
      cards
      tail
      brandImages
      coupon
      recipientTag {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
    }
  }
`;
export const getLoyaltySummary = /* GraphQL */ `
  query GetLoyaltySummary($id: ID!) {
    getLoyaltySummary(id: $id)
  }
`;
export const getSalesSummary = /* GraphQL */ `
  query GetSalesSummary($id: ID!) {
    getSalesSummary(id: $id)
  }
`;
export const getLoyaltyReport = /* GraphQL */ `
  query GetLoyaltyReport(
    $id: ID!
    $locationId: ID
    $item: String!
    $start: String
    $end: String
  ) {
    getLoyaltyReport(
      id: $id
      locationId: $locationId
      item: $item
      start: $start
      end: $end
    )
  }
`;
export const getSalesReport = /* GraphQL */ `
  query GetSalesReport(
    $id: ID!
    $locationId: ID
    $locationIds: [ID]
    $brandId: ID
    $item: String!
    $start: String
    $end: String
    $basis: String
    $page: Int
    $totalPage: Int
    $filters: AWSJSON
    $version: String
  ) {
    getSalesReport(
      id: $id
      locationId: $locationId
      locationIds: $locationIds
      brandId: $brandId
      item: $item
      start: $start
      end: $end
      basis: $basis
      page: $page
      totalPage: $totalPage
      filters: $filters
      version: $version
    )
  }
`;
export const listCustomerGroupWithStats = /* GraphQL */ `
  query ListCustomerGroupWithStats(
    $id: ID!
    $locationId: ID
    $page: Int
    $maxPage: Int
  ) {
    listCustomerGroupWithStats(
      id: $id
      locationId: $locationId
      page: $page
      maxPage: $maxPage
    )
  }
`;
export const listCustomersWithStats = /* GraphQL */ `
  query ListCustomersWithStats($storeId: ID!) {
    listCustomersWithStats(storeId: $storeId)
  }
`;
export const getCustomerWithStats = /* GraphQL */ `
  query GetCustomerWithStats($customerId: ID!) {
    getCustomerWithStats(customerId: $customerId)
  }
`;
export const settleSales = /* GraphQL */ `
  query SettleSales($id: ID!, $start: String, $end: String) {
    settleSales(id: $id, start: $start, end: $end)
  }
`;
export const retrieveBizNumber = /* GraphQL */ `
  query RetrieveBizNumber($bizNumber: String!) {
    retrieveBizNumber(bizNumber: $bizNumber)
  }
`;
export const listOrderDelta = /* GraphQL */ `
  query ListOrderDelta(
    $lastSync: AWSTimestamp
    $locationId: ID
    $limit: Int
    $nextToken: String
  ) {
    listOrderDelta(
      lastSync: $lastSync
      locationId: $locationId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listStoreCustomerDelta = /* GraphQL */ `
  query ListStoreCustomerDelta(
    $lastSync: AWSTimestamp
    $storeId: ID
    $limit: Int
    $nextToken: String
  ) {
    listStoreCustomerDelta(
      lastSync: $lastSync
      storeId: $storeId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const generateItemTemplate = /* GraphQL */ `
  query GenerateItemTemplate(
    $storeId: ID!
    $stockManageable: Boolean
    $excelType: String
  ) {
    generateItemTemplate(
      storeId: $storeId
      stockManageable: $stockManageable
      excelType: $excelType
    ) {
      key
      bucket
      region
      level
      url
      xsmall
      small
    }
  }
`;
export const parseItemTemplate = /* GraphQL */ `
  query ParseItemTemplate(
    $storeId: ID
    $key: String
    $locationId: ID
    $resource: String
    $excelType: String
    $templateSessionId: String
  ) {
    parseItemTemplate(
      storeId: $storeId
      key: $key
      locationId: $locationId
      resource: $resource
      excelType: $excelType
      templateSessionId: $templateSessionId
    )
  }
`;
export const syncItemTemplate = /* GraphQL */ `
  query SyncItemTemplate(
    $storeId: ID
    $key: String
    $excelType: String
    $templateSessionId: String
  ) {
    syncItemTemplate(
      storeId: $storeId
      key: $key
      excelType: $excelType
      templateSessionId: $templateSessionId
    )
  }
`;
export const generateExcelTemplate = /* GraphQL */ `
  query GenerateExcelTemplate($storeId: ID!, $type: String!) {
    generateExcelTemplate(storeId: $storeId, type: $type)
  }
`;
export const parseExcelTemplate = /* GraphQL */ `
  query ParseExcelTemplate(
    $storeId: ID!
    $type: String!
    $key: String!
    $returnType: String
  ) {
    parseExcelTemplate(
      storeId: $storeId
      type: $type
      key: $key
      returnType: $returnType
    )
  }
`;
export const generateInventoryTemplate = /* GraphQL */ `
  query GenerateInventoryTemplate(
    $storeId: ID!
    $locationId: ID
    $reason: String
    $type: String
    $options: AWSJSON
  ) {
    generateInventoryTemplate(
      storeId: $storeId
      locationId: $locationId
      reason: $reason
      type: $type
      options: $options
    ) {
      key
      bucket
      region
      level
      url
      xsmall
      small
    }
  }
`;
export const parseInventoryTemplate = /* GraphQL */ `
  query ParseInventoryTemplate(
    $storeId: ID
    $key: ID
    $employeeId: ID
    $reason: String
    $type: String
    $options: AWSJSON
    $templateSessionId: String
  ) {
    parseInventoryTemplate(
      storeId: $storeId
      key: $key
      employeeId: $employeeId
      reason: $reason
      type: $type
      options: $options
      templateSessionId: $templateSessionId
    )
  }
`;
export const syncInventoryTemplate = /* GraphQL */ `
  query SyncInventoryTemplate(
    $storeId: ID
    $key: String
    $reason: String
    $type: String
    $templateSessionId: String
  ) {
    syncInventoryTemplate(
      storeId: $storeId
      key: $key
      reason: $reason
      type: $type
      templateSessionId: $templateSessionId
    )
  }
`;
export const applyInventoryTransferHistory = /* GraphQL */ `
  query ApplyInventoryTransferHistory(
    $history: InventoryTransferHistoryInput
    $origin: String
    $originId: ID
    $templateType: String
    $templateSessionId: String
  ) {
    applyInventoryTransferHistory(
      history: $history
      origin: $origin
      originId: $originId
      templateType: $templateType
      templateSessionId: $templateSessionId
    ) {
      id
      storeId
      status
      fromLocationId
      toLocationId
      employeeId
      items {
        productId
        skuId
        quantity
        receivedQuantity
        totalCost
        fromInventoryHistoryId
        toInventoryHistoryId
      }
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const cancelInventoryTransferHistory = /* GraphQL */ `
  query CancelInventoryTransferHistory(
    $history: InventoryTransferHistoryInput
    $origin: String
    $originId: ID
  ) {
    cancelInventoryTransferHistory(
      history: $history
      origin: $origin
      originId: $originId
    ) {
      id
      storeId
      status
      fromLocationId
      toLocationId
      employeeId
      items {
        productId
        skuId
        quantity
        receivedQuantity
        totalCost
        fromInventoryHistoryId
        toInventoryHistoryId
      }
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const applyInventoryRequestHistory = /* GraphQL */ `
  query ApplyInventoryRequestHistory(
    $history: InventoryRequestHistoryInput
    $origin: String
    $originId: ID
  ) {
    applyInventoryRequestHistory(
      history: $history
      origin: $origin
      originId: $originId
    ) {
      id
      storeId
      status
      fromLocationId
      toLocationId
      employeeId
      items {
        productId
        skuId
        quantity
        receivedQuantity
        totalCost
        fromInventoryHistoryId
        toInventoryHistoryId
      }
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const applyPurchaseOrder = /* GraphQL */ `
  query ApplyPurchaseOrder(
    $purchaseOrder: PurchaseOrderInput
    $adjustments: [InventoryAdjustmentInput]
    $origin: String
    $originId: ID
  ) {
    applyPurchaseOrder(
      purchaseOrder: $purchaseOrder
      adjustments: $adjustments
      origin: $origin
      originId: $originId
    ) {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const cancelPurchaseOrder = /* GraphQL */ `
  query CancelPurchaseOrder(
    $purchaseOrder: PurchaseOrderInput
    $origin: String
    $originId: ID
  ) {
    cancelPurchaseOrder(
      purchaseOrder: $purchaseOrder
      origin: $origin
      originId: $originId
    ) {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const applyInventoryAdjustments = /* GraphQL */ `
  query ApplyInventoryAdjustments(
    $adjustments: [InventoryAdjustmentInput]
    $origin: String
    $originId: ID
  ) {
    applyInventoryAdjustments(
      adjustments: $adjustments
      origin: $origin
      originId: $originId
    ) {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const applyInventoryCountHistory = /* GraphQL */ `
  query ApplyInventoryCountHistory(
    $history: InventoryCountHistoryInput
    $origin: String
    $originId: ID
  ) {
    applyInventoryCountHistory(
      history: $history
      origin: $origin
      originId: $originId
    ) {
      id
      storeId
      status
      locationId
      items {
        productId
        skuId
        prevQuantity
        currQuantity
        totalCost
        inventoryHistoryId
        createdAt
      }
      employeeId
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const cancelInventoryCountHistory = /* GraphQL */ `
  query CancelInventoryCountHistory(
    $history: InventoryCountHistoryInput
    $origin: String
    $originId: ID
  ) {
    cancelInventoryCountHistory(
      history: $history
      origin: $origin
      originId: $originId
    ) {
      id
      storeId
      status
      locationId
      items {
        productId
        skuId
        prevQuantity
        currQuantity
        totalCost
        inventoryHistoryId
        createdAt
      }
      employeeId
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const getStoreStats = /* GraphQL */ `
  query GetStoreStats($storeId: ID) {
    getStoreStats(storeId: $storeId)
  }
`;
export const generatePgCode = /* GraphQL */ `
  query GeneratePgCode(
    $amount: Int!
    $ident: ID
    $name: String
    $address1: String
    $address2: String
    $phone: String
    $email: String
    $itemName: String
    $returnUrl: String
  ) {
    generatePgCode(
      amount: $amount
      ident: $ident
      name: $name
      address1: $address1
      address2: $address2
      phone: $phone
      email: $email
      itemName: $itemName
      returnUrl: $returnUrl
    )
  }
`;
export const requestCashReceipt = /* GraphQL */ `
  query RequestCashReceipt(
    $ident: ID!
    $name: String
    $amount: Int
    $supplyAmount: Int
    $vat: Int
    $taxFreeAmount: Int
    $receiptType: CashReceiptType
    $receiptNumber: String
    $bizNumber: String
    $bizName: String
    $bizRep: String
    $bizPhone: String
  ) {
    requestCashReceipt(
      ident: $ident
      name: $name
      amount: $amount
      supplyAmount: $supplyAmount
      vat: $vat
      taxFreeAmount: $taxFreeAmount
      receiptType: $receiptType
      receiptNumber: $receiptNumber
      bizNumber: $bizNumber
      bizName: $bizName
      bizRep: $bizRep
      bizPhone: $bizPhone
    )
  }
`;
export const cancelCashReceipt = /* GraphQL */ `
  query CancelCashReceipt(
    $ident: ID!
    $transactionId: ID
    $amount: Int
    $supplyAmount: Int
    $vat: Int
    $taxFreeAmount: Int
  ) {
    cancelCashReceipt(
      ident: $ident
      transactionId: $transactionId
      amount: $amount
      supplyAmount: $supplyAmount
      vat: $vat
      taxFreeAmount: $taxFreeAmount
    )
  }
`;
export const cancelCardPay = /* GraphQL */ `
  query CancelCardPay($ident: ID!, $transactionId: ID, $amount: Int) {
    cancelCardPay(ident: $ident, transactionId: $transactionId, amount: $amount)
  }
`;
export const registerAccount = /* GraphQL */ `
  query RegisterAccount(
    $ident: ID!
    $name: String
    $businessNumber: String
    $bankCode: String
    $number: String
    $holder: String
  ) {
    registerAccount(
      ident: $ident
      name: $name
      businessNumber: $businessNumber
      bankCode: $bankCode
      number: $number
      holder: $holder
    )
  }
`;
export const updateAccount = /* GraphQL */ `
  query UpdateAccount(
    $ident: ID!
    $name: String
    $businessNumber: String
    $bankCode: String
    $number: String
    $holder: String
  ) {
    updateAccount(
      ident: $ident
      name: $name
      businessNumber: $businessNumber
      bankCode: $bankCode
      number: $number
      holder: $holder
    )
  }
`;
export const sendNotice = /* GraphQL */ `
  query SendNotice(
    $recipient: AWSJSON!
    $category: String
    $params: AWSJSON
    $storeId: ID
    $locationId: ID
  ) {
    sendNotice(
      recipient: $recipient
      category: $category
      params: $params
      storeId: $storeId
      locationId: $locationId
    )
  }
`;
export const addKakaoChannel = /* GraphQL */ `
  query AddKakaoChannel(
    $channelId: ID!
    $phone: String!
    $categoryCode: String!
  ) {
    addKakaoChannel(
      channelId: $channelId
      phone: $phone
      categoryCode: $categoryCode
    )
  }
`;
export const validateKakaoToken = /* GraphQL */ `
  query ValidateKakaoToken($channelId: ID!, $token: String!) {
    validateKakaoToken(channelId: $channelId, token: $token)
  }
`;
export const getKakaoCategories = /* GraphQL */ `
  query GetKakaoCategories {
    getKakaoCategories
  }
`;
export const getAlimtalkTemplates = /* GraphQL */ `
  query GetAlimtalkTemplates($channelId: ID) {
    getAlimtalkTemplates(channelId: $channelId)
  }
`;
export const getReviewCampaigns = /* GraphQL */ `
  query GetReviewCampaigns($storeId: ID) {
    getReviewCampaigns(storeId: $storeId)
  }
`;
export const getReviewCampaignResults = /* GraphQL */ `
  query GetReviewCampaignResults($storeId: ID, $start: String, $end: String) {
    getReviewCampaignResults(storeId: $storeId, start: $start, end: $end)
  }
`;
export const createUser = /* GraphQL */ `
  query CreateUser(
    $ident: ID
    $phone: String
    $firstName: String
    $lastName: String
    $storeName: String
    $resend: Boolean
  ) {
    createUser(
      ident: $ident
      phone: $phone
      firstName: $firstName
      lastName: $lastName
      storeName: $storeName
      resend: $resend
    )
  }
`;
export const updateUserAttributes = /* GraphQL */ `
  query UpdateUserAttributes($ident: ID, $phone: String, $name: String) {
    updateUserAttributes(ident: $ident, phone: $phone, name: $name)
  }
`;
export const deleteUser = /* GraphQL */ `
  query DeleteUser($ident: ID) {
    deleteUser(ident: $ident)
  }
`;
export const getPeriodReport = /* GraphQL */ `
  query GetPeriodReport(
    $storeId: ID!
    $locationId: ID
    $brandId: ID
    $item: String!
    $start: String
    $end: String
    $basis: String
    $origin: String
    $version: String
    $options: AWSJSON
  ) {
    getPeriodReport(
      storeId: $storeId
      locationId: $locationId
      brandId: $brandId
      item: $item
      start: $start
      end: $end
      basis: $basis
      origin: $origin
      version: $version
      options: $options
    )
  }
`;
export const getPeriodReportExport = /* GraphQL */ `
  query GetPeriodReportExport(
    $storeId: ID!
    $item: String!
    $section: String!
    $start: String!
    $end: String!
    $version: String
    $options: AWSJSON
  ) {
    getPeriodReportExport(
      storeId: $storeId
      item: $item
      section: $section
      start: $start
      end: $end
      version: $version
      options: $options
    )
  }
`;
export const generateReport = /* GraphQL */ `
  query GenerateReport(
    $storeId: ID!
    $item: String!
    $start: String
    $end: String
  ) {
    generateReport(storeId: $storeId, item: $item, start: $start, end: $end) {
      key
      bucket
      region
      level
      url
      xsmall
      small
    }
  }
`;
export const LS_getMembershipReport = /* GraphQL */ `
  query LS_getMembershipReport(
    $storeId: ID!
    $start: AWSDateTime!
    $end: AWSDateTime!
    $interval: String
  ) {
    LS_getMembershipReport(
      storeId: $storeId
      start: $start
      end: $end
      interval: $interval
    )
  }
`;
export const LS_getLocationCustomers = /* GraphQL */ `
  query LS_getLocationCustomers($storeId: ID, $locationId: ID) {
    LS_getLocationCustomers(storeId: $storeId, locationId: $locationId) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const LS_getStoreCustomer = /* GraphQL */ `
  query LS_getStoreCustomer($storeId: ID, $ident: ID) {
    LS_getStoreCustomer(storeId: $storeId, ident: $ident) {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const LS_getCustomerCount = /* GraphQL */ `
  query LS_getCustomerCount(
    $storeId: ID!
    $locationId: ID
    $status: String
    $locationIds: [ID]
    $version: String
    $filters: AWSJSON
    $includes: [ID]
  ) {
    LS_getCustomerCount(
      storeId: $storeId
      locationId: $locationId
      status: $status
      locationIds: $locationIds
      version: $version
      filters: $filters
      includes: $includes
    )
  }
`;
export const LS_getCustomerGroups = /* GraphQL */ `
  query LS_getCustomerGroups(
    $storeId: ID!
    $locationId: ID
    $page: Int
    $size: Int
    $group: CustomerGroupKey
  ) {
    LS_getCustomerGroups(
      storeId: $storeId
      locationId: $locationId
      page: $page
      size: $size
      group: $group
    )
  }
`;
export const LS_getCustomerCountsByStatus = /* GraphQL */ `
  query LS_getCustomerCountsByStatus($storeId: ID!, $locationId: ID) {
    LS_getCustomerCountsByStatus(storeId: $storeId, locationId: $locationId)
  }
`;
export const LS_getCustomerBlacklists = /* GraphQL */ `
  query LS_getCustomerBlacklists($storeId: ID!) {
    LS_getCustomerBlacklists(storeId: $storeId)
  }
`;
export const LS_getCustomerCherrypickers = /* GraphQL */ `
  query LS_getCustomerCherrypickers($storeId: ID!) {
    LS_getCustomerCherrypickers(storeId: $storeId)
  }
`;
export const LS_getCustomerTierHistories = /* GraphQL */ `
  query LS_getCustomerTierHistories($storeId: ID!, $filters: AWSJSON) {
    LS_getCustomerTierHistories(storeId: $storeId, filters: $filters)
  }
`;
export const LS_getCustomersWithCount = /* GraphQL */ `
  query LS_getCustomersWithCount(
    $storeId: ID!
    $page: Int
    $size: Int
    $extraSize: Int
    $sort: CustomerSortInput
    $filters: AWSJSON
    $search: String
    $locationId: ID
  ) {
    LS_getCustomersWithCount(
      storeId: $storeId
      page: $page
      size: $size
      extraSize: $extraSize
      sort: $sort
      filters: $filters
      search: $search
      locationId: $locationId
    )
  }
`;
export const LS_getCustomerList = /* GraphQL */ `
  query LS_getCustomerList(
    $storeId: ID!
    $page: Int
    $size: Int
    $extraSize: Int
    $sort: CustomerSortInput
    $filters: AWSJSON
    $search: String
    $locationId: ID
  ) {
    LS_getCustomerList(
      storeId: $storeId
      page: $page
      size: $size
      extraSize: $extraSize
      sort: $sort
      filters: $filters
      search: $search
      locationId: $locationId
    )
  }
`;
export const LS_getCustomerTagsWithCount = /* GraphQL */ `
  query LS_getCustomerTagsWithCount($storeId: ID!, $locationId: ID) {
    LS_getCustomerTagsWithCount(storeId: $storeId, locationId: $locationId)
  }
`;
export const LS_countCustomersByTag = /* GraphQL */ `
  query LS_countCustomersByTag(
    $tagId: ID!
    $start: AWSDateTime
    $end: AWSDateTime
  ) {
    LS_countCustomersByTag(tagId: $tagId, start: $start, end: $end)
  }
`;
export const LS_applyCustomerTag = /* GraphQL */ `
  query LS_applyCustomerTag($tag: AWSJSON!) {
    LS_applyCustomerTag(tag: $tag) {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const LS_requestTaxRefund = /* GraphQL */ `
  query LS_requestTaxRefund($index: Int, $amount: Int) {
    LS_requestTaxRefund(index: $index, amount: $amount)
  }
`;
export const LS_confirmTaxRefund = /* GraphQL */ `
  query LS_confirmTaxRefund($index: Int, $amount: Int) {
    LS_confirmTaxRefund(index: $index, amount: $amount)
  }
`;
export const LS_cancelTaxRefund = /* GraphQL */ `
  query LS_cancelTaxRefund($index: Int) {
    LS_cancelTaxRefund(index: $index)
  }
`;
export const LS_validateImage = /* GraphQL */ `
  query LS_validateImage(
    $key: String
    $method: String
    $level: String
    $options: AWSJSON
  ) {
    LS_validateImage(
      key: $key
      method: $method
      level: $level
      options: $options
    )
  }
`;
export const LS_getOrderCount = /* GraphQL */ `
  query LS_getOrderCount($storeId: ID!, $filters: AWSJSON) {
    LS_getOrderCount(storeId: $storeId, filters: $filters)
  }
`;
export const LS_getOrders = /* GraphQL */ `
  query LS_getOrders($storeId: ID!, $page: Int, $size: Int, $filters: AWSJSON) {
    LS_getOrders(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      count
    }
  }
`;
export const LS_getOrdersStats = /* GraphQL */ `
  query LS_getOrdersStats($storeId: ID!, $filters: AWSJSON) {
    LS_getOrdersStats(storeId: $storeId, filters: $filters)
  }
`;
export const LS_getVanTransactions = /* GraphQL */ `
  query LS_getVanTransactions(
    $terminalId: String!
    $start: AWSDateTime!
    $end: AWSDateTime!
  ) {
    LS_getVanTransactions(terminalId: $terminalId, start: $start, end: $end) {
      items {
        id
        msgType
        tranUniqueId
        terminalId
        cardNumber
        installMonths
        amount
        approvalNumber
        orgApprovalDate
        transType
        issuerCode
        issuerName
        acquirerCode
        acquirerName
        merchantId
        bizRegNumber
        cancelType
        approvedAt
      }
      count
    }
  }
`;
export const LS_sendReport = /* GraphQL */ `
  query LS_sendReport(
    $storeId: ID!
    $item: String!
    $filters: AWSJSON
    $recepient: String
    $version: String
    $options: AWSJSON
  ) {
    LS_sendReport(
      storeId: $storeId
      item: $item
      filters: $filters
      recepient: $recepient
      version: $version
      options: $options
    )
  }
`;
export const LS_getEmployeeByEmail = /* GraphQL */ `
  query LS_getEmployeeByEmail($email: String) {
    LS_getEmployeeByEmail(email: $email) {
      id
      role
      lastName
      firstName
      name
      nickname
      phone
      email
      employeeStoreId
      employeeEnterpriseId
      organizations {
        items {
          id
          role
          employeeId
          enterpriseId
          storeId
          pin
          status
          locationId
          employee {
            id
            role
            lastName
            firstName
            name
            nickname
            phone
            email
            employeeStoreId
            employeeEnterpriseId
            organizations {
              items {
                id
                role
                employeeId
                enterpriseId
                storeId
                pin
                status
                locationId
                permissions
                updatedAt
                createdAt
              }
              nextToken
            }
            survey
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          permissions
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        nextToken
      }
      survey
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const LS_getCampaignRefuseList = /* GraphQL */ `
  query LS_getCampaignRefuseList($phone: String) {
    LS_getCampaignRefuseList(phone: $phone)
  }
`;
export const LS_getMessageCampaigns = /* GraphQL */ `
  query LS_getMessageCampaigns(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getMessageCampaigns(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      count
    }
  }
`;
export const LS_getMessageCampaignReport = /* GraphQL */ `
  query LS_getMessageCampaignReport(
    $storeId: ID!
    $start: AWSDateTime
    $end: AWSDateTime
    $filters: AWSJSON
  ) {
    LS_getMessageCampaignReport(
      storeId: $storeId
      start: $start
      end: $end
      filters: $filters
    )
  }
`;
export const LS_getSuppliers = /* GraphQL */ `
  query LS_getSuppliers($storeId: ID!, $locationId: ID) {
    LS_getSuppliers(storeId: $storeId, locationId: $locationId) {
      items {
        id
        status
        storeId
        locationId
        public
        name
        phone
        fax
        email
        note
        address
        updatedAt
        createdAt
      }
    }
  }
`;
export const LS_getPurchaseOrders = /* GraphQL */ `
  query LS_getPurchaseOrders(
    $storeId: ID!
    $locationId: ID
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getPurchaseOrders(
      storeId: $storeId
      locationId: $locationId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        number
        supplierId
        supplyingLocationId
        status
        supplierOrigin
        inventories {
          id
          inventoryId
          productId
          skuId
          quantity
          receivedQuantity
          waitingQuantity
          cancelledQuantity
          cost
          note
        }
        storeId
        locationId
        createdByEmployeeId
        createdLocationId
        note
        extraFees {
          id
          type
          value
          name
        }
        excludeVat
        expectDate
        confirmedAt
        receivedAt
        updatedAt
        createdAt
      }
      count
    }
  }
`;
export const LS_getPurchaseOrder = /* GraphQL */ `
  query LS_getPurchaseOrder($purchaseOrderId: ID!) {
    LS_getPurchaseOrder(purchaseOrderId: $purchaseOrderId) {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const LS_getKakaoProfileCategories = /* GraphQL */ `
  query LS_getKakaoProfileCategories {
    LS_getKakaoProfileCategories {
      name
      code
    }
  }
`;
export const LS_getKakaoProfile = /* GraphQL */ `
  query LS_getKakaoProfile($storeId: ID!) {
    LS_getKakaoProfile(storeId: $storeId)
  }
`;
export const LS_getInventoryHistories = /* GraphQL */ `
  query LS_getInventoryHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $type: String
    $filters: AWSJSON
  ) {
    LS_getInventoryHistories(
      storeId: $storeId
      page: $page
      size: $size
      type: $type
      filters: $filters
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      count
    }
  }
`;
export const LS_getSkuInventoryHistories = /* GraphQL */ `
  query LS_getSkuInventoryHistories(
    $storeId: ID!
    $skuId: ID!
    $start: AWSDateTime!
    $end: AWSDateTime!
    $filters: AWSJSON
  ) {
    LS_getSkuInventoryHistories(
      storeId: $storeId
      skuId: $skuId
      start: $start
      end: $end
      filters: $filters
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      prevQuantity
    }
  }
`;
export const LS_getInventoryRequestHistory = /* GraphQL */ `
  query LS_getInventoryRequestHistory($historyId: ID!) {
    LS_getInventoryRequestHistory(historyId: $historyId) {
      id
      storeId
      type
      status
      number
      requestEmployeeId
      confirmEmployeeId
      shipEmployeeId
      completeEmployeeId
      requestedAt
      confirmedAt
      shippedAt
      completedAt
      items {
        productId
        skuId
        initQuantity
        quantity
        receivedQuantity
        totalCost
        fromInventoryHistoryId
        toInventoryHistoryId
      }
      fromLocationId
      toLocationId
      note
      trackingNumber
      shippingCompanyCode
      updatedAt
      createdAt
    }
  }
`;
export const LS_getInventoryRequestHistories = /* GraphQL */ `
  query LS_getInventoryRequestHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getInventoryRequestHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        type
        status
        number
        requestEmployeeId
        confirmEmployeeId
        shipEmployeeId
        completeEmployeeId
        requestedAt
        confirmedAt
        shippedAt
        completedAt
        items {
          productId
          skuId
          initQuantity
          quantity
          receivedQuantity
          totalCost
          fromInventoryHistoryId
          toInventoryHistoryId
        }
        fromLocationId
        toLocationId
        note
        trackingNumber
        shippingCompanyCode
        updatedAt
        createdAt
      }
      count
    }
  }
`;
export const LS_getInventoryTransferHistory = /* GraphQL */ `
  query LS_getInventoryTransferHistory($historyId: ID) {
    LS_getInventoryTransferHistory(historyId: $historyId) {
      id
      storeId
      status
      fromLocationId
      toLocationId
      employeeId
      items {
        productId
        skuId
        quantity
        receivedQuantity
        totalCost
        fromInventoryHistoryId
        toInventoryHistoryId
      }
      note
      totalCost
      createdAt
      updatedAt
    }
  }
`;
export const LS_getInventoryTransferHistories = /* GraphQL */ `
  query LS_getInventoryTransferHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getInventoryTransferHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        status
        fromLocationId
        toLocationId
        employeeId
        items {
          productId
          skuId
          quantity
          receivedQuantity
          totalCost
          fromInventoryHistoryId
          toInventoryHistoryId
        }
        note
        totalCost
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getInventoryCountHistories = /* GraphQL */ `
  query LS_getInventoryCountHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getInventoryCountHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        status
        locationId
        items {
          productId
          skuId
          prevQuantity
          currQuantity
          totalCost
          inventoryHistoryId
          createdAt
        }
        employeeId
        note
        totalCost
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getInventorySyncHistories = /* GraphQL */ `
  query LS_getInventorySyncHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getInventorySyncHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        locationId
        provider
        items {
          productId
          skuId
          prevQuantity
          currQuantity
          inventoryHistoryId
        }
        failItems {
          productId
          skuId
          prevQuantity
          currQuantity
          inventoryHistoryId
        }
        employeeId
        condition
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getEquipments = /* GraphQL */ `
  query LS_getEquipments(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getEquipments(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        name
        model
        note
        cost
        stockAlertQty
        inventories {
          locationId
          quantity
          unavailableQuantity
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getEquipmentHistories = /* GraphQL */ `
  query LS_getEquipmentHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getEquipmentHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        locationId
        equipmentId
        reason
        quantity
        cost
        totalCost
        delta
        unavailableDelta
        note
        employeeId
        groupId
        referLocationId
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getEquipmentTransferHistories = /* GraphQL */ `
  query LS_getEquipmentTransferHistories(
    $storeId: ID!
    $page: Int
    $size: Int
    $filters: AWSJSON
  ) {
    LS_getEquipmentTransferHistories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
    ) {
      items {
        id
        storeId
        status
        fromLocationId
        toLocationId
        employeeId
        items {
          equipmentId
          quantity
          receivedQuantity
          totalCost
        }
        note
        totalCost
        createdAt
        updatedAt
      }
      count
    }
  }
`;
export const LS_getLocationInventories = /* GraphQL */ `
  query LS_getLocationInventories($storeId: ID!, $productId: ID!, $skuId: ID!) {
    LS_getLocationInventories(
      storeId: $storeId
      productId: $productId
      skuId: $skuId
    ) {
      items {
        id
        quantity
        cost
        locationId
        unavailableQuantity
        inReadyQuantity
        outReadyQuantity
        expiryDate
        updatedAt
        createdAt
        locations {
          id
          quantity
        }
        attributes {
          name
          type
          value
        }
      }
    }
  }
`;
export const LS_getInventoryHistorySummary = /* GraphQL */ `
  query LS_getInventoryHistorySummary(
    $storeId: ID!
    $start: ID!
    $end: ID!
    $filters: AWSJSON
  ) {
    LS_getInventoryHistorySummary(
      storeId: $storeId
      start: $start
      end: $end
      filters: $filters
    )
  }
`;
export const LS_getProductsByIds = /* GraphQL */ `
  query LS_getProductsByIds($storeId: ID!, $productIds: [ID]) {
    LS_getProductsByIds(storeId: $storeId, productIds: $productIds) {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const LS_checkProductBarcodes = /* GraphQL */ `
  query LS_checkProductBarcodes(
    $storeId: ID!
    $barcodes: [String!]!
    $excludeProductId: ID
  ) {
    LS_checkProductBarcodes(
      storeId: $storeId
      barcodes: $barcodes
      excludeProductId: $excludeProductId
    )
  }
`;
export const LS_checkProductModels = /* GraphQL */ `
  query LS_checkProductModels(
    $storeId: ID!
    $models: [String!]!
    $excludeProductId: ID
  ) {
    LS_checkProductModels(
      storeId: $storeId
      models: $models
      excludeProductId: $excludeProductId
    )
  }
`;
export const LS_getProductList = /* GraphQL */ `
  query LS_getProductList(
    $storeId: ID!
    $page: Int!
    $size: Int!
    $filters: AWSJSON
    $locationId: ID
  ) {
    LS_getProductList(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
      locationId: $locationId
    )
  }
`;
export const LS_getProductInventories = /* GraphQL */ `
  query LS_getProductInventories(
    $storeId: ID!
    $page: Int!
    $size: Int!
    $filters: AWSJSON
    $locationId: ID
  ) {
    LS_getProductInventories(
      storeId: $storeId
      page: $page
      size: $size
      filters: $filters
      locationId: $locationId
    )
  }
`;
export const LS_getSkuInventoryReport = /* GraphQL */ `
  query LS_getSkuInventoryReport(
    $storeId: ID!
    $skuId: ID!
    $start: AWSDateTime!
    $end: AWSDateTime!
    $locationId: ID
  ) {
    LS_getSkuInventoryReport(
      storeId: $storeId
      skuId: $skuId
      start: $start
      end: $end
      locationId: $locationId
    )
  }
`;
export const LS_getSkuSalesReport = /* GraphQL */ `
  query LS_getSkuSalesReport($storeId: ID!, $skuIds: [ID]) {
    LS_getSkuSalesReport(storeId: $storeId, skuIds: $skuIds)
  }
`;
export const LS_getBarcodeCouponTransactions = /* GraphQL */ `
  query LS_getBarcodeCouponTransactions($couponId: ID!, $recepient: String) {
    LS_getBarcodeCouponTransactions(couponId: $couponId, recepient: $recepient)
  }
`;
export const LS_getCouponsWithStats = /* GraphQL */ `
  query LS_getCouponsWithStats($storeId: ID!, $filters: AWSJSON) {
    LS_getCouponsWithStats(storeId: $storeId, filters: $filters)
  }
`;
export const LS_getCouponTransactions = /* GraphQL */ `
  query LS_getCouponTransactions(
    $storeId: ID!
    $start: AWSDateTime!
    $end: AWSDateTime!
    $page: Int
    $size: Int
    $locationId: ID
    $couponId: ID
    $customerId: ID
  ) {
    LS_getCouponTransactions(
      storeId: $storeId
      start: $start
      end: $end
      page: $page
      size: $size
      locationId: $locationId
      couponId: $couponId
      customerId: $customerId
    )
  }
`;
export const LS_getCustomerEventReport = /* GraphQL */ `
  query LS_getCustomerEventReport(
    $eventId: ID!
    $start: AWSDateTime
    $end: AWSDateTime
  ) {
    LS_getCustomerEventReport(eventId: $eventId, start: $start, end: $end)
  }
`;
export const LS_getCustomerEventList = /* GraphQL */ `
  query LS_getCustomerEventList(
    $eventId: ID!
    $item: String!
    $page: Int
    $size: Int
    $start: AWSDateTime
    $end: AWSDateTime
  ) {
    LS_getCustomerEventList(
      eventId: $eventId
      item: $item
      page: $page
      size: $size
      start: $start
      end: $end
    )
  }
`;
export const echo = /* GraphQL */ `
  query Echo($message: String) {
    echo(message: $message)
  }
`;
export const getPointStatsByCustomerId = /* GraphQL */ `
  query GetPointStatsByCustomerId($id: ID!) {
    getPointStatsByCustomerId(id: $id)
  }
`;
export const decodeToken = /* GraphQL */ `
  query DecodeToken($token: String!) {
    decodeToken(token: $token)
  }
`;
export const generateAuthCode = /* GraphQL */ `
  query GenerateAuthCode($redirectUrl: String, $customize: String) {
    generateAuthCode(redirectUrl: $redirectUrl, customize: $customize)
  }
`;
export const decodeAuthData = /* GraphQL */ `
  query DecodeAuthData($data: String) {
    decodeAuthData(data: $data)
  }
`;
export const resetPassword = /* GraphQL */ `
  query ResetPassword($ident: ID, $password: String) {
    resetPassword(ident: $ident, password: $password)
  }
`;
export const LS_getCustomer = /* GraphQL */ `
  query LS_getCustomer($customerId: ID!) {
    LS_getCustomer(customerId: $customerId)
  }
`;
export const LS_getCustomers = /* GraphQL */ `
  query LS_getCustomers(
    $customerId: ID
    $storeId: ID
    $locationId: ID
    $status: String
    $withStore: Boolean
    $page: Int
    $size: Int
  ) {
    LS_getCustomers(
      customerId: $customerId
      storeId: $storeId
      locationId: $locationId
      status: $status
      withStore: $withStore
      page: $page
      size: $size
    )
  }
`;
export const getSalesOrder = /* GraphQL */ `
  query GetSalesOrder($id: ID!) {
    getSalesOrder(id: $id) {
      id
      name
      state
      method
      address1
      address2
      amount
      tax
      origin
      phone
      email
      itemName
      returnUrl
      payment
      items {
        item
        qty
      }
      orderId
      updatedAt
      createdAt
    }
  }
`;
export const listSalesOrders = /* GraphQL */ `
  query ListSalesOrders(
    $filter: ModelSalesOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        state
        method
        address1
        address2
        amount
        tax
        origin
        phone
        email
        itemName
        returnUrl
        payment
        items {
          item
          qty
        }
        orderId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocationSettlement = /* GraphQL */ `
  query GetLocationSettlement($locationId: ID!, $transactionDate: AWSDate!) {
    getLocationSettlement(
      locationId: $locationId
      transactionDate: $transactionDate
    ) {
      locationId
      transactionDate
      storeId
      status
      amount
      amountSettled
      transactionAmount
      fee
      carryOrverAmount
      items {
        category
        status
        amount
        amountSettled
        fee
        brokerageRate
        brokerageFee
        cardRate
        cardFee
        cardAmount
        transactions {
          orderId
          amount
          type
          ident
          name
          approvalDate
          approvalNumber
          createdAt
        }
        carryOrverAmount
        carries {
          transactionDate
          amount
        }
        request
        response
        result
        requestSettleDate
        estimateDate
        settledAt
      }
      tryCount
      estimateDate
      requestSettleDate
      settledAt
      updatedAt
      createdAt
    }
  }
`;
export const listLocationSettlements = /* GraphQL */ `
  query ListLocationSettlements(
    $locationId: ID
    $transactionDate: ModelStringKeyConditionInput
    $filter: ModelLocationSettlementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLocationSettlements(
      locationId: $locationId
      transactionDate: $transactionDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        locationId
        transactionDate
        storeId
        status
        amount
        amountSettled
        transactionAmount
        fee
        carryOrverAmount
        items {
          category
          status
          amount
          amountSettled
          fee
          brokerageRate
          brokerageFee
          cardRate
          cardFee
          cardAmount
          transactions {
            orderId
            amount
            type
            ident
            name
            approvalDate
            approvalNumber
            createdAt
          }
          carryOrverAmount
          carries {
            transactionDate
            amount
          }
          request
          response
          result
          requestSettleDate
          estimateDate
          settledAt
        }
        tryCount
        estimateDate
        requestSettleDate
        settledAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getSettlement = /* GraphQL */ `
  query GetSettlement($storeId: ID!, $transactedAt: String!) {
    getSettlement(storeId: $storeId, transactedAt: $transactedAt) {
      storeId
      transactedAt
      status
      enterpriseId
      locationId
      amount
      amountSettled
      estimateDate
      settledAt
      transactionAmount
      tryCount
      requestSettleDate
      request
      response
      result
      brokerageFee
      cardBrokerageFee
      cardBrokerageRate
      carryOrverAmount
      creditAmount
      creditBrokerageRate
      creditBrokerageFee
      billingStatus
      amountBilled
      billedAt
      billingHistoryId
      updatedAt
      createdAt
    }
  }
`;
export const listSettlements = /* GraphQL */ `
  query ListSettlements(
    $storeId: ID
    $transactedAt: ModelStringKeyConditionInput
    $filter: ModelSettlementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSettlements(
      storeId: $storeId
      transactedAt: $transactedAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        transactedAt
        status
        enterpriseId
        locationId
        amount
        amountSettled
        estimateDate
        settledAt
        transactionAmount
        tryCount
        requestSettleDate
        request
        response
        result
        brokerageFee
        cardBrokerageFee
        cardBrokerageRate
        carryOrverAmount
        creditAmount
        creditBrokerageRate
        creditBrokerageFee
        billingStatus
        amountBilled
        billedAt
        billingHistoryId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getRequestHistory = /* GraphQL */ `
  query GetRequestHistory($id: ID!) {
    getRequestHistory(id: $id) {
      id
      headers
      ident
      audience
      path
      method
      body
      params
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listRequestHistorys = /* GraphQL */ `
  query ListRequestHistorys(
    $filter: ModelRequestHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequestHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        headers
        ident
        audience
        path
        method
        body
        params
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getWebhookHistory = /* GraphQL */ `
  query GetWebhookHistory($id: ID!) {
    getWebhookHistory(id: $id) {
      id
      storeId
      event
      url
      payload
      referId
      responseCode
      retryCount
      errorMessage
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listWebhookHistorys = /* GraphQL */ `
  query ListWebhookHistorys(
    $filter: ModelWebhookHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebhookHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        event
        url
        payload
        referId
        responseCode
        retryCount
        errorMessage
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getOrderHistory = /* GraphQL */ `
  query GetOrderHistory($storeId: ID!, $createdAt: AWSDateTime!) {
    getOrderHistory(storeId: $storeId, createdAt: $createdAt) {
      storeId
      createdAt
      enterpriseId
      locationId
      type
      amount
      parentId
      currency
      orderHistoryOrderId
      customerStatus
      gender
      birth
      customerId
      updatedAt
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const listOrderHistorys = /* GraphQL */ `
  query ListOrderHistorys(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrderHistorys(
      storeId: $storeId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        createdAt
        enterpriseId
        locationId
        type
        amount
        parentId
        currency
        orderHistoryOrderId
        customerStatus
        gender
        birth
        customerId
        updatedAt
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const getCustomerCart = /* GraphQL */ `
  query GetCustomerCart($id: ID!) {
    getCustomerCart(id: $id) {
      id
      number
      storeId
      orderLocationId
      orderCustomerId
      state
      amount
      taxFreeAmount
      supplyAmount
      tax
      currency
      quantity
      diningOption
      diningState
      address {
        id
        main
        detail
        storeId
      }
      address1
      address2
      reserveDate
      salesDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdAt
      updatedAt
      request
      visitorCount
      pointSaved
    }
  }
`;
export const listCustomerCarts = /* GraphQL */ `
  query ListCustomerCarts(
    $filter: ModelCustomerCartFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        number
        storeId
        orderLocationId
        orderCustomerId
        state
        amount
        taxFreeAmount
        supplyAmount
        tax
        currency
        quantity
        diningOption
        diningState
        address {
          id
          main
          detail
          storeId
        }
        address1
        address2
        reserveDate
        salesDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdAt
        updatedAt
        request
        visitorCount
        pointSaved
      }
      nextToken
    }
  }
`;
export const getLink = /* GraphQL */ `
  query GetLink($id: ID!) {
    getLink(id: $id) {
      id
      type
      originUrl
      redirectUrl
      parentId
      sourceId
      openedAt
      updatedAt
      createdAt
    }
  }
`;
export const listLinks = /* GraphQL */ `
  query ListLinks(
    $filter: ModelLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        originUrl
        redirectUrl
        parentId
        sourceId
        openedAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCustomerGroup = /* GraphQL */ `
  query GetCustomerGroup($id: ID!) {
    getCustomerGroup(id: $id) {
      id
      name
      type
      storeGroupsId
      locationGroupsId
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      count
      createdAt
      updatedAt
    }
  }
`;
export const listCustomerGroups = /* GraphQL */ `
  query ListCustomerGroups(
    $filter: ModelCustomerGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReportHistory = /* GraphQL */ `
  query GetReportHistory($id: ID!) {
    getReportHistory(id: $id) {
      id
      storeId
      type
      start
      end
      results {
        id
        phone
        resultCode
        resultCodeName
      }
      requestId
      title
      message
      error
      requestedAt
      templateId
      status
      sentAt
      updatedAt
      createdAt
    }
  }
`;
export const listReportHistorys = /* GraphQL */ `
  query ListReportHistorys(
    $filter: ModelReportHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        type
        start
        end
        results {
          id
          phone
          resultCode
          resultCodeName
        }
        requestId
        title
        message
        error
        requestedAt
        templateId
        status
        sentAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getBugReport = /* GraphQL */ `
  query GetBugReport($id: ID!) {
    getBugReport(id: $id) {
      id
      storeId
      employeeId
      locationId
      category
      name
      meta
      logs
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listBugReports = /* GraphQL */ `
  query ListBugReports(
    $filter: ModelBugReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBugReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        employeeId
        locationId
        category
        name
        meta
        logs
        device {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getEventHistory = /* GraphQL */ `
  query GetEventHistory($id: ID!) {
    getEventHistory(id: $id) {
      id
      storeId
      employeeId
      locationId
      category
      device {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listEventHistorys = /* GraphQL */ `
  query ListEventHistorys(
    $filter: ModelEventHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        employeeId
        locationId
        category
        device {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getCouponDelta = /* GraphQL */ `
  query GetCouponDelta($id: ID!) {
    getCouponDelta(id: $id) {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listCouponDeltas = /* GraphQL */ `
  query ListCouponDeltas(
    $filter: ModelCouponDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponDeltas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        enterpriseId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        name
        description
        availableOrigins
        code
        type
        method
        tranCount
        generateCount
        publishCount
        limitPublishCount
        duplicatePublish
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionItemsOperator
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        referId
        validDateType
        validValue
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        notice
        pointSavable
        startedAt
        endedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getCampaignResult = /* GraphQL */ `
  query GetCampaignResult($id: ID!) {
    getCampaignResult(id: $id) {
      id
      enterpriseId
      storeId
      locationId
      customerId
      campaignResultCustomerId
      customerProvider
      providerCustomerId
      linkId
      requestId
      title
      message
      phone
      msgStatus
      reservedAt
      campaignResultsId
      requestedAt
      resultCode
      resultCodeName
      templateId
      statusCode
      method
      sendType
      sender
      sentAt
      creditTransactionId
      messageType
      failureReason
      updatedAt
      createdAt
    }
  }
`;
export const listCampaignResults = /* GraphQL */ `
  query ListCampaignResults(
    $filter: ModelCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignResults(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        campaignResultCustomerId
        customerProvider
        providerCustomerId
        linkId
        requestId
        title
        message
        phone
        msgStatus
        reservedAt
        campaignResultsId
        requestedAt
        resultCode
        resultCodeName
        templateId
        statusCode
        method
        sendType
        sender
        sentAt
        creditTransactionId
        messageType
        failureReason
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCampaignTemplate = /* GraphQL */ `
  query GetCampaignTemplate($id: ID!) {
    getCampaignTemplate(id: $id) {
      id
      storeId
      locationId
      ads
      name
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const listCampaignTemplates = /* GraphQL */ `
  query ListCampaignTemplates(
    $filter: ModelCampaignTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        ads
        name
        title
        message
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      enterpriseId
      storeId
      locationId
      type
      name
      trigger
      agency
      triggerTiming
      triggerCondition {
        type
        operation
        value
      }
      startDate
      endDate
      couponProvider
      couponId
      description
      recipientProvider
      recipientId
      campaignRecipientId
      recipient {
        id
        name
        type
        storeGroupsId
        locationGroupsId
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        count
        createdAt
        updatedAt
      }
      campaignRecipientTagId
      campaignRecipientLocationIds
      recipientList
      recipientCount
      filter {
        type
        operation
        value
      }
      includes
      sendNow
      sendAfterDays
      sendAtTime
      reserveDate
      sentAt
      title
      message
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      imageType
      imageLink
      buttons {
        order
        type
        name
        linkMo
        linkPc
        target
      }
      params {
        key
        value
      }
      templateCode
      templateId
      method
      tracking
      trackingLink
      block
      ads
      duplicatable
      sender
      success
      failure
      pending
      cost
      status
      creditTransactionId
      results {
        items {
          id
          enterpriseId
          storeId
          locationId
          customerId
          campaignResultCustomerId
          customerProvider
          providerCustomerId
          linkId
          requestId
          title
          message
          phone
          msgStatus
          reservedAt
          campaignResultsId
          requestedAt
          resultCode
          resultCodeName
          templateId
          statusCode
          method
          sendType
          sender
          sentAt
          creditTransactionId
          messageType
          failureReason
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      report
      system
      messageType
      sendTarget
      brandMessageType
      listItems
      cards
      tail
      brandImages
      coupon
      recipientTag {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getInventoryAdjustmentTask = /* GraphQL */ `
  query GetInventoryAdjustmentTask($id: ID!) {
    getInventoryAdjustmentTask(id: $id) {
      id
      type
      storeId
      locationId
      productId
      reason
      setId
      skuId
      quantity
      employeeId
      cost
      expiryDate
      note
      origin
      readyQuantity
      unavailableQuantity
      adjustedAt
      groupId
      referId
      syncHistoryId
      purchaseOrderId
      transferHistoryId
      countHistoryId
      historyId
      eventId
      index
      count
      doneAt
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listInventoryAdjustmentTasks = /* GraphQL */ `
  query ListInventoryAdjustmentTasks(
    $filter: ModelInventoryAdjustmentTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryAdjustmentTasks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        storeId
        locationId
        productId
        reason
        setId
        skuId
        quantity
        employeeId
        cost
        expiryDate
        note
        origin
        readyQuantity
        unavailableQuantity
        adjustedAt
        groupId
        referId
        syncHistoryId
        purchaseOrderId
        transferHistoryId
        countHistoryId
        historyId
        eventId
        index
        count
        doneAt
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getInventoryHistory = /* GraphQL */ `
  query GetInventoryHistory($id: ID!, $createdAt: AWSDateTime!) {
    getInventoryHistory(id: $id, createdAt: $createdAt) {
      id
      createdAt
      enterpriseId
      storeId
      productId
      skuId
      locationId
      employeeId
      inventoryId
      referId
      referOrderOrigin
      origin
      groupId
      groupHistoryCount
      purchaseOrderId
      totalCost
      cost
      expiryDate
      note
      reason
      transactions {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      quantity
      prevQuantity
      currQuantity
      readyQuantity
      updatedAt
    }
  }
`;
export const listInventoryHistorys = /* GraphQL */ `
  query ListInventoryHistorys(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelInventoryHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInventoryHistorys(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInventoryQuantity = /* GraphQL */ `
  query GetInventoryQuantity($id: ID!) {
    getInventoryQuantity(id: $id) {
      id
      inventoryId
      storeId
      locationId
      productId
      skuId
      quantity
      lastTransaction {
        parentId
        reason
        quantity
        prevQuantity
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const listInventoryQuantitys = /* GraphQL */ `
  query ListInventoryQuantitys(
    $filter: ModelInventoryQuantityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryQuantitys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        inventoryId
        storeId
        locationId
        productId
        skuId
        quantity
        lastTransaction {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getInventory = /* GraphQL */ `
  query GetInventory($id: ID!) {
    getInventory(id: $id) {
      id
      storeId
      productId
      skuId
      expiryDate
      attributes {
        name
        type
        value
      }
      updatedAt
      createdAt
    }
  }
`;
export const listInventorys = /* GraphQL */ `
  query ListInventorys(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        productId
        skuId
        expiryDate
        attributes {
          name
          type
          value
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getStoreProducts = /* GraphQL */ `
  query GetStoreProducts($id: ID!) {
    getStoreProducts(id: $id) {
      id
      categories {
        items {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      modifiers {
        items {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
      updatedAt
      createdAt
      products {
        items {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        nextToken
      }
    }
  }
`;
export const listStoreProductss = /* GraphQL */ `
  query ListStoreProductss(
    $filter: ModelStoreProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreProductss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        categories {
          items {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          nextToken
        }
        modifiers {
          items {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        products {
          items {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      type
      id
      code
      enterpriseId
      storeId
      name
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      depth
      parentCategoryId
      active
      refer
      referId
      sortKey
      subCategoryProductDisplay
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const listCategorys = /* GraphQL */ `
  query ListCategorys(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getClassification = /* GraphQL */ `
  query GetClassification($id: ID!) {
    getClassification(id: $id) {
      type
      id
      enterpriseId
      storeId
      name
      depth
      parentId
      refer
      referId
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      updatedAt
      createdAt
    }
  }
`;
export const listClassifications = /* GraphQL */ `
  query ListClassifications(
    $filter: ModelClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClassifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        id
        enterpriseId
        storeId
        name
        depth
        parentId
        refer
        referId
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getModifier = /* GraphQL */ `
  query GetModifier($id: ID!) {
    getModifier(id: $id) {
      id
      type
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      origin
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      products {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const listModifiers = /* GraphQL */ `
  query ListModifiers(
    $filter: ModelModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModifiers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($id: ID!) {
    getProductCategory(id: $id) {
      id
      enterpriseId
      storeId
      productId
      categoryId
      position
      category {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const listProductCategorys = /* GraphQL */ `
  query ListProductCategorys(
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        categoryId
        position
        category {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getProductClassification = /* GraphQL */ `
  query GetProductClassification($id: ID!) {
    getProductClassification(id: $id) {
      id
      enterpriseId
      storeId
      productId
      classificationId
      classification {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const listProductClassifications = /* GraphQL */ `
  query ListProductClassifications(
    $filter: ModelProductClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductClassifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        classificationId
        classification {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getProductModifier = /* GraphQL */ `
  query GetProductModifier($id: ID!) {
    getProductModifier(id: $id) {
      id
      enterpriseId
      storeId
      productId
      modifierId
      position
      modifier {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const listProductModifiers = /* GraphQL */ `
  query ListProductModifiers(
    $filter: ModelProductModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductModifiers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        modifierId
        position
        modifier {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getSalesHistory = /* GraphQL */ `
  query GetSalesHistory($storeId: ID!, $startedAt: AWSDateTime!) {
    getSalesHistory(storeId: $storeId, startedAt: $startedAt) {
      storeId
      startedAt
      enterpriseId
      locationId
      endedAt
      reserves
      actualBalance
      currency
      note
      estimateBalance
      cashes {
        name
        value
        count
      }
      reservesHistories {
        type
        amount
        note
        createdEmployeeId
        createdAt
      }
      detail {
        totalSales
        totalRefund
        totalTax
        totalDiscount
        supplyAmount
        totalSalesCount
        cash {
          sales
          refund
        }
        card {
          sales
          refund
        }
        credit {
          sales
          refund
        }
        barcode {
          sales
          refund
        }
        extra {
          sales
          refund
        }
        refund {
          sales
          refund
        }
        products {
          id
          name
          quantity
          amount
        }
        origins {
          pos
          kiosk
          menuorder
          delivery
          market
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const listSalesHistorys = /* GraphQL */ `
  query ListSalesHistorys(
    $storeId: ID
    $startedAt: ModelStringKeyConditionInput
    $filter: ModelSalesHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSalesHistorys(
      storeId: $storeId
      startedAt: $startedAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        startedAt
        enterpriseId
        locationId
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        cashes {
          name
          value
          count
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getGlobalDelta = /* GraphQL */ `
  query GetGlobalDelta($id: ID!, $type: String!) {
    getGlobalDelta(id: $id, type: $type) {
      id
      type
      storeId
      locationId
      data
      updatedAt
      createdAt
      timestamp
      expdate
    }
  }
`;
export const listGlobalDeltas = /* GraphQL */ `
  query ListGlobalDeltas(
    $id: ID
    $type: ModelStringKeyConditionInput
    $filter: ModelGlobalDeltaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGlobalDeltas(
      id: $id
      type: $type
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        storeId
        locationId
        data
        updatedAt
        createdAt
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getBillHistory = /* GraphQL */ `
  query GetBillHistory($id: ID!) {
    getBillHistory(id: $id) {
      id
      date
      storeId
      locationId
      name
      type
      status
      failReason
      discounts {
        name
        amount
        transactionId
      }
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        type
        name
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const listBillHistorys = /* GraphQL */ `
  query ListBillHistorys(
    $filter: ModelBillHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        date
        storeId
        locationId
        name
        type
        status
        failReason
        discounts {
          name
          amount
          transactionId
        }
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          type
          name
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getBillingHistory = /* GraphQL */ `
  query GetBillingHistory($storeId: ID!, $date: String!) {
    getBillingHistory(storeId: $storeId, date: $date) {
      id
      date
      enterpriseId
      storeId
      locationId
      name
      type
      status
      failReason
      amount
      currency
      paidAt
      refundedAt
      transaction {
        cardName
        cardNumber
        cardQuota
        pg
        transactionId
        amount
        currency
        method
        purchasedAt
        requestedAt
        revokedAt
        status
        statusEn
        statusKo
        receiptId
        receiptUrl
      }
      items {
        locationId
        name
        type
        amount
        details {
          type
          name
          amount
          basePrice
          unitPrice
          usage
          rate
          referId
          period
        }
        category
        quantity
        currency
      }
      note
      updatedAt
      createdAt
    }
  }
`;
export const listBillingHistorys = /* GraphQL */ `
  query ListBillingHistorys(
    $storeId: ID
    $date: ModelStringKeyConditionInput
    $filter: ModelBillingHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBillingHistorys(
      storeId: $storeId
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        enterpriseId
        storeId
        locationId
        name
        type
        status
        failReason
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          locationId
          name
          type
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
          category
          quantity
          currency
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLabelTemplate = /* GraphQL */ `
  query GetLabelTemplate($id: ID!) {
    getLabelTemplate(id: $id) {
      id
      storeId
      locationId
      name
      components {
        type
        format
        height
        fontSize
        maxLines
        align
        bold
        strikeThrough
        showText
        x
        y
        w
        h
        discountRule
      }
      pageLayout {
        horizontalCount
        width
        height
        marginRight
        marginTop
        marginLeft
        marginBottom
        templateWidth
        templateHeight
      }
      updatedAt
      createdAt
    }
  }
`;
export const listLabelTemplates = /* GraphQL */ `
  query ListLabelTemplates(
    $filter: ModelLabelTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLabelTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        locationId
        name
        components {
          type
          format
          height
          fontSize
          maxLines
          align
          bold
          strikeThrough
          showText
          x
          y
          w
          h
          discountRule
        }
        pageLayout {
          horizontalCount
          width
          height
          marginRight
          marginTop
          marginLeft
          marginBottom
          templateWidth
          templateHeight
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($locationId: ID!, $createdAt: AWSDateTime!) {
    getMessage(locationId: $locationId, createdAt: $createdAt) {
      id
      enterpriseId
      storeId
      locationId
      priority
      read
      type
      title
      body
      action {
        category
        method
        args
      }
      updatedAt
      createdAt
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMessages(
      locationId: $locationId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        priority
        read
        type
        title
        body
        action {
          category
          method
          args
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCafe24Auth = /* GraphQL */ `
  query GetCafe24Auth($id: ID!) {
    getCafe24Auth(id: $id) {
      id
      storeId
      accessToken
      accessTokenExpiredAt
      refreshToken
      refreshToeknExpiredAt
      clientId
      userId
      scopes
      issuedAt
      shopNumber
      token1
      token2
      token3
      trialExpiredAt
      session {
        status
        cookies
        capturedAt
        lastVerifiedAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const listCafe24Auths = /* GraphQL */ `
  query ListCafe24Auths(
    $filter: ModelCafe24AuthFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCafe24Auths(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        accessToken
        accessTokenExpiredAt
        refreshToken
        refreshToeknExpiredAt
        clientId
        userId
        scopes
        issuedAt
        shopNumber
        token1
        token2
        token3
        trialExpiredAt
        session {
          status
          cookies
          capturedAt
          lastVerifiedAt
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCafe24Event = /* GraphQL */ `
  query GetCafe24Event($id: ID!) {
    getCafe24Event(id: $id) {
      id
      number
      resource
      updatedAt
      createdAt
    }
  }
`;
export const listCafe24Events = /* GraphQL */ `
  query ListCafe24Events(
    $filter: ModelCafe24EventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCafe24Events(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        number
        resource
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getProviderWebhookEvent = /* GraphQL */ `
  query GetProviderWebhookEvent($id: ID!) {
    getProviderWebhookEvent(id: $id) {
      id
      provider
      providerId
      type
      resource
      isSkip
      duration
      completedAt
      groupId
      updatedAt
      createdAt
      expdate
    }
  }
`;
export const listProviderWebhookEvents = /* GraphQL */ `
  query ListProviderWebhookEvents(
    $filter: ModelProviderWebhookEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProviderWebhookEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        provider
        providerId
        type
        resource
        isSkip
        duration
        completedAt
        groupId
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const getItemLinkHistory = /* GraphQL */ `
  query GetItemLinkHistory($id: ID!) {
    getItemLinkHistory(id: $id) {
      id
      storeId
      type
      subType
      provider
      linkQuantity
      syncQuantity
      unlinkQuantity
      totalLinkQuantity
      employeeId
      condition
      updatedAt
      createdAt
    }
  }
`;
export const listItemLinkHistorys = /* GraphQL */ `
  query ListItemLinkHistorys(
    $filter: ModelItemLinkHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemLinkHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        type
        subType
        provider
        linkQuantity
        syncQuantity
        unlinkQuantity
        totalLinkQuantity
        employeeId
        condition
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCustomerTierUpdateHistory = /* GraphQL */ `
  query GetCustomerTierUpdateHistory($id: ID!) {
    getCustomerTierUpdateHistory(id: $id) {
      id
      storeId
      type
      date
      totalCount
      upCount
      downCount
      coupons {
        couponId
        count
        type
        scope
        name
      }
      updatedAt
      createdAt
    }
  }
`;
export const listCustomerTierUpdateHistorys = /* GraphQL */ `
  query ListCustomerTierUpdateHistorys(
    $filter: ModelCustomerTierUpdateHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTierUpdateHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        type
        date
        totalCount
        upCount
        downCount
        coupons {
          couponId
          count
          type
          scope
          name
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getStoreCafe24Config = /* GraphQL */ `
  query GetStoreCafe24Config($id: ID!) {
    getStoreCafe24Config(id: $id) {
      id
      usableCouponIds
      autoTier {
        active
        tiers {
          tierId
          name
          coupons {
            id
            type
            issueScope
            name
            discountMethod
            discountValue
            conditionMinAmount
            usablePos
          }
          minAmount
          maxAmount
        }
        interval
        intervalValue
        orderPeriod
        exceptionTierIds
        calculateType
        launchDate
        promotionIntervalValue
        promotionLaunchDate
        couponIntervalValue
      }
      admins {
        name
        phone
        email
      }
      inventory {
        includeLocationIds
        excludeLocationIds
        design {
          pointColor
        }
        scope
        includeProductCode
        excludeProductCode
        searchType
        quantityType
        quantityPoint
        locationInfos {
          locationId
          name
          mapUrl
          phone
          address
          businessHours
          items
        }
        includeInventories {
          skuId
          model
        }
        excludeInventories {
          skuId
          model
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const listStoreCafe24Configs = /* GraphQL */ `
  query ListStoreCafe24Configs(
    $filter: ModelStoreCafe24ConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCafe24Configs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usableCouponIds
        autoTier {
          active
          tiers {
            tierId
            name
            coupons {
              id
              type
              issueScope
              name
              discountMethod
              discountValue
              conditionMinAmount
              usablePos
            }
            minAmount
            maxAmount
          }
          interval
          intervalValue
          orderPeriod
          exceptionTierIds
          calculateType
          launchDate
          promotionIntervalValue
          promotionLaunchDate
          couponIntervalValue
        }
        admins {
          name
          phone
          email
        }
        inventory {
          includeLocationIds
          excludeLocationIds
          design {
            pointColor
          }
          scope
          includeProductCode
          excludeProductCode
          searchType
          quantityType
          quantityPoint
          locationInfos {
            locationId
            name
            mapUrl
            phone
            address
            businessHours
            items
          }
          includeInventories {
            skuId
            model
          }
          excludeInventories {
            skuId
            model
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      role
      lastName
      firstName
      name
      nickname
      phone
      email
      employeeStoreId
      employeeEnterpriseId
      organizations {
        items {
          id
          role
          employeeId
          enterpriseId
          storeId
          pin
          status
          locationId
          employee {
            id
            role
            lastName
            firstName
            name
            nickname
            phone
            email
            employeeStoreId
            employeeEnterpriseId
            organizations {
              items {
                id
                role
                employeeId
                enterpriseId
                storeId
                pin
                status
                locationId
                permissions
                updatedAt
                createdAt
              }
              nextToken
            }
            survey
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          permissions
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        nextToken
      }
      survey
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      role
      employeeId
      enterpriseId
      storeId
      pin
      status
      locationId
      employee {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      permissions
      updatedAt
      createdAt
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        employeeId
        enterpriseId
        storeId
        pin
        status
        locationId
        employee {
          id
          role
          lastName
          firstName
          name
          nickname
          phone
          email
          employeeStoreId
          employeeEnterpriseId
          organizations {
            items {
              id
              role
              employeeId
              enterpriseId
              storeId
              pin
              status
              locationId
              employee {
                id
                role
                lastName
                firstName
                name
                nickname
                phone
                email
                employeeStoreId
                employeeEnterpriseId
                survey
                updatedAt
                createdAt
              }
              permissions
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            nextToken
          }
          survey
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        permissions
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getRentalContract = /* GraphQL */ `
  query GetRentalContract($id: ID!) {
    getRentalContract(id: $id) {
      id
      type
      storeId
      locationId
      businessOperatorId
      months
      quantity
      amount
      startDate
      endDate
      extraFees {
        name
        amount
        billedAt
        createdAt
      }
      updatedAt
      createdAt
      businessOperator {
        id
        businessNumber
        name
        createdAt
        updatedAt
      }
    }
  }
`;
export const listRentalContracts = /* GraphQL */ `
  query ListRentalContracts(
    $filter: ModelRentalContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentalContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        storeId
        locationId
        businessOperatorId
        months
        quantity
        amount
        startDate
        endDate
        extraFees {
          name
          amount
          billedAt
          createdAt
        }
        updatedAt
        createdAt
        businessOperator {
          id
          businessNumber
          name
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getPointTransaction = /* GraphQL */ `
  query GetPointTransaction($id: ID!) {
    getPointTransaction(id: $id) {
      id
      locationId
      storeId
      type
      name
      method
      amount
      origin
      provider
      providerCustomerId
      providerShopNo
      providerSyncedAt
      currency
      point
      extraPoint
      extraExpire
      items {
        type
        itemId
        name
        parentId
        point
        amount
        quantity
      }
      quantity
      note
      orderId
      referId
      orderNumberPrefix
      orderNumber
      customerId
      pointTransactionCustomerId
      expiredAt
      salesDate
      eventId
      updatedAt
      createdAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const listPointTransactions = /* GraphQL */ `
  query ListPointTransactions(
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const getCustomerHistory = /* GraphQL */ `
  query GetCustomerHistory($storeId: ID!, $createdAt: AWSDateTime!) {
    getCustomerHistory(storeId: $storeId, createdAt: $createdAt) {
      storeId
      createdAt
      locationId
      name
      phone
      birth
      gender
      status
      customerId
      storeCustomerId
      updatedAt
    }
  }
`;
export const listCustomerHistorys = /* GraphQL */ `
  query ListCustomerHistorys(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelCustomerHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCustomerHistorys(
      storeId: $storeId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        createdAt
        locationId
        name
        phone
        birth
        gender
        status
        customerId
        storeCustomerId
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCreditTransaction = /* GraphQL */ `
  query GetCreditTransaction($id: ID!) {
    getCreditTransaction(id: $id) {
      id
      locationId
      storeId
      name
      type
      amount
      origin
      note
      currency
      parentId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      creditTransactionCustomerId
      description
      salesDate
      createdAt
      updatedAt
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
    }
  }
`;
export const listCreditTransactions = /* GraphQL */ `
  query ListCreditTransactions(
    $filter: ModelCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreditTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        name
        type
        amount
        origin
        note
        currency
        parentId
        orderId
        orderNumberPrefix
        orderNumber
        customerId
        creditTransactionCustomerId
        description
        salesDate
        createdAt
        updatedAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const getSalesServiceHistory = /* GraphQL */ `
  query GetSalesServiceHistory($storeId: ID!, $createdAt: AWSDateTime!) {
    getSalesServiceHistory(storeId: $storeId, createdAt: $createdAt) {
      storeId
      type
      status
      locationId
      quantity
      referId
      updatedAt
      createdAt
    }
  }
`;
export const listSalesServiceHistorys = /* GraphQL */ `
  query ListSalesServiceHistorys(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelSalesServiceHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSalesServiceHistorys(
      storeId: $storeId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        type
        status
        locationId
        quantity
        referId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLoyaltyHistory = /* GraphQL */ `
  query GetLoyaltyHistory($storeId: ID!, $createdAt: AWSDateTime!) {
    getLoyaltyHistory(storeId: $storeId, createdAt: $createdAt) {
      storeId
      status
      createdAt
      updatedAt
    }
  }
`;
export const listLoyaltyHistorys = /* GraphQL */ `
  query ListLoyaltyHistorys(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelLoyaltyHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoyaltyHistorys(
      storeId: $storeId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getConfirmation = /* GraphQL */ `
  query GetConfirmation($phone: String!, $code: Int!) {
    getConfirmation(phone: $phone, code: $code) {
      phone
      code
      expiredAt
      createdAt
      updatedAt
    }
  }
`;
export const listConfirmations = /* GraphQL */ `
  query ListConfirmations(
    $phone: String
    $code: ModelIntKeyConditionInput
    $filter: ModelConfirmationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConfirmations(
      phone: $phone
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        phone
        code
        expiredAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getArticle = /* GraphQL */ `
  query GetArticle($id: ID!) {
    getArticle(id: $id) {
      id
      category
      createdAt
      parentId
      url
      title
      description
      updatedAt
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        category
        createdAt
        parentId
        url
        title
        description
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotice = /* GraphQL */ `
  query GetNotice($id: ID!) {
    getNotice(id: $id) {
      id
      enterpriseId
      storeId
      employeeId
      status
      type
      visibility
      title
      description
      attachment {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      parentId
      updatedAt
      createdAt
    }
  }
`;
export const listNotices = /* GraphQL */ `
  query ListNotices(
    $filter: ModelNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getNoticeCampaignResult = /* GraphQL */ `
  query GetNoticeCampaignResult($id: ID!) {
    getNoticeCampaignResult(id: $id) {
      id
      recipientStoreId
      recipientLocationId
      campaignId
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      read
      updatedAt
      createdAt
    }
  }
`;
export const listNoticeCampaignResults = /* GraphQL */ `
  query ListNoticeCampaignResults(
    $filter: ModelNoticeCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeCampaignResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipientStoreId
        recipientLocationId
        campaignId
        noticeId
        notice {
          id
          enterpriseId
          storeId
          employeeId
          status
          type
          visibility
          title
          description
          attachment {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          parentId
          updatedAt
          createdAt
        }
        read
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getNoticeCampaign = /* GraphQL */ `
  query GetNoticeCampaign($id: ID!) {
    getNoticeCampaign(id: $id) {
      id
      enterpriseId
      storeId
      status
      title
      reserveDate
      sendNow
      noticeId
      notice {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const listNoticeCampaigns = /* GraphQL */ `
  query ListNoticeCampaigns(
    $filter: ModelNoticeCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enterpriseId
        storeId
        status
        title
        reserveDate
        sendNow
        noticeId
        notice {
          id
          enterpriseId
          storeId
          employeeId
          status
          type
          visibility
          title
          description
          attachment {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          parentId
          updatedAt
          createdAt
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getOnoffConfig = /* GraphQL */ `
  query GetOnoffConfig($storeId: ID!, $stage: ConfigStage!) {
    getOnoffConfig(storeId: $storeId, stage: $stage) {
      storeId
      stage
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      tierBenefits {
        id
        description
      }
      theme {
        primaryColor
        secondaryColor
        templateCode
      }
      item {
        stockInfo
      }
      banners {
        position
        url
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      mallUrl
      updatedAt
      createdAt
    }
  }
`;
export const listOnoffConfigs = /* GraphQL */ `
  query ListOnoffConfigs(
    $storeId: ID
    $stage: ModelStringKeyConditionInput
    $filter: ModelOnoffConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOnoffConfigs(
      storeId: $storeId
      stage: $stage
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        storeId
        stage
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        tierBenefits {
          id
          description
        }
        theme {
          primaryColor
          secondaryColor
          templateCode
        }
        item {
          stockInfo
        }
        banners {
          position
          url
          image {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        mallUrl
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCustomerEvent = /* GraphQL */ `
  query GetCustomerEvent($id: ID!) {
    getCustomerEvent(id: $id) {
      id
      status
      type
      storeId
      employeeId
      name
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      condition {
        memberOnly
        joinUrl
        amount
        productIds
        entryLimit
        tierIds
        newOnly
      }
      mainTitle
      mainTitleMl {
        en
        zh
        ja
      }
      subTitle
      subTitleMl {
        en
        zh
        ja
      }
      design {
        backgroundColor
        pointColor
        textColor
        buttonRadius
        buttonTextColor
        rouletteType
        roulettePointColor
        rouletteTextColor
      }
      startDate
      endDate
      description
      descriptionMl {
        en
        zh
        ja
      }
      links {
        name
        url
      }
      notice
      noticeMl {
        en
        zh
        ja
      }
      missions {
        key
        action
        instagram
        instagramId
        kakao
        cafe24
        imweb
      }
      rewards {
        type
        name
        couponId
        providerCouponId
        point
        rate
      }
      updatedAt
      createdAt
    }
  }
`;
export const listCustomerEvents = /* GraphQL */ `
  query ListCustomerEvents(
    $filter: ModelCustomerEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        type
        storeId
        employeeId
        name
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        condition {
          memberOnly
          joinUrl
          amount
          productIds
          entryLimit
          tierIds
          newOnly
        }
        mainTitle
        mainTitleMl {
          en
          zh
          ja
        }
        subTitle
        subTitleMl {
          en
          zh
          ja
        }
        design {
          backgroundColor
          pointColor
          textColor
          buttonRadius
          buttonTextColor
          rouletteType
          roulettePointColor
          rouletteTextColor
        }
        startDate
        endDate
        description
        descriptionMl {
          en
          zh
          ja
        }
        links {
          name
          url
        }
        notice
        noticeMl {
          en
          zh
          ja
        }
        missions {
          key
          action
          instagram
          instagramId
          kakao
          cafe24
          imweb
        }
        rewards {
          type
          name
          couponId
          providerCouponId
          point
          rate
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getPaymentTerminal = /* GraphQL */ `
  query GetPaymentTerminal($id: ID!) {
    getPaymentTerminal(id: $id) {
      id
      businessNumber
      businessOperatorId
      storeId
      locationId
      serial
      model
      brand
      updatedAt
      createdAt
    }
  }
`;
export const listPaymentTerminals = /* GraphQL */ `
  query ListPaymentTerminals(
    $filter: ModelPaymentTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerminals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        businessOperatorId
        storeId
        locationId
        serial
        model
        brand
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listLocationSettlementByStore = /* GraphQL */ `
  query ListLocationSettlementByStore(
    $storeId: ID
    $transactionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationSettlementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationSettlementByStore(
      storeId: $storeId
      transactionDate: $transactionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        locationId
        transactionDate
        storeId
        status
        amount
        amountSettled
        transactionAmount
        fee
        carryOrverAmount
        items {
          category
          status
          amount
          amountSettled
          fee
          brokerageRate
          brokerageFee
          cardRate
          cardFee
          cardAmount
          transactions {
            orderId
            amount
            type
            ident
            name
            approvalDate
            approvalNumber
            createdAt
          }
          carryOrverAmount
          carries {
            transactionDate
            amount
          }
          request
          response
          result
          requestSettleDate
          estimateDate
          settledAt
        }
        tryCount
        estimateDate
        requestSettleDate
        settledAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listWebhookHistoryByStore = /* GraphQL */ `
  query ListWebhookHistoryByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWebhookHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebhookHistoryByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        event
        url
        payload
        referId
        responseCode
        retryCount
        errorMessage
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const listOrderHistorysByLocation = /* GraphQL */ `
  query ListOrderHistorysByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderHistorysByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeId
        createdAt
        enterpriseId
        locationId
        type
        amount
        parentId
        currency
        orderHistoryOrderId
        customerStatus
        gender
        birth
        customerId
        updatedAt
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrderHistorysByOrder = /* GraphQL */ `
  query ListOrderHistorysByOrder(
    $orderHistoryOrderId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderHistorysByOrder(
      orderHistoryOrderId: $orderHistoryOrderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeId
        createdAt
        enterpriseId
        locationId
        type
        amount
        parentId
        currency
        orderHistoryOrderId
        customerStatus
        gender
        birth
        customerId
        updatedAt
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const listBugReportByCategory = /* GraphQL */ `
  query ListBugReportByCategory(
    $category: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBugReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBugReportByCategory(
      category: $category
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        employeeId
        locationId
        category
        name
        meta
        logs
        device {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const listBugReportByStore = /* GraphQL */ `
  query ListBugReportByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBugReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBugReportByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        employeeId
        locationId
        category
        name
        meta
        logs
        device {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const listEvnetHistoryByStore = /* GraphQL */ `
  query ListEvnetHistoryByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvnetHistoryByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        employeeId
        locationId
        category
        device {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        expdate
      }
      nextToken
    }
  }
`;
export const listCouponDeltaByStore = /* GraphQL */ `
  query ListCouponDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        enterpriseId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        name
        description
        availableOrigins
        code
        type
        method
        tranCount
        generateCount
        publishCount
        limitPublishCount
        duplicatePublish
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionItemsOperator
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        referId
        validDateType
        validValue
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        notice
        pointSavable
        startedAt
        endedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listCampaignResultsByRequest = /* GraphQL */ `
  query ListCampaignResultsByRequest(
    $requestId: ID
    $phone: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignResultsByRequest(
      requestId: $requestId
      phone: $phone
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        campaignResultCustomerId
        customerProvider
        providerCustomerId
        linkId
        requestId
        title
        message
        phone
        msgStatus
        reservedAt
        campaignResultsId
        requestedAt
        resultCode
        resultCodeName
        templateId
        statusCode
        method
        sendType
        sender
        sentAt
        creditTransactionId
        messageType
        failureReason
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignResultsByStoreCustomer = /* GraphQL */ `
  query ListCampaignResultsByStoreCustomer(
    $campaignResultCustomerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignResultsByStoreCustomer(
      campaignResultCustomerId: $campaignResultCustomerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        campaignResultCustomerId
        customerProvider
        providerCustomerId
        linkId
        requestId
        title
        message
        phone
        msgStatus
        reservedAt
        campaignResultsId
        requestedAt
        resultCode
        resultCodeName
        templateId
        statusCode
        method
        sendType
        sender
        sentAt
        creditTransactionId
        messageType
        failureReason
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignResultsByStore = /* GraphQL */ `
  query ListCampaignResultsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignResultsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        campaignResultCustomerId
        customerProvider
        providerCustomerId
        linkId
        requestId
        title
        message
        phone
        msgStatus
        reservedAt
        campaignResultsId
        requestedAt
        resultCode
        resultCodeName
        templateId
        statusCode
        method
        sendType
        sender
        sentAt
        creditTransactionId
        messageType
        failureReason
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignResultsByLocation = /* GraphQL */ `
  query ListCampaignResultsByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignResultsByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        campaignResultCustomerId
        customerProvider
        providerCustomerId
        linkId
        requestId
        title
        message
        phone
        msgStatus
        reservedAt
        campaignResultsId
        requestedAt
        resultCode
        resultCodeName
        templateId
        statusCode
        method
        sendType
        sender
        sentAt
        creditTransactionId
        messageType
        failureReason
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignTemplateByStore = /* GraphQL */ `
  query ListCampaignTemplateByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignTemplateByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        ads
        name
        title
        message
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignTemplateByLocation = /* GraphQL */ `
  query ListCampaignTemplateByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignTemplateByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        ads
        name
        title
        message
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCampaignsByStore = /* GraphQL */ `
  query ListCampaignsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listCampaignsByLocation = /* GraphQL */ `
  query ListCampaignsByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listCampaignsByRecipient = /* GraphQL */ `
  query ListCampaignsByRecipient(
    $recipientId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByRecipient(
      recipientId: $recipientId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listCampaignsByStatus = /* GraphQL */ `
  query ListCampaignsByStatus(
    $status: CampaignStatus
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        type
        name
        trigger
        agency
        triggerTiming
        triggerCondition {
          type
          operation
          value
        }
        startDate
        endDate
        couponProvider
        couponId
        description
        recipientProvider
        recipientId
        campaignRecipientId
        recipient {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        campaignRecipientTagId
        campaignRecipientLocationIds
        recipientList
        recipientCount
        filter {
          type
          operation
          value
        }
        includes
        sendNow
        sendAfterDays
        sendAtTime
        reserveDate
        sentAt
        title
        message
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        imageType
        imageLink
        buttons {
          order
          type
          name
          linkMo
          linkPc
          target
        }
        params {
          key
          value
        }
        templateCode
        templateId
        method
        tracking
        trackingLink
        block
        ads
        duplicatable
        sender
        success
        failure
        pending
        cost
        status
        creditTransactionId
        results {
          items {
            id
            enterpriseId
            storeId
            locationId
            customerId
            campaignResultCustomerId
            customerProvider
            providerCustomerId
            linkId
            requestId
            title
            message
            phone
            msgStatus
            reservedAt
            campaignResultsId
            requestedAt
            resultCode
            resultCodeName
            templateId
            statusCode
            method
            sendType
            sender
            sentAt
            creditTransactionId
            messageType
            failureReason
            updatedAt
            createdAt
          }
          nextToken
        }
        updatedAt
        createdAt
        report
        system
        messageType
        sendTarget
        brandMessageType
        listItems
        cards
        tail
        brandImages
        coupon
        recipientTag {
          id
          label
          description
          color
          customerIds
          storeId
          locationId
          type
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listInventoryHistorysByStore = /* GraphQL */ `
  query ListInventoryHistorysByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryHistorysByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      nextToken
    }
  }
`;
export const listInventoryHistorysByLocation = /* GraphQL */ `
  query ListInventoryHistorysByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryHistorysByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      nextToken
    }
  }
`;
export const listInventoryHistorysByRefer = /* GraphQL */ `
  query ListInventoryHistorysByRefer(
    $referId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryHistorysByRefer(
      referId: $referId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        enterpriseId
        storeId
        productId
        skuId
        locationId
        employeeId
        inventoryId
        referId
        referOrderOrigin
        origin
        groupId
        groupHistoryCount
        purchaseOrderId
        totalCost
        cost
        expiryDate
        note
        reason
        transactions {
          parentId
          reason
          quantity
          prevQuantity
          createdAt
        }
        quantity
        prevQuantity
        currQuantity
        readyQuantity
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCategoriesByStore = /* GraphQL */ `
  query ListCategoriesByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        code
        enterpriseId
        storeId
        name
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        depth
        parentCategoryId
        active
        refer
        referId
        sortKey
        subCategoryProductDisplay
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listClassificationByStore = /* GraphQL */ `
  query ListClassificationByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClassificationByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        id
        enterpriseId
        storeId
        name
        depth
        parentId
        refer
        referId
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listModifiersByStore = /* GraphQL */ `
  query ListModifiersByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModifiersByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        origin
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        products {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listProductCategoryByProduct = /* GraphQL */ `
  query ListProductCategoryByProduct(
    $productId: ID
    $categoryId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategoryByProduct(
      productId: $productId
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        categoryId
        position
        category {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductCategoryByCategory = /* GraphQL */ `
  query ListProductCategoryByCategory(
    $categoryId: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategoryByCategory(
      categoryId: $categoryId
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        categoryId
        position
        category {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductCategoryByStore = /* GraphQL */ `
  query ListProductCategoryByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategoryByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        categoryId
        position
        category {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductClassificationByProduct = /* GraphQL */ `
  query ListProductClassificationByProduct(
    $productId: ID
    $classificationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductClassificationByProduct(
      productId: $productId
      classificationId: $classificationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        classificationId
        classification {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductClassificationByCategory = /* GraphQL */ `
  query ListProductClassificationByCategory(
    $classificationId: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductClassificationByCategory(
      classificationId: $classificationId
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        classificationId
        classification {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductClassificationByStore = /* GraphQL */ `
  query ListProductClassificationByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductClassificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductClassificationByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        classificationId
        classification {
          type
          id
          code
          enterpriseId
          storeId
          name
          displayName
          displayNameMl {
            en
            zh
            ja
          }
          depth
          parentCategoryId
          active
          refer
          referId
          sortKey
          subCategoryProductDisplay
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductModifierByProduct = /* GraphQL */ `
  query ListProductModifierByProduct(
    $productId: ID
    $modifierId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductModifierByProduct(
      productId: $productId
      modifierId: $modifierId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        modifierId
        position
        modifier {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductModifierByModifier = /* GraphQL */ `
  query ListProductModifierByModifier(
    $modifierId: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductModifierByModifier(
      modifierId: $modifierId
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        modifierId
        position
        modifier {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listProductModifierByStore = /* GraphQL */ `
  query ListProductModifierByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductModifierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductModifierByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        productId
        modifierId
        position
        modifier {
          id
          type
          enterpriseId
          storeId
          name
          nameMl {
            en
            zh
            ja
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          origin
          orderType
          defaultSkuId
          coverage
          required
          requiredQuantity
          limitQuantity
          products {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listSalesHistorysByLocation = /* GraphQL */ `
  query ListSalesHistorysByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSalesHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesHistorysByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeId
        startedAt
        enterpriseId
        locationId
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        cashes {
          name
          value
          count
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listGlobalDeltaByStore = /* GraphQL */ `
  query ListGlobalDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGlobalDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGlobalDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        storeId
        locationId
        data
        updatedAt
        createdAt
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listBillHistoryByStore = /* GraphQL */ `
  query ListBillHistoryByStore(
    $storeId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillHistoryByStore(
      storeId: $storeId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        storeId
        locationId
        name
        type
        status
        failReason
        discounts {
          name
          amount
          transactionId
        }
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          type
          name
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listBillHistoryByLocation = /* GraphQL */ `
  query ListBillHistoryByLocation(
    $locationId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillHistoryByLocation(
      locationId: $locationId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        storeId
        locationId
        name
        type
        status
        failReason
        discounts {
          name
          amount
          transactionId
        }
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          type
          name
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listBillHistoryByStatus = /* GraphQL */ `
  query ListBillHistoryByStatus(
    $status: BillHistoryStatus
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillHistoryByStatus(
      status: $status
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        storeId
        locationId
        name
        type
        status
        failReason
        discounts {
          name
          amount
          transactionId
        }
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          type
          name
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listBillHistoryByType = /* GraphQL */ `
  query ListBillHistoryByType(
    $type: String
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillHistoryByType(
      type: $type
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        storeId
        locationId
        name
        type
        status
        failReason
        discounts {
          name
          amount
          transactionId
        }
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          type
          name
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listBillingHistoryByDate = /* GraphQL */ `
  query ListBillingHistoryByDate(
    $date: String
    $sortDirection: ModelSortDirection
    $filter: ModelBillingHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillingHistoryByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        enterpriseId
        storeId
        locationId
        name
        type
        status
        failReason
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          locationId
          name
          type
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
          category
          quantity
          currency
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listBillingHistoryByStatus = /* GraphQL */ `
  query ListBillingHistoryByStatus(
    $status: BillHistoryStatus
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBillingHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillingHistoryByStatus(
      status: $status
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        enterpriseId
        storeId
        locationId
        name
        type
        status
        failReason
        amount
        currency
        paidAt
        refundedAt
        transaction {
          cardName
          cardNumber
          cardQuota
          pg
          transactionId
          amount
          currency
          method
          purchasedAt
          requestedAt
          revokedAt
          status
          statusEn
          statusKo
          receiptId
          receiptUrl
        }
        items {
          locationId
          name
          type
          amount
          details {
            type
            name
            amount
            basePrice
            unitPrice
            usage
            rate
            referId
            period
          }
          category
          quantity
          currency
        }
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listLabelTemplateByStore = /* GraphQL */ `
  query ListLabelTemplateByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLabelTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLabelTemplateByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        name
        components {
          type
          format
          height
          fontSize
          maxLines
          align
          bold
          strikeThrough
          showText
          x
          y
          w
          h
          discountRule
        }
        pageLayout {
          horizontalCount
          width
          height
          marginRight
          marginTop
          marginLeft
          marginBottom
          templateWidth
          templateHeight
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listLabelTemplateByLocation = /* GraphQL */ `
  query ListLabelTemplateByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLabelTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLabelTemplateByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        name
        components {
          type
          format
          height
          fontSize
          maxLines
          align
          bold
          strikeThrough
          showText
          x
          y
          w
          h
          discountRule
        }
        pageLayout {
          horizontalCount
          width
          height
          marginRight
          marginTop
          marginLeft
          marginBottom
          templateWidth
          templateHeight
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCafe24EventByNumber = /* GraphQL */ `
  query ListCafe24EventByNumber(
    $number: Int
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCafe24EventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCafe24EventByNumber(
      number: $number
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        resource
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listItemLinkHistoryByStore = /* GraphQL */ `
  query ListItemLinkHistoryByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemLinkHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemLinkHistoryByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        type
        subType
        provider
        linkQuantity
        syncQuantity
        unlinkQuantity
        totalLinkQuantity
        employeeId
        condition
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerTierUpdateHistoryByStore = /* GraphQL */ `
  query ListCustomerTierUpdateHistoryByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTierUpdateHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTierUpdateHistoryByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        type
        date
        totalCount
        upCount
        downCount
        coupons {
          couponId
          count
          type
          scope
          name
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerTierUpdateHistoryByDateStore = /* GraphQL */ `
  query ListCustomerTierUpdateHistoryByDateStore(
    $date: String
    $storeId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTierUpdateHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTierUpdateHistoryByDateStore(
      date: $date
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        type
        date
        totalCount
        upCount
        downCount
        coupons {
          couponId
          count
          type
          scope
          name
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listEmployeeByEmail = /* GraphQL */ `
  query ListEmployeeByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        lastName
        firstName
        name
        nickname
        phone
        email
        employeeStoreId
        employeeEnterpriseId
        organizations {
          items {
            id
            role
            employeeId
            enterpriseId
            storeId
            pin
            status
            locationId
            employee {
              id
              role
              lastName
              firstName
              name
              nickname
              phone
              email
              employeeStoreId
              employeeEnterpriseId
              organizations {
                nextToken
              }
              survey
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            permissions
            updatedAt
            createdAt
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
          }
          nextToken
        }
        survey
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationsByEmployee = /* GraphQL */ `
  query ListOrganizationsByEmployee(
    $employeeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationsByEmployee(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        employeeId
        enterpriseId
        storeId
        pin
        status
        locationId
        employee {
          id
          role
          lastName
          firstName
          name
          nickname
          phone
          email
          employeeStoreId
          employeeEnterpriseId
          organizations {
            items {
              id
              role
              employeeId
              enterpriseId
              storeId
              pin
              status
              locationId
              employee {
                id
                role
                lastName
                firstName
                name
                nickname
                phone
                email
                employeeStoreId
                employeeEnterpriseId
                survey
                updatedAt
                createdAt
              }
              permissions
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            nextToken
          }
          survey
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        permissions
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationsByStore = /* GraphQL */ `
  query ListOrganizationsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        employeeId
        enterpriseId
        storeId
        pin
        status
        locationId
        employee {
          id
          role
          lastName
          firstName
          name
          nickname
          phone
          email
          employeeStoreId
          employeeEnterpriseId
          organizations {
            items {
              id
              role
              employeeId
              enterpriseId
              storeId
              pin
              status
              locationId
              employee {
                id
                role
                lastName
                firstName
                name
                nickname
                phone
                email
                employeeStoreId
                employeeEnterpriseId
                survey
                updatedAt
                createdAt
              }
              permissions
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            nextToken
          }
          survey
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        permissions
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationsByLocation = /* GraphQL */ `
  query ListOrganizationsByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationsByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        employeeId
        enterpriseId
        storeId
        pin
        status
        locationId
        employee {
          id
          role
          lastName
          firstName
          name
          nickname
          phone
          email
          employeeStoreId
          employeeEnterpriseId
          organizations {
            items {
              id
              role
              employeeId
              enterpriseId
              storeId
              pin
              status
              locationId
              employee {
                id
                role
                lastName
                firstName
                name
                nickname
                phone
                email
                employeeStoreId
                employeeEnterpriseId
                survey
                updatedAt
                createdAt
              }
              permissions
              updatedAt
              createdAt
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
            }
            nextToken
          }
          survey
          updatedAt
          createdAt
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
        }
        permissions
        updatedAt
        createdAt
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listRentalContractByStore = /* GraphQL */ `
  query ListRentalContractByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRentalContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentalContractByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        storeId
        locationId
        businessOperatorId
        months
        quantity
        amount
        startDate
        endDate
        extraFees {
          name
          amount
          billedAt
          createdAt
        }
        updatedAt
        createdAt
        businessOperator {
          id
          businessNumber
          name
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listRentalContractByLocation = /* GraphQL */ `
  query ListRentalContractByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRentalContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentalContractByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        storeId
        locationId
        businessOperatorId
        months
        quantity
        amount
        startDate
        endDate
        extraFees {
          name
          amount
          billedAt
          createdAt
        }
        updatedAt
        createdAt
        businessOperator {
          id
          businessNumber
          name
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listRentalContractByBusinessOperator = /* GraphQL */ `
  query ListRentalContractByBusinessOperator(
    $businessOperatorId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRentalContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentalContractByBusinessOperator(
      businessOperatorId: $businessOperatorId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        storeId
        locationId
        businessOperatorId
        months
        quantity
        amount
        startDate
        endDate
        extraFees {
          name
          amount
          billedAt
          createdAt
        }
        updatedAt
        createdAt
        businessOperator {
          id
          businessNumber
          name
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByStore = /* GraphQL */ `
  query ListPointTransactionsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByLocation = /* GraphQL */ `
  query ListPointTransactionsByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByStoreSalesDate = /* GraphQL */ `
  query ListPointTransactionsByStoreSalesDate(
    $storeId: ID
    $salesDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByStoreSalesDate(
      storeId: $storeId
      salesDate: $salesDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByLocationSalesDate = /* GraphQL */ `
  query ListPointTransactionsByLocationSalesDate(
    $locationId: ID
    $salesDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByLocationSalesDate(
      locationId: $locationId
      salesDate: $salesDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByOrder = /* GraphQL */ `
  query ListPointTransactionsByOrder(
    $orderId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByOrder(
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByCustomer = /* GraphQL */ `
  query ListPointTransactionsByCustomer(
    $customerId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByCustomer(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointTransactionsByStoreCustomer = /* GraphQL */ `
  query ListPointTransactionsByStoreCustomer(
    $pointTransactionCustomerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointTransactionsByStoreCustomer(
      pointTransactionCustomerId: $pointTransactionCustomerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        type
        name
        method
        amount
        origin
        provider
        providerCustomerId
        providerShopNo
        providerSyncedAt
        currency
        point
        extraPoint
        extraExpire
        items {
          type
          itemId
          name
          parentId
          point
          amount
          quantity
        }
        quantity
        note
        orderId
        referId
        orderNumberPrefix
        orderNumber
        customerId
        pointTransactionCustomerId
        expiredAt
        salesDate
        eventId
        updatedAt
        createdAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listCreditTransactionsByStore = /* GraphQL */ `
  query ListCreditTransactionsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreditTransactionsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        name
        type
        amount
        origin
        note
        currency
        parentId
        orderId
        orderNumberPrefix
        orderNumber
        customerId
        creditTransactionCustomerId
        description
        salesDate
        createdAt
        updatedAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listCreditTransactionsByCustomer = /* GraphQL */ `
  query ListCreditTransactionsByCustomer(
    $customerId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreditTransactionsByCustomer(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        name
        type
        amount
        origin
        note
        currency
        parentId
        orderId
        orderNumberPrefix
        orderNumber
        customerId
        creditTransactionCustomerId
        description
        salesDate
        createdAt
        updatedAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listCreditTransactionsByStoreCustomer = /* GraphQL */ `
  query ListCreditTransactionsByStoreCustomer(
    $creditTransactionCustomerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreditTransactionsByStoreCustomer(
      creditTransactionCustomerId: $creditTransactionCustomerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        storeId
        name
        type
        amount
        origin
        note
        currency
        parentId
        orderId
        orderNumberPrefix
        orderNumber
        customerId
        creditTransactionCustomerId
        description
        salesDate
        createdAt
        updatedAt
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listSalesServiceHistoryByLocation = /* GraphQL */ `
  query ListSalesServiceHistoryByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSalesServiceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesServiceHistoryByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeId
        type
        status
        locationId
        quantity
        referId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listArticleByCategory = /* GraphQL */ `
  query ListArticleByCategory(
    $category: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticleByCategory(
      category: $category
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        createdAt
        parentId
        url
        title
        description
        updatedAt
      }
      nextToken
    }
  }
`;
export const listNoticesByStore = /* GraphQL */ `
  query ListNoticesByStore(
    $storeId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticesByStore(
      storeId: $storeId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        employeeId
        status
        type
        visibility
        title
        description
        attachment {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        parentId
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listNoticeCampaignResultsByStore = /* GraphQL */ `
  query ListNoticeCampaignResultsByStore(
    $recipientStoreId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoticeCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeCampaignResultsByStore(
      recipientStoreId: $recipientStoreId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipientStoreId
        recipientLocationId
        campaignId
        noticeId
        notice {
          id
          enterpriseId
          storeId
          employeeId
          status
          type
          visibility
          title
          description
          attachment {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          parentId
          updatedAt
          createdAt
        }
        read
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listNoticeCampaignResultsByLocation = /* GraphQL */ `
  query ListNoticeCampaignResultsByLocation(
    $recipientLocationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoticeCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeCampaignResultsByLocation(
      recipientLocationId: $recipientLocationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipientStoreId
        recipientLocationId
        campaignId
        noticeId
        notice {
          id
          enterpriseId
          storeId
          employeeId
          status
          type
          visibility
          title
          description
          attachment {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          parentId
          updatedAt
          createdAt
        }
        read
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listNoticeCampaignsByStore = /* GraphQL */ `
  query ListNoticeCampaignsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoticeCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoticeCampaignsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        status
        title
        reserveDate
        sendNow
        noticeId
        notice {
          id
          enterpriseId
          storeId
          employeeId
          status
          type
          visibility
          title
          description
          attachment {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          parentId
          updatedAt
          createdAt
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerEventByStore = /* GraphQL */ `
  query ListCustomerEventByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerEventByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        type
        storeId
        employeeId
        name
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        condition {
          memberOnly
          joinUrl
          amount
          productIds
          entryLimit
          tierIds
          newOnly
        }
        mainTitle
        mainTitleMl {
          en
          zh
          ja
        }
        subTitle
        subTitleMl {
          en
          zh
          ja
        }
        design {
          backgroundColor
          pointColor
          textColor
          buttonRadius
          buttonTextColor
          rouletteType
          roulettePointColor
          rouletteTextColor
        }
        startDate
        endDate
        description
        descriptionMl {
          en
          zh
          ja
        }
        links {
          name
          url
        }
        notice
        noticeMl {
          en
          zh
          ja
        }
        missions {
          key
          action
          instagram
          instagramId
          kakao
          cafe24
          imweb
        }
        rewards {
          type
          name
          couponId
          providerCouponId
          point
          rate
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPaymentTerminalByBusinessNumber = /* GraphQL */ `
  query ListPaymentTerminalByBusinessNumber(
    $businessNumber: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerminalByBusinessNumber(
      businessNumber: $businessNumber
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        businessOperatorId
        storeId
        locationId
        serial
        model
        brand
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPaymentTerminalByBusinessOperator = /* GraphQL */ `
  query ListPaymentTerminalByBusinessOperator(
    $businessOperatorId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerminalByBusinessOperator(
      businessOperatorId: $businessOperatorId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        businessOperatorId
        storeId
        locationId
        serial
        model
        brand
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPaymentTerminalByStore = /* GraphQL */ `
  query ListPaymentTerminalByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerminalByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        businessOperatorId
        storeId
        locationId
        serial
        model
        brand
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPaymentTerminalByLocation = /* GraphQL */ `
  query ListPaymentTerminalByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerminalByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        businessOperatorId
        storeId
        locationId
        serial
        model
        brand
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getEnvironment = /* GraphQL */ `
  query GetEnvironment($id: ID!) {
    getEnvironment(id: $id) {
      id
      appVersion
      pcVersion
      webVersion
      inventoryDeployedAt
      credits {
        quantity
        amount
        discount
      }
      merchantPassword
      noticeDate
      updatedAt
      createdAt
    }
  }
`;
export const listEnvironments = /* GraphQL */ `
  query ListEnvironments(
    $filter: ModelEnvironmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEnvironments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        appVersion
        pcVersion
        webVersion
        inventoryDeployedAt
        credits {
          quantity
          amount
          discount
        }
        merchantPassword
        noticeDate
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      note
      request
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      customer {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      orderCustomer {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByLocation = /* GraphQL */ `
  query ListOrdersByLocation(
    $orderLocationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByLocation(
      orderLocationId: $orderLocationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByStore = /* GraphQL */ `
  query ListOrdersByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByCustomer = /* GraphQL */ `
  query ListOrdersByCustomer(
    $customerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByCustomer(
      customerId: $customerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByStoreCustomer = /* GraphQL */ `
  query ListOrdersByStoreCustomer(
    $orderCustomerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByStoreCustomer(
      orderCustomerId: $orderCustomerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByReceiptCustomer = /* GraphQL */ `
  query ListOrdersByReceiptCustomer(
    $receiptCustomerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByReceiptCustomer(
      receiptCustomerId: $receiptCustomerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByLocationReceiptNumber = /* GraphQL */ `
  query ListOrdersByLocationReceiptNumber(
    $orderLocationId: ID
    $receiptNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByLocationReceiptNumber(
      orderLocationId: $orderLocationId
      receiptNumber: $receiptNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByLocationOriginId = /* GraphQL */ `
  query ListOrdersByLocationOriginId(
    $orderLocationId: ID
    $originId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByLocationOriginId(
      orderLocationId: $orderLocationId
      originId: $originId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByLocationState = /* GraphQL */ `
  query ListOrdersByLocationState(
    $orderLocationId: ID
    $state: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByLocationState(
      orderLocationId: $orderLocationId
      state: $state
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByShippingLocation = /* GraphQL */ `
  query ListOrdersByShippingLocation(
    $shippingLocationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByShippingLocation(
      shippingLocationId: $shippingLocationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByLocationReopened = /* GraphQL */ `
  query ListOrdersByLocationReopened(
    $orderLocationId: ID
    $reopenedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByLocationReopened(
      orderLocationId: $orderLocationId
      reopenedAt: $reopenedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
      nextToken
    }
  }
`;
export const getOrderDelta = /* GraphQL */ `
  query GetOrderDelta($id: ID!) {
    getOrderDelta(id: $id) {
      id
      orderLocationId
      numberPrefix
      number
      beeper
      enterpriseId
      storeId
      customerId
      orderCustomerId
      state
      amount
      amountPaid
      origin
      subOrigin
      originId
      customerProvider
      providerCustomerId
      customerProviderShopNo
      amountChanged
      amountReturned
      tax
      currency
      quantity
      shippingType
      diningOption
      diningState
      retailOption
      retailState
      mergeGroupId
      mergeBlocked
      deliveredAt
      name
      phone
      address
      zip
      customerGender
      customerAge
      customerCountry
      receivers {
        id
        type
        shipmentSeq
        provision
        name
        phone
        zip
        address1
        address2
        addressState
        addressCity
        addressStreet
        addressFull
        note
        shippingCompanyCode
        shippingAcceptCount
        shippingStartCount
        trackingNumber
        providerShippingId
        providerSyncStatus
        providerSyncError
        providerSyncedAt
        issuedAt
        privacyAgreedAt
        waybillMeta
      }
      tableId
      tableIds
      parentDeviceId
      deviceId
      reserveDate
      pickupDate
      shippingDate
      items {
        id
        type
        index
        category
        categories {
          id
          name
        }
        classificationIds
        productId
        modifierId
        name
        description
        amount
        price
        parentId
        providerProductId
        providerOptionId
        providerProductName
        providerOptionName
        matchType
        matchedQuantity
        receiverId
        shippingLocationId
        returnShippingLocationId
        referType
        referId
        campaignId
        eventId
        requestId
        quantity
        sku
        tax
        taxRate
        diningOption
        diningState
        retailOption
        retailState
        confirmedAt
        shippedAt
        deliveredAt
        modifiers {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        discounts {
          id
          scope
          type
          amount
          name
        }
        discountable
        discountQuantity
        discountIncludeIds
        discountExcludeIds
        discountMethod
        discountValue
        orderedQuantity
        voidQuantity
        paidQuantity
        readyQuantity
        receivedQuantity
        inventoryReason
        point
        note
        salesDate
        createdAt
      }
      createdEmployeeId
      createdDeviceId
      updatedDeviceId
      shippingLocationId
      returnShippingLocationId
      confirmedEmployeeId
      importedAt
      confirmedAt
      createdAt
      paidAt
      salesDate
      returnedAt
      reopenedAt
      shippedAt
      returnShippedAt
      returnSalesDate
      updatedAt
      noticeCount
      visitorCount
      totalPoint
      pointSaved
      receiptId
      receiptNumber
      receiptCount
      alarmCustomerId
      receiptCustomerId
      request
      note
      charges {
        id
        method
        extraMethod
        gateway
        amount
        tax
        taxRefundAmount
        purchaser {
          name
          number
          nation
          gender
          birth
          address
        }
        supplyAmount
        taxFreeAmount
        amountRefunded
        createdEmployeeId
        createdDeviceId
        salesDate
        createdAt
        creditTransactionId
        balance
        splitType
        pg
        van
        origin
        originId
        note
        brand
        name
        ident
        installment
        transactionId
        approver
        issuerCode
        acquirer
        acquirerCode
        acquirerName
        refundable
        recurring
        approvalCode
        approvalDate
        approvalNumber
        signature {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        terminalId
        refunds {
          id
          amount
          supplyAmount
          taxFreeAmount
          tax
          taxRefundAmount
          creditTransactionId
          approvalNumber
          approvalDate
          transactionId
          origin
          originId
          currency
          reason
          bankCode
          bankName
          bankAccountNo
          bankAccountHolder
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          createdEmployeeId
          createdDeviceId
          terminalId
          salesDate
          createdAt
        }
      }
      exchanges {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        chargeIds
        providerClaimId
        salesDate
        createdAt
      }
      returns {
        exchangeGroupId
        amount
        currency
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        refundId
        refundIds
        providerClaimId
        receiverId
        shippingFee
        shippingPayType
        settled
        settledAt
        salesDate
        createdAt
      }
      fee
      revision
      _delta
      timestamp
      expdate
    }
  }
`;
export const listOrderDeltas = /* GraphQL */ `
  query ListOrderDeltas(
    $filter: ModelOrderDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderDeltas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        request
        note
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listOrderDeltaByLocation = /* GraphQL */ `
  query ListOrderDeltaByLocation(
    $orderLocationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderDeltaByLocation(
      orderLocationId: $orderLocationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        request
        note
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listOrderDeltaByShippingLocation = /* GraphQL */ `
  query ListOrderDeltaByShippingLocation(
    $shippingLocationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderDeltaByShippingLocation(
      shippingLocationId: $shippingLocationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        request
        note
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getOrderTicketDelta = /* GraphQL */ `
  query GetOrderTicketDelta($id: ID!) {
    getOrderTicketDelta(id: $id) {
      id
      storeId
      locationId
      orderId
      items {
        id
        diningState
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      order {
        id
        orderLocationId
        numberPrefix
        number
        beeper
        enterpriseId
        storeId
        customerId
        orderCustomerId
        state
        amount
        amountPaid
        origin
        subOrigin
        originId
        customerProvider
        providerCustomerId
        customerProviderShopNo
        amountChanged
        amountReturned
        tax
        currency
        quantity
        shippingType
        diningOption
        diningState
        retailOption
        retailState
        mergeGroupId
        mergeBlocked
        deliveredAt
        name
        phone
        address
        zip
        customerGender
        customerAge
        customerCountry
        receivers {
          id
          type
          shipmentSeq
          provision
          name
          phone
          zip
          address1
          address2
          addressState
          addressCity
          addressStreet
          addressFull
          note
          shippingCompanyCode
          shippingAcceptCount
          shippingStartCount
          trackingNumber
          providerShippingId
          providerSyncStatus
          providerSyncError
          providerSyncedAt
          issuedAt
          privacyAgreedAt
          waybillMeta
        }
        tableId
        tableIds
        parentDeviceId
        deviceId
        reserveDate
        pickupDate
        shippingDate
        items {
          id
          type
          index
          category
          categories {
            id
            name
          }
          classificationIds
          productId
          modifierId
          name
          description
          amount
          price
          parentId
          providerProductId
          providerOptionId
          providerProductName
          providerOptionName
          matchType
          matchedQuantity
          receiverId
          shippingLocationId
          returnShippingLocationId
          referType
          referId
          campaignId
          eventId
          requestId
          quantity
          sku
          tax
          taxRate
          diningOption
          diningState
          retailOption
          retailState
          confirmedAt
          shippedAt
          deliveredAt
          modifiers {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          discounts {
            id
            scope
            type
            amount
            name
          }
          discountable
          discountQuantity
          discountIncludeIds
          discountExcludeIds
          discountMethod
          discountValue
          orderedQuantity
          voidQuantity
          paidQuantity
          readyQuantity
          receivedQuantity
          inventoryReason
          point
          note
          salesDate
          createdAt
        }
        createdEmployeeId
        createdDeviceId
        updatedDeviceId
        shippingLocationId
        returnShippingLocationId
        confirmedEmployeeId
        importedAt
        confirmedAt
        createdAt
        paidAt
        salesDate
        returnedAt
        reopenedAt
        shippedAt
        returnShippedAt
        returnSalesDate
        updatedAt
        noticeCount
        visitorCount
        totalPoint
        pointSaved
        receiptId
        receiptNumber
        receiptCount
        alarmCustomerId
        receiptCustomerId
        note
        request
        charges {
          id
          method
          extraMethod
          gateway
          amount
          tax
          taxRefundAmount
          purchaser {
            name
            number
            nation
            gender
            birth
            address
          }
          supplyAmount
          taxFreeAmount
          amountRefunded
          createdEmployeeId
          createdDeviceId
          salesDate
          createdAt
          creditTransactionId
          balance
          splitType
          pg
          van
          origin
          originId
          note
          brand
          name
          ident
          installment
          transactionId
          approver
          issuerCode
          acquirer
          acquirerCode
          acquirerName
          refundable
          recurring
          approvalCode
          approvalDate
          approvalNumber
          signature {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          terminalId
          refunds {
            id
            amount
            supplyAmount
            taxFreeAmount
            tax
            taxRefundAmount
            creditTransactionId
            approvalNumber
            approvalDate
            transactionId
            origin
            originId
            currency
            reason
            bankCode
            bankName
            bankAccountNo
            bankAccountHolder
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            createdEmployeeId
            createdDeviceId
            terminalId
            salesDate
            createdAt
          }
        }
        exchanges {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          chargeIds
          providerClaimId
          salesDate
          createdAt
        }
        returns {
          exchangeGroupId
          amount
          currency
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          refundId
          refundIds
          providerClaimId
          receiverId
          shippingFee
          shippingPayType
          settled
          settledAt
          salesDate
          createdAt
        }
        fee
        revision
        _delta
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        customer {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        orderCustomer {
          id
          enterpriseId
          storeId
          locationId
          customerId
          provider
          providerCustomerId
          shopNo
          tier
          tierId
          customerCreatedAt
          ident
          identType
          type
          name
          nameKeyword
          payments {
            id
            method
            pg
            number
            name
            expMonth
            expYear
            billingKey
            updatedAt
            createdAt
          }
          attributes {
            name
            type
            value
          }
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          tags {
            tagId
            createdLocationId
          }
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          status
          registeredAt
          salesDate
          campaignBlockedAt
          blacklistedAt
          isFavorite
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          note
          sources {
            id
            type
            name
            ident
            createdAt
          }
          removedAt
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
        }
      }
    }
  }
`;
export const listOrderTicketDeltas = /* GraphQL */ `
  query ListOrderTicketDeltas(
    $filter: ModelOrderTicketDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderTicketDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        orderId
        items {
          id
          diningState
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrderTicketByLocation = /* GraphQL */ `
  query ListOrderTicketByLocation(
    $locationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderTicketDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderTicketByLocation(
      locationId: $locationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        orderId
        items {
          id
          diningState
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrderTicketByOrder = /* GraphQL */ `
  query ListOrderTicketByOrder(
    $orderId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderTicketDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderTicketByOrder(
      orderId: $orderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        orderId
        items {
          id
          diningState
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        order {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
      }
      nextToken
    }
  }
`;
export const getCustomerTag = /* GraphQL */ `
  query GetCustomerTag($id: ID!) {
    getCustomerTag(id: $id) {
      id
      label
      description
      color
      customerIds
      storeId
      locationId
      type
      key
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
    }
  }
`;
export const listCustomerTags = /* GraphQL */ `
  query ListCustomerTags(
    $filter: ModelCustomerTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerTagsByStore = /* GraphQL */ `
  query ListCustomerTagsByStore(
    $storeId: ID
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTagsByStore(
      storeId: $storeId
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerTagsByStoreId = /* GraphQL */ `
  query ListCustomerTagsByStoreId(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTagsByStoreId(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listCustomerTagsByLocationId = /* GraphQL */ `
  query ListCustomerTagsByLocationId(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTagsByLocationId(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        description
        color
        customerIds
        storeId
        locationId
        type
        key
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCustomerTagDelta = /* GraphQL */ `
  query GetCustomerTagDelta($id: ID!) {
    getCustomerTagDelta(id: $id) {
      id
      type
      label
      description
      color
      storeId
      locationId
      conditions {
        key
        object
        field
        operations {
          operation
          type
          value
        }
        value
        operation
        type
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listCustomerTagDeltas = /* GraphQL */ `
  query ListCustomerTagDeltas(
    $filter: ModelCustomerTagDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTagDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        label
        description
        color
        storeId
        locationId
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listCustomerTagDeltaByStore = /* GraphQL */ `
  query ListCustomerTagDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerTagDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTagDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        label
        description
        color
        storeId
        locationId
        conditions {
          key
          object
          field
          operations {
            operation
            type
            value
          }
          value
          operation
          type
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getCouponTransaction = /* GraphQL */ `
  query GetCouponTransaction($id: ID!) {
    getCouponTransaction(id: $id) {
      id
      usedAt
      state
      amount
      quantity
      refundedAt
      orderId
      customerId
      couponTransactionCustomerId
      updatedAt
      createdAt
      expiredDate
      barcode
      generateLocationId
      generatedAt
      couponTransactionsId
      enterpriseId
      storeId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      providerTransactionId
      providerCustomerId
      providerShopNo
      name
      code
      type
      method
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      campaignId
      eventId
      startedAt
      endedAt
    }
  }
`;
export const listCouponTransactions = /* GraphQL */ `
  query ListCouponTransactions(
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByStore = /* GraphQL */ `
  query ListCouponTransactionsByStore(
    $storeId: ID
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByStore(
      storeId: $storeId
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByCouponStoreCustomer = /* GraphQL */ `
  query ListCouponTransactionsByCouponStoreCustomer(
    $couponTransactionsId: ID
    $couponTransactionCustomerId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByCouponStoreCustomer(
      couponTransactionsId: $couponTransactionsId
      couponTransactionCustomerId: $couponTransactionCustomerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByStoreBarcode = /* GraphQL */ `
  query ListCouponTransactionsByStoreBarcode(
    $storeId: ID
    $barcode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByStoreBarcode(
      storeId: $storeId
      barcode: $barcode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByStoreCoupon = /* GraphQL */ `
  query ListCouponTransactionsByStoreCoupon(
    $storeId: ID
    $couponTransactionsId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByStoreCoupon(
      storeId: $storeId
      couponTransactionsId: $couponTransactionsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByOrder = /* GraphQL */ `
  query ListCouponTransactionsByOrder(
    $orderId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByOrder(
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const listCouponTransactionsByStoreCustomerMethod = /* GraphQL */ `
  query ListCouponTransactionsByStoreCustomerMethod(
    $couponTransactionCustomerId: ID
    $method: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponTransactionsByStoreCustomerMethod(
      couponTransactionCustomerId: $couponTransactionCustomerId
      method: $method
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usedAt
        state
        amount
        quantity
        refundedAt
        orderId
        customerId
        couponTransactionCustomerId
        updatedAt
        createdAt
        expiredDate
        barcode
        generateLocationId
        generatedAt
        couponTransactionsId
        enterpriseId
        storeId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        providerTransactionId
        providerCustomerId
        providerShopNo
        name
        code
        type
        method
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        campaignId
        eventId
        startedAt
        endedAt
      }
      nextToken
    }
  }
`;
export const getCoupon = /* GraphQL */ `
  query GetCoupon($id: ID!) {
    getCoupon(id: $id) {
      id
      storeId
      enterpriseId
      locationId
      activeLocationIds
      inactiveLocationIds
      publishableLocationIds
      provider
      providerCouponId
      name
      description
      availableOrigins
      code
      type
      method
      tranCount
      generateCount
      publishCount
      limitPublishCount
      duplicatePublish
      conditionType
      conditionQuantity
      conditionAmount
      conditionItems
      conditionItemsOperator
      conditionTimes {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      conditionTier
      conditionMinAmount
      discountMethod
      discountValue
      applyScope
      applyItemId
      applyCandidateItemIds
      applyCandidateItemModels
      applyExcludeItemModels
      referId
      validDateType
      validValue
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      notice
      pointSavable
      startedAt
      endedAt
      updatedAt
      createdAt
      transactions {
        items {
          id
          usedAt
          state
          amount
          quantity
          refundedAt
          orderId
          customerId
          couponTransactionCustomerId
          updatedAt
          createdAt
          expiredDate
          barcode
          generateLocationId
          generatedAt
          couponTransactionsId
          enterpriseId
          storeId
          locationId
          activeLocationIds
          inactiveLocationIds
          publishableLocationIds
          provider
          providerCouponId
          providerTransactionId
          providerCustomerId
          providerShopNo
          name
          code
          type
          method
          conditionType
          conditionQuantity
          conditionAmount
          conditionItems
          conditionTimes {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          conditionTier
          conditionMinAmount
          discountMethod
          discountValue
          applyScope
          applyItemId
          applyCandidateItemIds
          applyCandidateItemModels
          applyExcludeItemModels
          campaignId
          eventId
          startedAt
          endedAt
        }
        nextToken
      }
    }
  }
`;
export const listCoupons = /* GraphQL */ `
  query ListCoupons(
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoupons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        enterpriseId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        name
        description
        availableOrigins
        code
        type
        method
        tranCount
        generateCount
        publishCount
        limitPublishCount
        duplicatePublish
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionItemsOperator
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        referId
        validDateType
        validValue
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        notice
        pointSavable
        startedAt
        endedAt
        updatedAt
        createdAt
        transactions {
          items {
            id
            usedAt
            state
            amount
            quantity
            refundedAt
            orderId
            customerId
            couponTransactionCustomerId
            updatedAt
            createdAt
            expiredDate
            barcode
            generateLocationId
            generatedAt
            couponTransactionsId
            enterpriseId
            storeId
            locationId
            activeLocationIds
            inactiveLocationIds
            publishableLocationIds
            provider
            providerCouponId
            providerTransactionId
            providerCustomerId
            providerShopNo
            name
            code
            type
            method
            conditionType
            conditionQuantity
            conditionAmount
            conditionItems
            conditionTimes {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            conditionTier
            conditionMinAmount
            discountMethod
            discountValue
            applyScope
            applyItemId
            applyCandidateItemIds
            applyCandidateItemModels
            applyExcludeItemModels
            campaignId
            eventId
            startedAt
            endedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCouponsByStore = /* GraphQL */ `
  query ListCouponsByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponsByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        enterpriseId
        locationId
        activeLocationIds
        inactiveLocationIds
        publishableLocationIds
        provider
        providerCouponId
        name
        description
        availableOrigins
        code
        type
        method
        tranCount
        generateCount
        publishCount
        limitPublishCount
        duplicatePublish
        conditionType
        conditionQuantity
        conditionAmount
        conditionItems
        conditionItemsOperator
        conditionTimes {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        conditionTier
        conditionMinAmount
        discountMethod
        discountValue
        applyScope
        applyItemId
        applyCandidateItemIds
        applyCandidateItemModels
        applyExcludeItemModels
        referId
        validDateType
        validValue
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        notice
        pointSavable
        startedAt
        endedAt
        updatedAt
        createdAt
        transactions {
          items {
            id
            usedAt
            state
            amount
            quantity
            refundedAt
            orderId
            customerId
            couponTransactionCustomerId
            updatedAt
            createdAt
            expiredDate
            barcode
            generateLocationId
            generatedAt
            couponTransactionsId
            enterpriseId
            storeId
            locationId
            activeLocationIds
            inactiveLocationIds
            publishableLocationIds
            provider
            providerCouponId
            providerTransactionId
            providerCustomerId
            providerShopNo
            name
            code
            type
            method
            conditionType
            conditionQuantity
            conditionAmount
            conditionItems
            conditionTimes {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            conditionTier
            conditionMinAmount
            discountMethod
            discountValue
            applyScope
            applyItemId
            applyCandidateItemIds
            applyCandidateItemModels
            applyExcludeItemModels
            campaignId
            eventId
            startedAt
            endedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getReviewCampaignResult = /* GraphQL */ `
  query GetReviewCampaignResult($id: ID!) {
    getReviewCampaignResult(id: $id) {
      id
      campaignId
      enterpriseId
      storeId
      locationId
      orderId
      orderNumberPrefix
      orderNumber
      customerId
      storeCustomerId
      reserveDate
      sentAt
      submittedAt
      rate
      comment
      answers
      updatedAt
      createdAt
    }
  }
`;
export const listReviewCampaignResults = /* GraphQL */ `
  query ListReviewCampaignResults(
    $filter: ModelReviewCampaignResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviewCampaignResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignId
        enterpriseId
        storeId
        locationId
        orderId
        orderNumberPrefix
        orderNumber
        customerId
        storeCustomerId
        reserveDate
        sentAt
        submittedAt
        rate
        comment
        answers
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getReviewCampaign = /* GraphQL */ `
  query GetReviewCampaign($id: ID!) {
    getReviewCampaign(id: $id) {
      id
      status
      enterpriseId
      storeId
      locationId
      name
      delay
      trial
      limit
      basic
      rewardPoint
      templateId
      templateName
      questions
      stats
      startedAt
      endedAt
      updatedAt
      createdAt
    }
  }
`;
export const listReviewCampaigns = /* GraphQL */ `
  query ListReviewCampaigns(
    $filter: ModelReviewCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviewCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        enterpriseId
        storeId
        locationId
        name
        delay
        trial
        limit
        basic
        rewardPoint
        templateId
        templateName
        questions
        stats
        startedAt
        endedAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getPurchaseOrder = /* GraphQL */ `
  query GetPurchaseOrder($id: ID!) {
    getPurchaseOrder(id: $id) {
      id
      number
      supplierId
      supplyingLocationId
      status
      supplierOrigin
      inventories {
        id
        inventoryId
        productId
        skuId
        quantity
        receivedQuantity
        waitingQuantity
        cancelledQuantity
        cost
        note
      }
      storeId
      locationId
      createdByEmployeeId
      createdLocationId
      note
      extraFees {
        id
        type
        value
        name
      }
      excludeVat
      expectDate
      confirmedAt
      receivedAt
      updatedAt
      createdAt
    }
  }
`;
export const listPurchaseOrders = /* GraphQL */ `
  query ListPurchaseOrders(
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        number
        supplierId
        supplyingLocationId
        status
        supplierOrigin
        inventories {
          id
          inventoryId
          productId
          skuId
          quantity
          receivedQuantity
          waitingQuantity
          cancelledQuantity
          cost
          note
        }
        storeId
        locationId
        createdByEmployeeId
        createdLocationId
        note
        extraFees {
          id
          type
          value
          name
        }
        excludeVat
        expectDate
        confirmedAt
        receivedAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPurchaseOrderByStore = /* GraphQL */ `
  query ListPurchaseOrderByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrderByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        supplierId
        supplyingLocationId
        status
        supplierOrigin
        inventories {
          id
          inventoryId
          productId
          skuId
          quantity
          receivedQuantity
          waitingQuantity
          cancelledQuantity
          cost
          note
        }
        storeId
        locationId
        createdByEmployeeId
        createdLocationId
        note
        extraFees {
          id
          type
          value
          name
        }
        excludeVat
        expectDate
        confirmedAt
        receivedAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listPurchaseOrderByLocation = /* GraphQL */ `
  query ListPurchaseOrderByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrderByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        supplierId
        supplyingLocationId
        status
        supplierOrigin
        inventories {
          id
          inventoryId
          productId
          skuId
          quantity
          receivedQuantity
          waitingQuantity
          cancelledQuantity
          cost
          note
        }
        storeId
        locationId
        createdByEmployeeId
        createdLocationId
        note
        extraFees {
          id
          type
          value
          name
        }
        excludeVat
        expectDate
        confirmedAt
        receivedAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getStoreSupplier = /* GraphQL */ `
  query GetStoreSupplier($id: ID!) {
    getStoreSupplier(id: $id) {
      id
      storeId
      name
      phone
      fax
      email
      note
      address
      updatedAt
      createdAt
    }
  }
`;
export const listStoreSuppliers = /* GraphQL */ `
  query ListStoreSuppliers(
    $filter: ModelStoreSupplierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        name
        phone
        fax
        email
        note
        address
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listStoreSupplierByStore = /* GraphQL */ `
  query ListStoreSupplierByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreSupplierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreSupplierByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        name
        phone
        fax
        email
        note
        address
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getItems = /* GraphQL */ `
  query GetItems($id: ID!) {
    getItems(id: $id) {
      id
      products {
        type
        id
        itemId
        name
        description
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        image
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        locationIds
      }
      productModifiers {
        productId
        modifierId
      }
      categoryProducts {
        categoryId
        productId
      }
      modifiers {
        type
        id
        itemId
        name
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        locationIds
      }
      categories {
        type
        id
        itemId
        name
        displayName
        locationIds
      }
      updatedAt
      createdAt
    }
  }
`;
export const listItemss = /* GraphQL */ `
  query ListItemss(
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        products {
          type
          id
          itemId
          name
          description
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          image
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          locationIds
        }
        productModifiers {
          productId
          modifierId
        }
        categoryProducts {
          categoryId
          productId
        }
        modifiers {
          type
          id
          itemId
          name
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          locationIds
        }
        categories {
          type
          id
          itemId
          name
          displayName
          locationIds
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getItemDelta = /* GraphQL */ `
  query GetItemDelta($id: ID!) {
    getItemDelta(id: $id) {
      id
      itemId
      type
      code
      enterpriseId
      storeId
      name
      nameMl {
        en
        zh
        ja
      }
      attributes {
        name
        type
        value
      }
      displayName
      displayNameMl {
        en
        zh
        ja
      }
      brandIds
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      active
      origin
      refer
      referId
      depth
      parentId
      parentCategoryId
      sortKey
      subCategoryProductDisplay
      description
      descriptionMl {
        en
        zh
        ja
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      variablePrice
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      ordering
      categoryIds
      classificationIds
      modifierIds
      productIds
      locationIds
      orderType
      defaultSkuId
      coverage
      required
      requiredQuantity
      limitQuantity
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listItemDeltas = /* GraphQL */ `
  query ListItemDeltas(
    $filter: ModelItemDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemDeltas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        itemId
        type
        code
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        attributes {
          name
          type
          value
        }
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        brandIds
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        active
        origin
        refer
        referId
        depth
        parentId
        parentCategoryId
        sortKey
        subCategoryProductDisplay
        description
        descriptionMl {
          en
          zh
          ja
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        variablePrice
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        ordering
        categoryIds
        classificationIds
        modifierIds
        productIds
        locationIds
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listItemDeltaByStore = /* GraphQL */ `
  query ListItemDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItemDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        itemId
        type
        code
        enterpriseId
        storeId
        name
        nameMl {
          en
          zh
          ja
        }
        attributes {
          name
          type
          value
        }
        displayName
        displayNameMl {
          en
          zh
          ja
        }
        brandIds
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        active
        origin
        refer
        referId
        depth
        parentId
        parentCategoryId
        sortKey
        subCategoryProductDisplay
        description
        descriptionMl {
          en
          zh
          ja
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        variablePrice
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        ordering
        categoryIds
        classificationIds
        modifierIds
        productIds
        locationIds
        orderType
        defaultSkuId
        coverage
        required
        requiredQuantity
        limitQuantity
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getLocationItemDelta = /* GraphQL */ `
  query GetLocationItemDelta($id: ID!) {
    getLocationItemDelta(id: $id) {
      id
      scope
      seqKey
      storeId
      locationId
      streamType
      seq
      deltaType
      entityId
      payload
      expiresAt
      updatedAt
      createdAt
    }
  }
`;
export const listLocationItemDeltas = /* GraphQL */ `
  query ListLocationItemDeltas(
    $filter: ModelLocationItemDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationItemDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scope
        seqKey
        storeId
        locationId
        streamType
        seq
        deltaType
        entityId
        payload
        expiresAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listLocationItemDeltaByScopeSeq = /* GraphQL */ `
  query ListLocationItemDeltaByScopeSeq(
    $scope: String
    $seqKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationItemDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationItemDeltaByScopeSeq(
      scope: $scope
      seqKey: $seqKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scope
        seqKey
        storeId
        locationId
        streamType
        seq
        deltaType
        entityId
        payload
        expiresAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocationItemManifest = /* GraphQL */ `
  query GetLocationItemManifest($id: ID!) {
    getLocationItemManifest(id: $id) {
      id
      storeId
      locationId
      lastSeq
      snapshot {
        version
        key
        etag
        size
        generatedAt
        seqAt
      }
      snapshotInProgress
      snapshotTargetSeq
      updatedAt
      createdAt
    }
  }
`;
export const listLocationItemManifests = /* GraphQL */ `
  query ListLocationItemManifests(
    $filter: ModelLocationItemManifestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationItemManifests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        lastSeq
        snapshot {
          version
          key
          etag
          size
          generatedAt
          seqAt
        }
        snapshotInProgress
        snapshotTargetSeq
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      type
      enterpriseId
      storeId
      origin
      refer
      referId
      name
      nameMl {
        en
        zh
        ja
      }
      description
      descriptionMl {
        en
        zh
        ja
      }
      available
      internalName
      relationProductIds
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      note
      model
      variablePrice
      attributes {
        name
        type
        value
      }
      thumbnail {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      skus {
        type
        id
        itemId
        refer
        referId
        attributes {
          name
          type
          value
        }
        name
        nameMl {
          en
          zh
          ja
        }
        price
        cost
        unit
        unitSuffix
        barcode
        currency
        model
        locationId
        futureLocationAvailable
        locationIds
        inventories {
          id
          quantity
          cost
          locationId
          unavailableQuantity
          inReadyQuantity
          outReadyQuantity
          expiryDate
          updatedAt
          createdAt
          locations {
            id
            quantity
          }
          attributes {
            name
            type
            value
          }
        }
        locations {
          id
          isActive
          available
          price
        }
        links {
          type
          origin
          originId
          originProductId
          quantity
          updatedAt
          createdAt
        }
        stock
        stockAlert
        stockAlertQty
        stockTrack
        stockControl
        quantity
        limitQuantity
        mergeable
        mergeMaxQuantity
        isActive
      }
      trackStock
      taxId
      categories {
        items {
          id
          enterpriseId
          storeId
          productId
          categoryId
          position
          category {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      classifications {
        items {
          id
          enterpriseId
          storeId
          productId
          classificationId
          classification {
            type
            id
            code
            enterpriseId
            storeId
            name
            displayName
            displayNameMl {
              en
              zh
              ja
            }
            depth
            parentCategoryId
            active
            refer
            referId
            sortKey
            subCategoryProductDisplay
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      modifiers {
        items {
          id
          enterpriseId
          storeId
          productId
          modifierId
          position
          modifier {
            id
            type
            enterpriseId
            storeId
            name
            nameMl {
              en
              zh
              ja
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            origin
            orderType
            defaultSkuId
            coverage
            required
            requiredQuantity
            limitQuantity
            products {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
          updatedAt
          createdAt
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        nextToken
      }
      locationIds
      updatedAt
      createdAt
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listProductsByStore = /* GraphQL */ `
  query ListProductsByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      name
      type
      code
      brand
      brandId
      provider
      address
      zip
      phone
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      representative
      businessNumber
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      businessHours {
        sun {
          open
          close
        }
        mon {
          open
          close
        }
        tue {
          open
          close
        }
        wed {
          open
          close
        }
        thu {
          open
          close
        }
        fri {
          open
          close
        }
        sat {
          open
          close
        }
      }
      storeId
      state
      menuPlanId
      payments {
        refund
        barcode
        barcodeVan
        barcodeTerminalId
      }
      policy {
        locationCost
        loyaltyCost
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mini {
        defaultItemName
      }
      orderPlanId
      menu {
        board {
          textSize
          columnSize
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          enableFavorite
        }
        list {
          pages {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          favorite {
            parentId
            badge
            type
            position
            activeOptions
          }
          shortcuts {
            type
            title
            itemName
            itemPrice
            active
          }
        }
        navOrder
      }
      menus {
        parentId
        position
        page
        pageTitle
      }
      favMenus {
        parentId
        position
        page
        pageTitle
      }
      catMenus {
        title
        index
        ids
        parentId
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      waiting {
        status
        waitingOptions {
          id
          type
          name
          nameMl {
            en
            zh
            ja
          }
          items {
            id
            name
            nameMl {
              en
              zh
              ja
            }
            limitQuantity
          }
          required
          updatedAt
          createdAt
        }
        waitingMinutes
        waitingMinutesHide
        hasForeigner
        foreignerMethod
        notifications {
          created
          ready
          requested
          cancelled
        }
        notices {
          createdNotice
          createdNoticeMl {
            en
            zh
            ja
          }
          requestedNotice
          requestedNoticeMl {
            en
            zh
            ja
          }
        }
        settings {
          autoCancel
          autoCancelMinutes
        }
        updatedAt
        createdAt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      tables {
        id
        width
        height
        name
        axisX
        axisY
        screenHeight
        screenWidth
        initialX
        initialY
        shape
        layout {
          x
          y
          w
          h
        }
        color
        orderId
        disabled
      }
      boardTables {
        title
        index
        items {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
      }
      gridTables {
        id
        name
        orderId
        index
        page
      }
      modifierSoldoutIds
      delivery {
        baemin
        coupang
        yogiyo
        enableGenProd
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
      sales {
        startedAt
        endedAt
        reserves
        actualBalance
        currency
        note
        estimateBalance
        detail {
          totalSales
          totalRefund
          totalTax
          totalDiscount
          supplyAmount
          totalSalesCount
          cash {
            sales
            refund
          }
          card {
            sales
            refund
          }
          credit {
            sales
            refund
          }
          barcode {
            sales
            refund
          }
          extra {
            sales
            refund
          }
          refund {
            sales
            refund
          }
          products {
            id
            name
            quantity
            amount
          }
          origins {
            pos
            kiosk
            menuorder
            delivery
            market
          }
        }
        reservesHistories {
          type
          amount
          note
          createdEmployeeId
          createdAt
        }
      }
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      nextToken
    }
  }
`;
export const listLocationsByStore = /* GraphQL */ `
  query ListLocationsByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      nextToken
    }
  }
`;
export const getBrand = /* GraphQL */ `
  query GetBrand($id: ID!) {
    getBrand(id: $id) {
      id
      storeId
      name
      code
      description
      logo {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      state
      phone
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      menuPlanId
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      order
      createdAt
      updatedAt
    }
  }
`;
export const listBrands = /* GraphQL */ `
  query ListBrands(
    $filter: ModelBrandFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        name
        code
        description
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        state
        phone
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        menuPlanId
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        order
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listBrandsByStore = /* GraphQL */ `
  query ListBrandsByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelBrandFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBrandsByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        name
        code
        description
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        state
        phone
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        menuPlanId
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        order
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductCodeRule = /* GraphQL */ `
  query GetProductCodeRule($id: ID!) {
    getProductCodeRule(id: $id) {
      id
      storeId
      name
      brandId
      productComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      optionComponents {
        componentType
        digit
        values {
          name
          code
        }
      }
      updatedAt
      createdAt
    }
  }
`;
export const listProductCodeRules = /* GraphQL */ `
  query ListProductCodeRules(
    $filter: ModelProductCodeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCodeRules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        name
        brandId
        productComponents {
          componentType
          digit
          values {
            name
            code
          }
        }
        optionComponents {
          componentType
          digit
          values {
            name
            code
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listProductCodeRulesByStore = /* GraphQL */ `
  query ListProductCodeRulesByStore(
    $storeId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProductCodeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCodeRulesByStore(
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        name
        brandId
        productComponents {
          componentType
          digit
          values {
            name
            code
          }
        }
        optionComponents {
          componentType
          digit
          values {
            name
            code
          }
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocationDeviceDelta = /* GraphQL */ `
  query GetLocationDeviceDelta($id: ID!) {
    getLocationDeviceDelta(id: $id) {
      id
      ident
      storeId
      locationId
      system
      ipAddress
      brand
      model
      name
      type
      deviceType
      display {
        height
        width
      }
      protocol
      images {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      barcodeReader
      appVersion
      sysVersion
      status
      password
      msgToken
      msgTokenStatus
      parentId
      childId
      sleepMode
      kioskOptions {
        mode
        isActive
        tableId
        orderId
        callable
        payable
        enableDiningOption
        resetTime
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        columnSize
      }
      menuOrderOptions {
        tableId
        orderId
      }
      terminalId
      orderOptions {
        cycleNumber
      }
      printOptions {
        port
        baudRate
        receipt
        receiptButtonHide
        storeNameHide
        bills
        refund
        salesEnd
        order
        orderBeep
        orderCount
        orderExcludeIds
        delivery
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listLocationDeviceDeltas = /* GraphQL */ `
  query ListLocationDeviceDeltas(
    $filter: ModelLocationDeviceDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationDeviceDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ident
        storeId
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        msgTokenStatus
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        menuOrderOptions {
          tableId
          orderId
        }
        terminalId
        orderOptions {
          cycleNumber
        }
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationDeviceDeltaByStore = /* GraphQL */ `
  query ListLocationDeviceDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationDeviceDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationDeviceDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ident
        storeId
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        msgTokenStatus
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        menuOrderOptions {
          tableId
          orderId
        }
        terminalId
        orderOptions {
          cycleNumber
        }
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationDeviceDeltaByLocation = /* GraphQL */ `
  query ListLocationDeviceDeltaByLocation(
    $locationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationDeviceDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationDeviceDeltaByLocation(
      locationId: $locationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ident
        storeId
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        msgTokenStatus
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        menuOrderOptions {
          tableId
          orderId
        }
        terminalId
        orderOptions {
          cycleNumber
        }
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationDeviceDeltaByIdent = /* GraphQL */ `
  query ListLocationDeviceDeltaByIdent(
    $ident: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLocationDeviceDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationDeviceDeltaByIdent(
      ident: $ident
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ident
        storeId
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        msgTokenStatus
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        menuOrderOptions {
          tableId
          orderId
        }
        terminalId
        orderOptions {
          cycleNumber
        }
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getBillingPolicy = /* GraphQL */ `
  query GetBillingPolicy($id: ID!) {
    getBillingPolicy(id: $id) {
      id
      exemption
      exemptionLocations
      marketBrokerageRate
      subscriptionBrokerageRate
      locationFee
      note
      updatedAt
      createdAt
    }
  }
`;
export const listBillingPolicys = /* GraphQL */ `
  query ListBillingPolicys(
    $filter: ModelBillingPolicyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBillingPolicys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        exemption
        exemptionLocations
        marketBrokerageRate
        subscriptionBrokerageRate
        locationFee
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getContractSubscriptionPlan = /* GraphQL */ `
  query GetContractSubscriptionPlan($id: ID!) {
    getContractSubscriptionPlan(id: $id) {
      id
      name
      type
      minCount
      maxCount
      price
      billingCycle
      yearDiscountRate
      updatedAt
      createdAt
    }
  }
`;
export const listContractSubscriptionPlans = /* GraphQL */ `
  query ListContractSubscriptionPlans(
    $filter: ModelContractSubscriptionPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContractSubscriptionPlans(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        minCount
        maxCount
        price
        billingCycle
        yearDiscountRate
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocationContract = /* GraphQL */ `
  query GetLocationContract($id: ID!) {
    getLocationContract(id: $id) {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      updatedAt
      createdAt
    }
  }
`;
export const listLocationContracts = /* GraphQL */ `
  query ListLocationContracts(
    $filter: ModelLocationContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationContracts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessOperatorId
        menuOrderExemptionQuantity
        menuOrderQuantity
        menuOrderStartedAt
        menuOrderRecurringType
        taxRefund
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listLocationContractByBusinessOperator = /* GraphQL */ `
  query ListLocationContractByBusinessOperator(
    $businessOperatorId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationContractByBusinessOperator(
      businessOperatorId: $businessOperatorId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessOperatorId
        menuOrderExemptionQuantity
        menuOrderQuantity
        menuOrderStartedAt
        menuOrderRecurringType
        taxRefund
        note
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getStoreContract = /* GraphQL */ `
  query GetStoreContract($id: ID!) {
    getStoreContract(id: $id) {
      id
      businessOperatorId
      menuOrderExemptionQuantity
      menuOrderQuantity
      menuOrderStartedAt
      menuOrderRecurringType
      taxRefund
      note
      cafe24
      imweb
      subscribed
      subscriptions {
        planId
        type
        status
        name
        billingCycle
        nextBillingCycle
        nextPlanId
        monthExtraPrice
        startedAt
        expiryDate
        canceledAt
        updatedAt
        createdAt
      }
      providerFee
      multiLocation
      locationFee
      locationFeeType
      locationFeeExemptionIds
      updatedAt
      createdAt
    }
  }
`;
export const listStoreContracts = /* GraphQL */ `
  query ListStoreContracts(
    $filter: ModelStoreContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        businessOperatorId
        menuOrderExemptionQuantity
        menuOrderQuantity
        menuOrderStartedAt
        menuOrderRecurringType
        taxRefund
        note
        cafe24
        imweb
        subscribed
        subscriptions {
          planId
          type
          status
          name
          billingCycle
          nextBillingCycle
          nextPlanId
          monthExtraPrice
          startedAt
          expiryDate
          canceledAt
          updatedAt
          createdAt
        }
        providerFee
        multiLocation
        locationFee
        locationFeeType
        locationFeeExemptionIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listStoreContractByBusinessOperator = /* GraphQL */ `
  query ListStoreContractByBusinessOperator(
    $businessOperatorId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreContractByBusinessOperator(
      businessOperatorId: $businessOperatorId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessOperatorId
        menuOrderExemptionQuantity
        menuOrderQuantity
        menuOrderStartedAt
        menuOrderRecurringType
        taxRefund
        note
        cafe24
        imweb
        subscribed
        subscriptions {
          planId
          type
          status
          name
          billingCycle
          nextBillingCycle
          nextPlanId
          monthExtraPrice
          startedAt
          expiryDate
          canceledAt
          updatedAt
          createdAt
        }
        providerFee
        multiLocation
        locationFee
        locationFeeType
        locationFeeExemptionIds
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getSubscriptionEvent = /* GraphQL */ `
  query GetSubscriptionEvent($id: ID!) {
    getSubscriptionEvent(id: $id) {
      id
      storeId
      locationId
      subscriptionId
      sessionId
      planId
      price
      amount
      currency
      type
      customerId
      storeCustomerId
      orderId
      orderNumberPrefix
      orderNumber
      startDate
      endDate
      updatedAt
      createdAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      plan {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const listSubscriptionEvents = /* GraphQL */ `
  query ListSubscriptionEvents(
    $filter: ModelSubscriptionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        subscriptionId
        sessionId
        planId
        price
        amount
        currency
        type
        customerId
        storeCustomerId
        orderId
        orderNumberPrefix
        orderNumber
        startDate
        endDate
        updatedAt
        createdAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        plan {
          id
          storeId
          productId
          skuId
          name
          recurringType
          recurringValue
          price
          quantity
          status
          image {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          gracePeriod
          subscriberCount
          locations {
            planId
            locationId
            available
            subscriberCount
          }
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listSubscriptionEventByCustomer = /* GraphQL */ `
  query ListSubscriptionEventByCustomer(
    $customerId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionEventByCustomer(
      customerId: $customerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        subscriptionId
        sessionId
        planId
        price
        amount
        currency
        type
        customerId
        storeCustomerId
        orderId
        orderNumberPrefix
        orderNumber
        startDate
        endDate
        updatedAt
        createdAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        plan {
          id
          storeId
          productId
          skuId
          name
          recurringType
          recurringValue
          price
          quantity
          status
          image {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          gracePeriod
          subscriberCount
          locations {
            planId
            locationId
            available
            subscriberCount
          }
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listSubscriptionEventBySession = /* GraphQL */ `
  query ListSubscriptionEventBySession(
    $sessionId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionEventBySession(
      sessionId: $sessionId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        subscriptionId
        sessionId
        planId
        price
        amount
        currency
        type
        customerId
        storeCustomerId
        orderId
        orderNumberPrefix
        orderNumber
        startDate
        endDate
        updatedAt
        createdAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        plan {
          id
          storeId
          productId
          skuId
          name
          recurringType
          recurringValue
          price
          quantity
          status
          image {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          gracePeriod
          subscriberCount
          locations {
            planId
            locationId
            available
            subscriberCount
          }
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listSubscriptionEventBySubscription = /* GraphQL */ `
  query ListSubscriptionEventBySubscription(
    $subscriptionId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionEventBySubscription(
      subscriptionId: $subscriptionId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        subscriptionId
        sessionId
        planId
        price
        amount
        currency
        type
        customerId
        storeCustomerId
        orderId
        orderNumberPrefix
        orderNumber
        startDate
        endDate
        updatedAt
        createdAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        plan {
          id
          storeId
          productId
          skuId
          name
          recurringType
          recurringValue
          price
          quantity
          status
          image {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          gracePeriod
          subscriberCount
          locations {
            planId
            locationId
            available
            subscriberCount
          }
          updatedAt
          createdAt
          _delta
          timestamp
          expdate
          product {
            id
            type
            enterpriseId
            storeId
            origin
            refer
            referId
            name
            nameMl {
              en
              zh
              ja
            }
            description
            descriptionMl {
              en
              zh
              ja
            }
            available
            internalName
            relationProductIds
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            note
            model
            variablePrice
            attributes {
              name
              type
              value
            }
            thumbnail {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            skus {
              type
              id
              itemId
              refer
              referId
              attributes {
                name
                type
                value
              }
              name
              nameMl {
                en
                zh
                ja
              }
              price
              cost
              unit
              unitSuffix
              barcode
              currency
              model
              locationId
              futureLocationAvailable
              locationIds
              inventories {
                id
                quantity
                cost
                locationId
                unavailableQuantity
                inReadyQuantity
                outReadyQuantity
                expiryDate
                updatedAt
                createdAt
              }
              locations {
                id
                isActive
                available
                price
              }
              links {
                type
                origin
                originId
                originProductId
                quantity
                updatedAt
                createdAt
              }
              stock
              stockAlert
              stockAlertQty
              stockTrack
              stockControl
              quantity
              limitQuantity
              mergeable
              mergeMaxQuantity
              isActive
            }
            trackStock
            taxId
            categories {
              items {
                id
                enterpriseId
                storeId
                productId
                categoryId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            classifications {
              items {
                id
                enterpriseId
                storeId
                productId
                classificationId
                updatedAt
                createdAt
              }
              nextToken
            }
            modifiers {
              items {
                id
                enterpriseId
                storeId
                productId
                modifierId
                position
                updatedAt
                createdAt
              }
              nextToken
            }
            locationIds
            updatedAt
            createdAt
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getSubscriptionPlanDelta = /* GraphQL */ `
  query GetSubscriptionPlanDelta($id: ID!) {
    getSubscriptionPlanDelta(id: $id) {
      id
      storeId
      productId
      skuId
      name
      recurringType
      recurringValue
      price
      quantity
      status
      image {
        key
        bucket
        region
        level
        url
        xsmall
        small
      }
      gracePeriod
      subscriberCount
      locations {
        planId
        locationId
        available
        subscriberCount
      }
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      product {
        id
        type
        enterpriseId
        storeId
        origin
        refer
        referId
        name
        nameMl {
          en
          zh
          ja
        }
        description
        descriptionMl {
          en
          zh
          ja
        }
        available
        internalName
        relationProductIds
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        note
        model
        variablePrice
        attributes {
          name
          type
          value
        }
        thumbnail {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        skus {
          type
          id
          itemId
          refer
          referId
          attributes {
            name
            type
            value
          }
          name
          nameMl {
            en
            zh
            ja
          }
          price
          cost
          unit
          unitSuffix
          barcode
          currency
          model
          locationId
          futureLocationAvailable
          locationIds
          inventories {
            id
            quantity
            cost
            locationId
            unavailableQuantity
            inReadyQuantity
            outReadyQuantity
            expiryDate
            updatedAt
            createdAt
            locations {
              id
              quantity
            }
            attributes {
              name
              type
              value
            }
          }
          locations {
            id
            isActive
            available
            price
          }
          links {
            type
            origin
            originId
            originProductId
            quantity
            updatedAt
            createdAt
          }
          stock
          stockAlert
          stockAlertQty
          stockTrack
          stockControl
          quantity
          limitQuantity
          mergeable
          mergeMaxQuantity
          isActive
        }
        trackStock
        taxId
        categories {
          items {
            id
            enterpriseId
            storeId
            productId
            categoryId
            position
            category {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        classifications {
          items {
            id
            enterpriseId
            storeId
            productId
            classificationId
            classification {
              type
              id
              code
              enterpriseId
              storeId
              name
              displayName
              displayNameMl {
                en
                zh
                ja
              }
              depth
              parentCategoryId
              active
              refer
              referId
              sortKey
              subCategoryProductDisplay
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        modifiers {
          items {
            id
            enterpriseId
            storeId
            productId
            modifierId
            position
            modifier {
              id
              type
              enterpriseId
              storeId
              name
              nameMl {
                en
                zh
                ja
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              origin
              orderType
              defaultSkuId
              coverage
              required
              requiredQuantity
              limitQuantity
              products {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
            updatedAt
            createdAt
            product {
              id
              type
              enterpriseId
              storeId
              origin
              refer
              referId
              name
              nameMl {
                en
                zh
                ja
              }
              description
              descriptionMl {
                en
                zh
                ja
              }
              available
              internalName
              relationProductIds
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              note
              model
              variablePrice
              attributes {
                name
                type
                value
              }
              thumbnail {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              skus {
                type
                id
                itemId
                refer
                referId
                name
                price
                cost
                unit
                unitSuffix
                barcode
                currency
                model
                locationId
                futureLocationAvailable
                locationIds
                stock
                stockAlert
                stockAlertQty
                stockTrack
                stockControl
                quantity
                limitQuantity
                mergeable
                mergeMaxQuantity
                isActive
              }
              trackStock
              taxId
              categories {
                nextToken
              }
              classifications {
                nextToken
              }
              modifiers {
                nextToken
              }
              locationIds
              updatedAt
              createdAt
            }
          }
          nextToken
        }
        locationIds
        updatedAt
        createdAt
      }
    }
  }
`;
export const listSubscriptionPlanDeltas = /* GraphQL */ `
  query ListSubscriptionPlanDeltas(
    $filter: ModelSubscriptionPlanDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionPlanDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const listSubscriptionPlanDeltaByStore = /* GraphQL */ `
  query ListSubscriptionPlanDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionPlanDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionPlanDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        productId
        skuId
        name
        recurringType
        recurringValue
        price
        quantity
        status
        image {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        gracePeriod
        subscriberCount
        locations {
          planId
          locationId
          available
          subscriberCount
        }
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        product {
          id
          type
          enterpriseId
          storeId
          origin
          refer
          referId
          name
          nameMl {
            en
            zh
            ja
          }
          description
          descriptionMl {
            en
            zh
            ja
          }
          available
          internalName
          relationProductIds
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          note
          model
          variablePrice
          attributes {
            name
            type
            value
          }
          thumbnail {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          skus {
            type
            id
            itemId
            refer
            referId
            attributes {
              name
              type
              value
            }
            name
            nameMl {
              en
              zh
              ja
            }
            price
            cost
            unit
            unitSuffix
            barcode
            currency
            model
            locationId
            futureLocationAvailable
            locationIds
            inventories {
              id
              quantity
              cost
              locationId
              unavailableQuantity
              inReadyQuantity
              outReadyQuantity
              expiryDate
              updatedAt
              createdAt
              locations {
                id
                quantity
              }
              attributes {
                name
                type
                value
              }
            }
            locations {
              id
              isActive
              available
              price
            }
            links {
              type
              origin
              originId
              originProductId
              quantity
              updatedAt
              createdAt
            }
            stock
            stockAlert
            stockAlertQty
            stockTrack
            stockControl
            quantity
            limitQuantity
            mergeable
            mergeMaxQuantity
            isActive
          }
          trackStock
          taxId
          categories {
            items {
              id
              enterpriseId
              storeId
              productId
              categoryId
              position
              category {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          classifications {
            items {
              id
              enterpriseId
              storeId
              productId
              classificationId
              classification {
                type
                id
                code
                enterpriseId
                storeId
                name
                displayName
                depth
                parentCategoryId
                active
                refer
                referId
                sortKey
                subCategoryProductDisplay
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          modifiers {
            items {
              id
              enterpriseId
              storeId
              productId
              modifierId
              position
              modifier {
                id
                type
                enterpriseId
                storeId
                name
                origin
                orderType
                defaultSkuId
                coverage
                required
                requiredQuantity
                limitQuantity
                locationIds
                updatedAt
                createdAt
              }
              updatedAt
              createdAt
              product {
                id
                type
                enterpriseId
                storeId
                origin
                refer
                referId
                name
                description
                available
                internalName
                relationProductIds
                note
                model
                variablePrice
                trackStock
                taxId
                locationIds
                updatedAt
                createdAt
              }
            }
            nextToken
          }
          locationIds
          updatedAt
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getStoreCreditTransaction = /* GraphQL */ `
  query GetStoreCreditTransaction($id: ID!) {
    getStoreCreditTransaction(id: $id) {
      id
      type
      origin
      method
      storeId
      locationId
      referId
      name
      quantity
      price
      amount
      currency
      createdAt
      updatedAt
    }
  }
`;
export const listStoreCreditTransactions = /* GraphQL */ `
  query ListStoreCreditTransactions(
    $filter: ModelStoreCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCreditTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        origin
        method
        storeId
        locationId
        referId
        name
        quantity
        price
        amount
        currency
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listStoreCreditTransactionByStore = /* GraphQL */ `
  query ListStoreCreditTransactionByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCreditTransactionByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        origin
        method
        storeId
        locationId
        referId
        name
        quantity
        price
        amount
        currency
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listStoreCreditTransactionByLocation = /* GraphQL */ `
  query ListStoreCreditTransactionByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreCreditTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCreditTransactionByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        origin
        method
        storeId
        locationId
        referId
        name
        quantity
        price
        amount
        currency
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStore = /* GraphQL */ `
  query GetStore($id: ID!) {
    getStore(id: $id) {
      id
      enterpriseId
      info {
        name
        phone
        email
        representative
        businessType
        businessNumber
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        industryType
        sendNumber
        currency
        address
        zip
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        csPhone
      }
      policy {
        multiLocation
        provider {
          key
          ident
          customer
          customerQr
          coupon
          inventory
          inventoryLocationId
          locationId
          userId
          userPassword
          shopMap {
            storeId
            shopNo
            name
            originName
            countryCode
            usableCouponIds
            currencyCode
            tiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
        }
      }
      currency
      payments {
        card
        cardJoined
        cash
        credit
        refund
      }
      devices {
        id
        ident
        locationId
        system
        ipAddress
        brand
        model
        name
        type
        deviceType
        display {
          height
          width
        }
        protocol
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        barcodeReader
        appVersion
        sysVersion
        status
        password
        msgToken
        parentId
        childId
        sleepMode
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        terminalId
        printOptions {
          port
          baudRate
          receipt
          receiptButtonHide
          storeNameHide
          bills
          refund
          salesEnd
          order
          orderBeep
          orderCount
          orderExcludeIds
          delivery
        }
        updatedAt
        createdAt
      }
      plans {
        menus {
          id
          name
          mode
          size
          menus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          pages {
            index
            parentId
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            title
            titleMl {
              en
              zh
              ja
            }
          }
          updatedAt
          createdAt
        }
        orders {
          id
          name
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          updatedAt
          createdAt
        }
      }
      taxes {
        id
        type
        name
        enabled
        rate
        method
        targetType
      }
      receipt {
        salesSlip
        orderList
        barcode
        footnote
        phone
        orderNumberHide
        storeNameHide
        orderSheetFontSize
        billsBusinessInfo
        giftFootnote
        giftReceipt
        enReceipt
      }
      subscription {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        updatedAt
        createdAt
      }
      view {
        order {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
        itemReport {
          excludeColumns
        }
        summaryReport {
          excludeColumns
        }
        shippingOrder {
          excludeColumns
        }
        trsItemReport {
          excludeColumns
        }
        customReport {
          excludeColumns
          exportTemplates {
            name
            type
            headers {
              key
              label
            }
          }
        }
      }
      settings {
        mode
        table
        diningOption
        retailOption
        orderAlarm
        orderConfirm
        addressInput
        autoPay
        autoReturnItem
        autoSoldout
        menuGridSize
        menuMode
        tableMode
        orderNotify
        orderNotifySkippable
        disablePhonePrefix
        autoCloseScreen
        orderNumberPrefix {
          pos
          kiosk
          menuOrder
        }
        orderMgmt {
          kiosk
          menuorder
          delivery
          pos
        }
        reportBasis
        orderOrigins
        beeper {
          active
          coverage
          skippable
        }
        kioskOptions {
          mode
          isActive
          tableId
          orderId
          callable
          payable
          enableDiningOption
          resetTime
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          columnSize
        }
        customerOptions {
          countries
          ages
          gender
        }
      }
      item {
        attributes {
          name
          type
          value
        }
        actualPrice
        skuMgmt
        barcodeMgmt
        stockTrack
        variablePrice
        locationCreatable
      }
      inventory {
        attributes {
          name
          type
          value
        }
        expiryDateMgmt
        expiryDateAlertDays
        hqWhExposureEnabled
        hqWhExposureLocIds
        hqWhUnexposureLocIds
        customAdjustDateEnabled
      }
      customer {
        attributes {
          name
          type
          value
        }
      }
      billing {
        key
        businessNumber
        name
        email
        phone
        contanctName
        contactName
        address
        zip
        card {
          pg
          number
          name
          expMonth
          expYear
          identify
          password
          billingKey
        }
      }
      credit {
        autoCharge
        autoChargeCredit
        autoChargeQuantity
        alertCredit
      }
      kakao {
        agency
        key
        channelId
        categoryCode
        status
        updatedAt
        createdAt
      }
      review {
        status
        campaignId
        updatedAt
        createdAt
      }
      kiosk {
        status
        callable
        payable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        exchangeTicket
        columnSize
        discounts {
          condition
          couponId
        }
        menuDescription
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        titles
        titlePosition
        updatedAt
        createdAt
      }
      menuOrder {
        callOptions {
          index
          label
        }
        orderable
        menus {
          title
          titleMl {
            en
            zh
            ja
          }
          index
          ids
          items {
            parentId
            badge
            type
            position
            activeOptions
          }
          parentId
        }
        multilingual
        displayImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        columnSize
        fontSize
        notice
        resetTime
        enableCash
        boardType
      }
      kds {
        layout
        alerts {
          urgent
          warning
        }
        disabledProdIds
        orderNotify
      }
      mirror {
        images {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        video {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorImages {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        mirrorVideo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        methods
        multilingual
        layout
        featuredPosition
        titles
        pointTitleIndexs
        textColor
        pointColor
        displayColor
        featuredColor
        featuredImage {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
      }
      loyalty {
        status
        provider
        sharePolicy
        type
        grade
        conditionType
        conditionSubType
        condition {
          minAmount
          perAmount
          minTime
          rate
          expirationPeriod
          excludeProdIds
          excludeLocIds
          discountPointSavable
        }
        conditionItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        conditionTiers {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardType
        rewardSubType
        reward {
          requirePoint
          requireOrderAmount
          minUsePoint
          minRequireRate
          maxUsePoint
        }
        rewardItems {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardRates {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardAmounts {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCashs {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardCoupons {
          id
          itemId
          name
          parentId
          rate
          point
          amount
        }
        rewardDelayDays
        rewardDelayIssueTime
        incentives {
          fulfill
          fulfillPoint
          fulfillCampaignId
          birth
          birthPoint
          birthCampaignId
          birthItem {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
        }
        notification {
          register
          registerCampainId
          save
          saveCampaignId
          use
          useCampaignId
          expire
          expireCampaignId
        }
      }
      market {
        status
        account {
          ident
          holder
          bank
          bankCode
          number
          businessNumber
        }
        paused
        takeoutDiscount
        creditDiscount
        takeout
        intro
        notice
        bookTable
        bookTableNote
        depositAmount
        delivery
        deliveryFee {
          start
          end
          fee
        }
        waitingTime
        itemIds
        updatedAt
        createdAt
      }
      notification {
        options {
          type
          email
          sms
        }
      }
      groups {
        items {
          id
          name
          type
          storeGroupsId
          locationGroupsId
          key
          conditions {
            key
            object
            field
            operations {
              operation
              type
              value
            }
            value
            operation
            type
          }
          count
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      locations {
        items {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const listStores = /* GraphQL */ `
  query ListStores(
    $filter: ModelStoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getShippingConfig = /* GraphQL */ `
  query GetShippingConfig($id: ID!) {
    getShippingConfig(id: $id) {
      id
      storeId
      brandId
      senderLocationId
      returnLocationId
      stockLimitedPrint
      reprintWarning
      overflowItemMode
      printSortKeys
      provisionEnabled
      batchShipEnabled
      carrierId
      unusedWaybillAlertDays
      createdAt
      updatedAt
    }
  }
`;
export const listShippingConfigs = /* GraphQL */ `
  query ListShippingConfigs(
    $filter: ModelShippingConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippingConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        brandId
        senderLocationId
        returnLocationId
        stockLimitedPrint
        reprintWarning
        overflowItemMode
        printSortKeys
        provisionEnabled
        batchShipEnabled
        carrierId
        unusedWaybillAlertDays
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listShippingConfigByStore = /* GraphQL */ `
  query ListShippingConfigByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShippingConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippingConfigByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        brandId
        senderLocationId
        returnLocationId
        stockLimitedPrint
        reprintWarning
        overflowItemMode
        printSortKeys
        provisionEnabled
        batchShipEnabled
        carrierId
        unusedWaybillAlertDays
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrier = /* GraphQL */ `
  query GetCarrier($id: ID!) {
    getCarrier(id: $id) {
      id
      storeId
      code
      name
      enabled
      credentials
      prepaidContract
      templates {
        id
        name
        carrierCode
        paperType
        isDefault
        offsetX
        offsetY
        logoUrl
        fixedText
        giftMark {
          enabled
          text
          position
        }
        itemLineNumber {
          enabled
          format
        }
        maxItemRows
        emphasizeMultiQty
        mergeSameItemQty
        splitLineByProduct
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCarriers = /* GraphQL */ `
  query ListCarriers(
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        code
        name
        enabled
        credentials
        prepaidContract
        templates {
          id
          name
          carrierCode
          paperType
          isDefault
          offsetX
          offsetY
          logoUrl
          fixedText
          giftMark {
            enabled
            text
            position
          }
          itemLineNumber {
            enabled
            format
          }
          maxItemRows
          emphasizeMultiQty
          mergeSameItemQty
          splitLineByProduct
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCarrierByStore = /* GraphQL */ `
  query ListCarrierByStore(
    $storeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierByStore(
      storeId: $storeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        code
        name
        enabled
        credentials
        prepaidContract
        templates {
          id
          name
          carrierCode
          paperType
          isDefault
          offsetX
          offsetY
          logoUrl
          fixedText
          giftMark {
            enabled
            text
            position
          }
          itemLineNumber {
            enabled
            format
          }
          maxItemRows
          emphasizeMultiQty
          mergeSameItemQty
          splitLineByProduct
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierToken = /* GraphQL */ `
  query GetCarrierToken($id: ID!) {
    getCarrierToken(id: $id) {
      id
      token
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierTokens = /* GraphQL */ `
  query ListCarrierTokens(
    $filter: ModelCarrierTokenFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierTokens(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        token
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStoreStatus = /* GraphQL */ `
  query GetStoreStatus($id: ID!) {
    getStoreStatus(id: $id) {
      id
      item {
        func
        progress
        errorMessage
        updatedAt
        createdAt
      }
      updatedAt
      createdAt
    }
  }
`;
export const listStoreStatuss = /* GraphQL */ `
  query ListStoreStatuss(
    $filter: ModelStoreStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreStatuss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        item {
          func
          progress
          errorMessage
          updatedAt
          createdAt
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getRequestProgressEvent = /* GraphQL */ `
  query GetRequestProgressEvent($id: ID!) {
    getRequestProgressEvent(id: $id) {
      id
      origin
      originId
      func
      params
      status
      progress
      errorMessage
      doneAt
      updatedAt
      createdAt
    }
  }
`;
export const listRequestProgressEvents = /* GraphQL */ `
  query ListRequestProgressEvents(
    $filter: ModelRequestProgressEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequestProgressEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        origin
        originId
        func
        params
        status
        progress
        errorMessage
        doneAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listRequestProgressEventByOrigin = /* GraphQL */ `
  query ListRequestProgressEventByOrigin(
    $originId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRequestProgressEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequestProgressEventByOrigin(
      originId: $originId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        origin
        originId
        func
        params
        status
        progress
        errorMessage
        doneAt
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getLocationStats = /* GraphQL */ `
  query GetLocationStats($id: ID!) {
    getLocationStats(id: $id) {
      id
      sales {
        date
        yesterday
        today
        thisMonthCount
      }
      updatedAt
      createdAt
    }
  }
`;
export const listLocationStatss = /* GraphQL */ `
  query ListLocationStatss(
    $filter: ModelLocationStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationStatss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sales {
          date
          yesterday
          today
          thisMonthCount
        }
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getBusinessOperator = /* GraphQL */ `
  query GetBusinessOperator($id: ID!) {
    getBusinessOperator(id: $id) {
      id
      businessNumber
      name
      createdAt
      updatedAt
    }
  }
`;
export const listBusinessOperators = /* GraphQL */ `
  query ListBusinessOperators(
    $filter: ModelBusinessOperatorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBusinessOperators(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessNumber
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStoreCustomer = /* GraphQL */ `
  query GetStoreCustomer($id: ID!) {
    getStoreCustomer(id: $id) {
      id
      customerId
      storeId
      sources {
        id
        type
        name
        ident
        createdAt
      }
      isFavorite
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      status
      registeredAt
      campaignBlockedAt
      note
      removedAt
      updatedAt
      createdAt
      points {
        items {
          id
          locationId
          storeId
          type
          name
          method
          amount
          origin
          provider
          providerCustomerId
          providerShopNo
          providerSyncedAt
          currency
          point
          extraPoint
          extraExpire
          items {
            type
            itemId
            name
            parentId
            point
            amount
            quantity
          }
          quantity
          note
          orderId
          referId
          orderNumberPrefix
          orderNumber
          customerId
          pointTransactionCustomerId
          expiredAt
          salesDate
          eventId
          updatedAt
          createdAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      credits {
        items {
          id
          locationId
          storeId
          name
          type
          amount
          origin
          note
          currency
          parentId
          orderId
          orderNumberPrefix
          orderNumber
          customerId
          creditTransactionCustomerId
          description
          salesDate
          createdAt
          updatedAt
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
        }
        nextToken
      }
      _delta
      orders {
        items {
          id
          orderLocationId
          numberPrefix
          number
          beeper
          enterpriseId
          storeId
          customerId
          orderCustomerId
          state
          amount
          amountPaid
          origin
          subOrigin
          originId
          customerProvider
          providerCustomerId
          customerProviderShopNo
          amountChanged
          amountReturned
          tax
          currency
          quantity
          shippingType
          diningOption
          diningState
          retailOption
          retailState
          mergeGroupId
          mergeBlocked
          deliveredAt
          name
          phone
          address
          zip
          customerGender
          customerAge
          customerCountry
          receivers {
            id
            type
            shipmentSeq
            provision
            name
            phone
            zip
            address1
            address2
            addressState
            addressCity
            addressStreet
            addressFull
            note
            shippingCompanyCode
            shippingAcceptCount
            shippingStartCount
            trackingNumber
            providerShippingId
            providerSyncStatus
            providerSyncError
            providerSyncedAt
            issuedAt
            privacyAgreedAt
            waybillMeta
          }
          tableId
          tableIds
          parentDeviceId
          deviceId
          reserveDate
          pickupDate
          shippingDate
          items {
            id
            type
            index
            category
            categories {
              id
              name
            }
            classificationIds
            productId
            modifierId
            name
            description
            amount
            price
            parentId
            providerProductId
            providerOptionId
            providerProductName
            providerOptionName
            matchType
            matchedQuantity
            receiverId
            shippingLocationId
            returnShippingLocationId
            referType
            referId
            campaignId
            eventId
            requestId
            quantity
            sku
            tax
            taxRate
            diningOption
            diningState
            retailOption
            retailState
            confirmedAt
            shippedAt
            deliveredAt
            modifiers {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            discounts {
              id
              scope
              type
              amount
              name
            }
            discountable
            discountQuantity
            discountIncludeIds
            discountExcludeIds
            discountMethod
            discountValue
            orderedQuantity
            voidQuantity
            paidQuantity
            readyQuantity
            receivedQuantity
            inventoryReason
            point
            note
            salesDate
            createdAt
          }
          createdEmployeeId
          createdDeviceId
          updatedDeviceId
          shippingLocationId
          returnShippingLocationId
          confirmedEmployeeId
          importedAt
          confirmedAt
          createdAt
          paidAt
          salesDate
          returnedAt
          reopenedAt
          shippedAt
          returnShippedAt
          returnSalesDate
          updatedAt
          noticeCount
          visitorCount
          totalPoint
          pointSaved
          receiptId
          receiptNumber
          receiptCount
          alarmCustomerId
          receiptCustomerId
          note
          request
          charges {
            id
            method
            extraMethod
            gateway
            amount
            tax
            taxRefundAmount
            purchaser {
              name
              number
              nation
              gender
              birth
              address
            }
            supplyAmount
            taxFreeAmount
            amountRefunded
            createdEmployeeId
            createdDeviceId
            salesDate
            createdAt
            creditTransactionId
            balance
            splitType
            pg
            van
            origin
            originId
            note
            brand
            name
            ident
            installment
            transactionId
            approver
            issuerCode
            acquirer
            acquirerCode
            acquirerName
            refundable
            recurring
            approvalCode
            approvalDate
            approvalNumber
            signature {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            terminalId
            refunds {
              id
              amount
              supplyAmount
              taxFreeAmount
              tax
              taxRefundAmount
              creditTransactionId
              approvalNumber
              approvalDate
              transactionId
              origin
              originId
              currency
              reason
              bankCode
              bankName
              bankAccountNo
              bankAccountHolder
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              createdEmployeeId
              createdDeviceId
              terminalId
              salesDate
              createdAt
            }
          }
          exchanges {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            chargeIds
            providerClaimId
            salesDate
            createdAt
          }
          returns {
            exchangeGroupId
            amount
            currency
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            refundId
            refundIds
            providerClaimId
            receiverId
            shippingFee
            shippingPayType
            settled
            settledAt
            salesDate
            createdAt
          }
          fee
          revision
          _delta
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          customer {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          orderCustomer {
            id
            enterpriseId
            storeId
            locationId
            customerId
            provider
            providerCustomerId
            shopNo
            tier
            tierId
            customerCreatedAt
            ident
            identType
            type
            name
            nameKeyword
            payments {
              id
              method
              pg
              number
              name
              expMonth
              expYear
              billingKey
              updatedAt
              createdAt
            }
            attributes {
              name
              type
              value
            }
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            tags {
              tagId
              createdLocationId
            }
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            status
            registeredAt
            salesDate
            campaignBlockedAt
            blacklistedAt
            isFavorite
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            note
            sources {
              id
              type
              name
              ident
              createdAt
            }
            removedAt
            updatedAt
            createdAt
            _delta
            timestamp
            expdate
          }
        }
        nextToken
      }
      location {
        id
        name
        type
        code
        brand
        brandId
        provider
        address
        zip
        phone
        logo {
          key
          bucket
          region
          level
          url
          xsmall
          small
        }
        representative
        businessNumber
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        businessHours {
          sun {
            open
            close
          }
          mon {
            open
            close
          }
          tue {
            open
            close
          }
          wed {
            open
            close
          }
          thu {
            open
            close
          }
          fri {
            open
            close
          }
          sat {
            open
            close
          }
        }
        storeId
        state
        menuPlanId
        payments {
          refund
          barcode
          barcodeVan
          barcodeTerminalId
        }
        policy {
          locationCost
          loyaltyCost
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mini {
          defaultItemName
        }
        orderPlanId
        menu {
          board {
            textSize
            columnSize
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            enableFavorite
          }
          list {
            pages {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            favorite {
              parentId
              badge
              type
              position
              activeOptions
            }
            shortcuts {
              type
              title
              itemName
              itemPrice
              active
            }
          }
          navOrder
        }
        menus {
          parentId
          position
          page
          pageTitle
        }
        favMenus {
          parentId
          position
          page
          pageTitle
        }
        catMenus {
          title
          index
          ids
          parentId
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        waiting {
          status
          waitingOptions {
            id
            type
            name
            nameMl {
              en
              zh
              ja
            }
            items {
              id
              name
              nameMl {
                en
                zh
                ja
              }
              limitQuantity
            }
            required
            updatedAt
            createdAt
          }
          waitingMinutes
          waitingMinutesHide
          hasForeigner
          foreignerMethod
          notifications {
            created
            ready
            requested
            cancelled
          }
          notices {
            createdNotice
            createdNoticeMl {
              en
              zh
              ja
            }
            requestedNotice
            requestedNoticeMl {
              en
              zh
              ja
            }
          }
          settings {
            autoCancel
            autoCancelMinutes
          }
          updatedAt
          createdAt
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        tables {
          id
          width
          height
          name
          axisX
          axisY
          screenHeight
          screenWidth
          initialX
          initialY
          shape
          layout {
            x
            y
            w
            h
          }
          color
          orderId
          disabled
        }
        boardTables {
          title
          index
          items {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
        }
        gridTables {
          id
          name
          orderId
          index
          page
        }
        modifierSoldoutIds
        delivery {
          baemin
          coupang
          yogiyo
          enableGenProd
          updatedAt
          createdAt
        }
        createdAt
        updatedAt
        sales {
          startedAt
          endedAt
          reserves
          actualBalance
          currency
          note
          estimateBalance
          detail {
            totalSales
            totalRefund
            totalTax
            totalDiscount
            supplyAmount
            totalSalesCount
            cash {
              sales
              refund
            }
            card {
              sales
              refund
            }
            credit {
              sales
              refund
            }
            barcode {
              sales
              refund
            }
            extra {
              sales
              refund
            }
            refund {
              sales
              refund
            }
            products {
              id
              name
              quantity
              amount
            }
            origins {
              pos
              kiosk
              menuorder
              delivery
              market
            }
          }
          reservesHistories {
            type
            amount
            note
            createdEmployeeId
            createdAt
          }
        }
      }
      store {
        id
        enterpriseId
        info {
          name
          phone
          email
          representative
          businessType
          businessNumber
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          industryType
          sendNumber
          currency
          address
          zip
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          csPhone
        }
        policy {
          multiLocation
          provider {
            key
            ident
            customer
            customerQr
            coupon
            inventory
            inventoryLocationId
            locationId
            userId
            userPassword
            shopMap {
              storeId
              shopNo
              name
              originName
              countryCode
              usableCouponIds
              currencyCode
              tiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
          }
        }
        currency
        payments {
          card
          cardJoined
          cash
          credit
          refund
        }
        devices {
          id
          ident
          locationId
          system
          ipAddress
          brand
          model
          name
          type
          deviceType
          display {
            height
            width
          }
          protocol
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          barcodeReader
          appVersion
          sysVersion
          status
          password
          msgToken
          parentId
          childId
          sleepMode
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          terminalId
          printOptions {
            port
            baudRate
            receipt
            receiptButtonHide
            storeNameHide
            bills
            refund
            salesEnd
            order
            orderBeep
            orderCount
            orderExcludeIds
            delivery
          }
          updatedAt
          createdAt
        }
        plans {
          menus {
            id
            name
            mode
            size
            menus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            pages {
              index
              parentId
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              title
              titleMl {
                en
                zh
                ja
              }
            }
            updatedAt
            createdAt
          }
          orders {
            id
            name
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            updatedAt
            createdAt
          }
        }
        taxes {
          id
          type
          name
          enabled
          rate
          method
          targetType
        }
        receipt {
          salesSlip
          orderList
          barcode
          footnote
          phone
          orderNumberHide
          storeNameHide
          orderSheetFontSize
          billsBusinessInfo
          giftFootnote
          giftReceipt
          enReceipt
        }
        subscription {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          updatedAt
          createdAt
        }
        view {
          order {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
          itemReport {
            excludeColumns
          }
          summaryReport {
            excludeColumns
          }
          shippingOrder {
            excludeColumns
          }
          trsItemReport {
            excludeColumns
          }
          customReport {
            excludeColumns
            exportTemplates {
              name
              type
              headers {
                key
                label
              }
            }
          }
        }
        settings {
          mode
          table
          diningOption
          retailOption
          orderAlarm
          orderConfirm
          addressInput
          autoPay
          autoReturnItem
          autoSoldout
          menuGridSize
          menuMode
          tableMode
          orderNotify
          orderNotifySkippable
          disablePhonePrefix
          autoCloseScreen
          orderNumberPrefix {
            pos
            kiosk
            menuOrder
          }
          orderMgmt {
            kiosk
            menuorder
            delivery
            pos
          }
          reportBasis
          orderOrigins
          beeper {
            active
            coverage
            skippable
          }
          kioskOptions {
            mode
            isActive
            tableId
            orderId
            callable
            payable
            enableDiningOption
            resetTime
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            columnSize
          }
          customerOptions {
            countries
            ages
            gender
          }
        }
        item {
          attributes {
            name
            type
            value
          }
          actualPrice
          skuMgmt
          barcodeMgmt
          stockTrack
          variablePrice
          locationCreatable
        }
        inventory {
          attributes {
            name
            type
            value
          }
          expiryDateMgmt
          expiryDateAlertDays
          hqWhExposureEnabled
          hqWhExposureLocIds
          hqWhUnexposureLocIds
          customAdjustDateEnabled
        }
        customer {
          attributes {
            name
            type
            value
          }
        }
        billing {
          key
          businessNumber
          name
          email
          phone
          contanctName
          contactName
          address
          zip
          card {
            pg
            number
            name
            expMonth
            expYear
            identify
            password
            billingKey
          }
        }
        credit {
          autoCharge
          autoChargeCredit
          autoChargeQuantity
          alertCredit
        }
        kakao {
          agency
          key
          channelId
          categoryCode
          status
          updatedAt
          createdAt
        }
        review {
          status
          campaignId
          updatedAt
          createdAt
        }
        kiosk {
          status
          callable
          payable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          exchangeTicket
          columnSize
          discounts {
            condition
            couponId
          }
          menuDescription
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          titles
          titlePosition
          updatedAt
          createdAt
        }
        menuOrder {
          callOptions {
            index
            label
          }
          orderable
          menus {
            title
            titleMl {
              en
              zh
              ja
            }
            index
            ids
            items {
              parentId
              badge
              type
              position
              activeOptions
            }
            parentId
          }
          multilingual
          displayImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          columnSize
          fontSize
          notice
          resetTime
          enableCash
          boardType
        }
        kds {
          layout
          alerts {
            urgent
            warning
          }
          disabledProdIds
          orderNotify
        }
        mirror {
          images {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          video {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorImages {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          mirrorVideo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          methods
          multilingual
          layout
          featuredPosition
          titles
          pointTitleIndexs
          textColor
          pointColor
          displayColor
          featuredColor
          featuredImage {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
        }
        loyalty {
          status
          provider
          sharePolicy
          type
          grade
          conditionType
          conditionSubType
          condition {
            minAmount
            perAmount
            minTime
            rate
            expirationPeriod
            excludeProdIds
            excludeLocIds
            discountPointSavable
          }
          conditionItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          conditionTiers {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardType
          rewardSubType
          reward {
            requirePoint
            requireOrderAmount
            minUsePoint
            minRequireRate
            maxUsePoint
          }
          rewardItems {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardRates {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardAmounts {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCashs {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardCoupons {
            id
            itemId
            name
            parentId
            rate
            point
            amount
          }
          rewardDelayDays
          rewardDelayIssueTime
          incentives {
            fulfill
            fulfillPoint
            fulfillCampaignId
            birth
            birthPoint
            birthCampaignId
            birthItem {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
          }
          notification {
            register
            registerCampainId
            save
            saveCampaignId
            use
            useCampaignId
            expire
            expireCampaignId
          }
        }
        market {
          status
          account {
            ident
            holder
            bank
            bankCode
            number
            businessNumber
          }
          paused
          takeoutDiscount
          creditDiscount
          takeout
          intro
          notice
          bookTable
          bookTableNote
          depositAmount
          delivery
          deliveryFee {
            start
            end
            fee
          }
          waitingTime
          itemIds
          updatedAt
          createdAt
        }
        notification {
          options {
            type
            email
            sms
          }
        }
        groups {
          items {
            id
            name
            type
            storeGroupsId
            locationGroupsId
            key
            conditions {
              key
              object
              field
              operations {
                operation
                type
                value
              }
              value
              operation
              type
            }
            count
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        locations {
          items {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          nextToken
        }
      }
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const listStoreCustomers = /* GraphQL */ `
  query ListStoreCustomers(
    $filter: ModelStoreCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listCustomerByStore = /* GraphQL */ `
  query ListCustomerByStore(
    $storeId: ID
    $customerId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerByStore(
      storeId: $storeId
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listStoreByCustomer = /* GraphQL */ `
  query ListStoreByCustomer(
    $customerId: ID
    $storeId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreByCustomer(
      customerId: $customerId
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        storeId
        sources {
          id
          type
          name
          ident
          createdAt
        }
        isFavorite
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        status
        registeredAt
        campaignBlockedAt
        note
        removedAt
        updatedAt
        createdAt
        points {
          items {
            id
            locationId
            storeId
            type
            name
            method
            amount
            origin
            provider
            providerCustomerId
            providerShopNo
            providerSyncedAt
            currency
            point
            extraPoint
            extraExpire
            items {
              type
              itemId
              name
              parentId
              point
              amount
              quantity
            }
            quantity
            note
            orderId
            referId
            orderNumberPrefix
            orderNumber
            customerId
            pointTransactionCustomerId
            expiredAt
            salesDate
            eventId
            updatedAt
            createdAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        credits {
          items {
            id
            locationId
            storeId
            name
            type
            amount
            origin
            note
            currency
            parentId
            orderId
            orderNumberPrefix
            orderNumber
            customerId
            creditTransactionCustomerId
            description
            salesDate
            createdAt
            updatedAt
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
          }
          nextToken
        }
        _delta
        orders {
          items {
            id
            orderLocationId
            numberPrefix
            number
            beeper
            enterpriseId
            storeId
            customerId
            orderCustomerId
            state
            amount
            amountPaid
            origin
            subOrigin
            originId
            customerProvider
            providerCustomerId
            customerProviderShopNo
            amountChanged
            amountReturned
            tax
            currency
            quantity
            shippingType
            diningOption
            diningState
            retailOption
            retailState
            mergeGroupId
            mergeBlocked
            deliveredAt
            name
            phone
            address
            zip
            customerGender
            customerAge
            customerCountry
            receivers {
              id
              type
              shipmentSeq
              provision
              name
              phone
              zip
              address1
              address2
              addressState
              addressCity
              addressStreet
              addressFull
              note
              shippingCompanyCode
              shippingAcceptCount
              shippingStartCount
              trackingNumber
              providerShippingId
              providerSyncStatus
              providerSyncError
              providerSyncedAt
              issuedAt
              privacyAgreedAt
              waybillMeta
            }
            tableId
            tableIds
            parentDeviceId
            deviceId
            reserveDate
            pickupDate
            shippingDate
            items {
              id
              type
              index
              category
              categories {
                id
                name
              }
              classificationIds
              productId
              modifierId
              name
              description
              amount
              price
              parentId
              providerProductId
              providerOptionId
              providerProductName
              providerOptionName
              matchType
              matchedQuantity
              receiverId
              shippingLocationId
              returnShippingLocationId
              referType
              referId
              campaignId
              eventId
              requestId
              quantity
              sku
              tax
              taxRate
              diningOption
              diningState
              retailOption
              retailState
              confirmedAt
              shippedAt
              deliveredAt
              modifiers {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              discounts {
                id
                scope
                type
                amount
                name
              }
              discountable
              discountQuantity
              discountIncludeIds
              discountExcludeIds
              discountMethod
              discountValue
              orderedQuantity
              voidQuantity
              paidQuantity
              readyQuantity
              receivedQuantity
              inventoryReason
              point
              note
              salesDate
              createdAt
            }
            createdEmployeeId
            createdDeviceId
            updatedDeviceId
            shippingLocationId
            returnShippingLocationId
            confirmedEmployeeId
            importedAt
            confirmedAt
            createdAt
            paidAt
            salesDate
            returnedAt
            reopenedAt
            shippedAt
            returnShippedAt
            returnSalesDate
            updatedAt
            noticeCount
            visitorCount
            totalPoint
            pointSaved
            receiptId
            receiptNumber
            receiptCount
            alarmCustomerId
            receiptCustomerId
            note
            request
            charges {
              id
              method
              extraMethod
              gateway
              amount
              tax
              taxRefundAmount
              purchaser {
                name
                number
                nation
                gender
                birth
                address
              }
              supplyAmount
              taxFreeAmount
              amountRefunded
              createdEmployeeId
              createdDeviceId
              salesDate
              createdAt
              creditTransactionId
              balance
              splitType
              pg
              van
              origin
              originId
              note
              brand
              name
              ident
              installment
              transactionId
              approver
              issuerCode
              acquirer
              acquirerCode
              acquirerName
              refundable
              recurring
              approvalCode
              approvalDate
              approvalNumber
              signature {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              terminalId
              refunds {
                id
                amount
                supplyAmount
                taxFreeAmount
                tax
                taxRefundAmount
                creditTransactionId
                approvalNumber
                approvalDate
                transactionId
                origin
                originId
                currency
                reason
                bankCode
                bankName
                bankAccountNo
                bankAccountHolder
                createdEmployeeId
                createdDeviceId
                terminalId
                salesDate
                createdAt
              }
            }
            exchanges {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              chargeIds
              providerClaimId
              salesDate
              createdAt
            }
            returns {
              exchangeGroupId
              amount
              currency
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              refundId
              refundIds
              providerClaimId
              receiverId
              shippingFee
              shippingPayType
              settled
              settledAt
              salesDate
              createdAt
            }
            fee
            revision
            _delta
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            customer {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            orderCustomer {
              id
              enterpriseId
              storeId
              locationId
              customerId
              provider
              providerCustomerId
              shopNo
              tier
              tierId
              customerCreatedAt
              ident
              identType
              type
              name
              nameKeyword
              payments {
                id
                method
                pg
                number
                name
                expMonth
                expYear
                billingKey
                updatedAt
                createdAt
              }
              attributes {
                name
                type
                value
              }
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              tags {
                tagId
                createdLocationId
              }
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              status
              registeredAt
              salesDate
              campaignBlockedAt
              blacklistedAt
              isFavorite
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              note
              sources {
                id
                type
                name
                ident
                createdAt
              }
              removedAt
              updatedAt
              createdAt
              _delta
              timestamp
              expdate
            }
          }
          nextToken
        }
        location {
          id
          name
          type
          code
          brand
          brandId
          provider
          address
          zip
          phone
          logo {
            key
            bucket
            region
            level
            url
            xsmall
            small
          }
          representative
          businessNumber
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          businessHours {
            sun {
              open
              close
            }
            mon {
              open
              close
            }
            tue {
              open
              close
            }
            wed {
              open
              close
            }
            thu {
              open
              close
            }
            fri {
              open
              close
            }
            sat {
              open
              close
            }
          }
          storeId
          state
          menuPlanId
          payments {
            refund
            barcode
            barcodeVan
            barcodeTerminalId
          }
          policy {
            locationCost
            loyaltyCost
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mini {
            defaultItemName
          }
          orderPlanId
          menu {
            board {
              textSize
              columnSize
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              enableFavorite
            }
            list {
              pages {
                title
                index
                ids
                parentId
              }
              favorite {
                parentId
                badge
                type
                position
                activeOptions
              }
              shortcuts {
                type
                title
                itemName
                itemPrice
                active
              }
            }
            navOrder
          }
          menus {
            parentId
            position
            page
            pageTitle
          }
          favMenus {
            parentId
            position
            page
            pageTitle
          }
          catMenus {
            title
            index
            ids
            parentId
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          waiting {
            status
            waitingOptions {
              id
              type
              name
              nameMl {
                en
                zh
                ja
              }
              items {
                id
                name
                limitQuantity
              }
              required
              updatedAt
              createdAt
            }
            waitingMinutes
            waitingMinutesHide
            hasForeigner
            foreignerMethod
            notifications {
              created
              ready
              requested
              cancelled
            }
            notices {
              createdNotice
              createdNoticeMl {
                en
                zh
                ja
              }
              requestedNotice
              requestedNoticeMl {
                en
                zh
                ja
              }
            }
            settings {
              autoCancel
              autoCancelMinutes
            }
            updatedAt
            createdAt
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          tables {
            id
            width
            height
            name
            axisX
            axisY
            screenHeight
            screenWidth
            initialX
            initialY
            shape
            layout {
              x
              y
              w
              h
            }
            color
            orderId
            disabled
          }
          boardTables {
            title
            index
            items {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
          }
          gridTables {
            id
            name
            orderId
            index
            page
          }
          modifierSoldoutIds
          delivery {
            baemin
            coupang
            yogiyo
            enableGenProd
            updatedAt
            createdAt
          }
          createdAt
          updatedAt
          sales {
            startedAt
            endedAt
            reserves
            actualBalance
            currency
            note
            estimateBalance
            detail {
              totalSales
              totalRefund
              totalTax
              totalDiscount
              supplyAmount
              totalSalesCount
              cash {
                sales
                refund
              }
              card {
                sales
                refund
              }
              credit {
                sales
                refund
              }
              barcode {
                sales
                refund
              }
              extra {
                sales
                refund
              }
              refund {
                sales
                refund
              }
              products {
                id
                name
                quantity
                amount
              }
              origins {
                pos
                kiosk
                menuorder
                delivery
                market
              }
            }
            reservesHistories {
              type
              amount
              note
              createdEmployeeId
              createdAt
            }
          }
        }
        store {
          id
          enterpriseId
          info {
            name
            phone
            email
            representative
            businessType
            businessNumber
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            industryType
            sendNumber
            currency
            address
            zip
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            csPhone
          }
          policy {
            multiLocation
            provider {
              key
              ident
              customer
              customerQr
              coupon
              inventory
              inventoryLocationId
              locationId
              userId
              userPassword
              shopMap {
                storeId
                shopNo
                name
                originName
                countryCode
                usableCouponIds
                currencyCode
              }
            }
          }
          currency
          payments {
            card
            cardJoined
            cash
            credit
            refund
          }
          devices {
            id
            ident
            locationId
            system
            ipAddress
            brand
            model
            name
            type
            deviceType
            display {
              height
              width
            }
            protocol
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            barcodeReader
            appVersion
            sysVersion
            status
            password
            msgToken
            parentId
            childId
            sleepMode
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            terminalId
            printOptions {
              port
              baudRate
              receipt
              receiptButtonHide
              storeNameHide
              bills
              refund
              salesEnd
              order
              orderBeep
              orderCount
              orderExcludeIds
              delivery
            }
            updatedAt
            createdAt
          }
          plans {
            menus {
              id
              name
              mode
              size
              menus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              pages {
                index
                parentId
                title
              }
              updatedAt
              createdAt
            }
            orders {
              id
              name
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              updatedAt
              createdAt
            }
          }
          taxes {
            id
            type
            name
            enabled
            rate
            method
            targetType
          }
          receipt {
            salesSlip
            orderList
            barcode
            footnote
            phone
            orderNumberHide
            storeNameHide
            orderSheetFontSize
            billsBusinessInfo
            giftFootnote
            giftReceipt
            enReceipt
          }
          subscription {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            updatedAt
            createdAt
          }
          view {
            order {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
            itemReport {
              excludeColumns
            }
            summaryReport {
              excludeColumns
            }
            shippingOrder {
              excludeColumns
            }
            trsItemReport {
              excludeColumns
            }
            customReport {
              excludeColumns
              exportTemplates {
                name
                type
              }
            }
          }
          settings {
            mode
            table
            diningOption
            retailOption
            orderAlarm
            orderConfirm
            addressInput
            autoPay
            autoReturnItem
            autoSoldout
            menuGridSize
            menuMode
            tableMode
            orderNotify
            orderNotifySkippable
            disablePhonePrefix
            autoCloseScreen
            orderNumberPrefix {
              pos
              kiosk
              menuOrder
            }
            orderMgmt {
              kiosk
              menuorder
              delivery
              pos
            }
            reportBasis
            orderOrigins
            beeper {
              active
              coverage
              skippable
            }
            kioskOptions {
              mode
              isActive
              tableId
              orderId
              callable
              payable
              enableDiningOption
              resetTime
              menus {
                title
                index
                ids
                parentId
              }
              columnSize
            }
            customerOptions {
              countries
              ages
              gender
            }
          }
          item {
            attributes {
              name
              type
              value
            }
            actualPrice
            skuMgmt
            barcodeMgmt
            stockTrack
            variablePrice
            locationCreatable
          }
          inventory {
            attributes {
              name
              type
              value
            }
            expiryDateMgmt
            expiryDateAlertDays
            hqWhExposureEnabled
            hqWhExposureLocIds
            hqWhUnexposureLocIds
            customAdjustDateEnabled
          }
          customer {
            attributes {
              name
              type
              value
            }
          }
          billing {
            key
            businessNumber
            name
            email
            phone
            contanctName
            contactName
            address
            zip
            card {
              pg
              number
              name
              expMonth
              expYear
              identify
              password
              billingKey
            }
          }
          credit {
            autoCharge
            autoChargeCredit
            autoChargeQuantity
            alertCredit
          }
          kakao {
            agency
            key
            channelId
            categoryCode
            status
            updatedAt
            createdAt
          }
          review {
            status
            campaignId
            updatedAt
            createdAt
          }
          kiosk {
            status
            callable
            payable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            exchangeTicket
            columnSize
            discounts {
              condition
              couponId
            }
            menuDescription
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            titles
            titlePosition
            updatedAt
            createdAt
          }
          menuOrder {
            callOptions {
              index
              label
            }
            orderable
            menus {
              title
              titleMl {
                en
                zh
                ja
              }
              index
              ids
              items {
                parentId
                badge
                type
                position
                activeOptions
              }
              parentId
            }
            multilingual
            displayImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            columnSize
            fontSize
            notice
            resetTime
            enableCash
            boardType
          }
          kds {
            layout
            alerts {
              urgent
              warning
            }
            disabledProdIds
            orderNotify
          }
          mirror {
            images {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            video {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorImages {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            mirrorVideo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            methods
            multilingual
            layout
            featuredPosition
            titles
            pointTitleIndexs
            textColor
            pointColor
            displayColor
            featuredColor
            featuredImage {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
          }
          loyalty {
            status
            provider
            sharePolicy
            type
            grade
            conditionType
            conditionSubType
            condition {
              minAmount
              perAmount
              minTime
              rate
              expirationPeriod
              excludeProdIds
              excludeLocIds
              discountPointSavable
            }
            conditionItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            conditionTiers {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardType
            rewardSubType
            reward {
              requirePoint
              requireOrderAmount
              minUsePoint
              minRequireRate
              maxUsePoint
            }
            rewardItems {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardRates {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardAmounts {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCashs {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardCoupons {
              id
              itemId
              name
              parentId
              rate
              point
              amount
            }
            rewardDelayDays
            rewardDelayIssueTime
            incentives {
              fulfill
              fulfillPoint
              fulfillCampaignId
              birth
              birthPoint
              birthCampaignId
              birthItem {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
            }
            notification {
              register
              registerCampainId
              save
              saveCampaignId
              use
              useCampaignId
              expire
              expireCampaignId
            }
          }
          market {
            status
            account {
              ident
              holder
              bank
              bankCode
              number
              businessNumber
            }
            paused
            takeoutDiscount
            creditDiscount
            takeout
            intro
            notice
            bookTable
            bookTableNote
            depositAmount
            delivery
            deliveryFee {
              start
              end
              fee
            }
            waitingTime
            itemIds
            updatedAt
            createdAt
          }
          notification {
            options {
              type
              email
              sms
            }
          }
          groups {
            items {
              id
              name
              type
              storeGroupsId
              locationGroupsId
              key
              conditions {
                key
                object
                field
                value
                operation
                type
              }
              count
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          locations {
            items {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            nextToken
          }
        }
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      ident
      identType
      type
      name
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      updatedAt
      createdAt
      stores {
        items {
          id
          customerId
          storeId
          sources {
            id
            type
            name
            ident
            createdAt
          }
          isFavorite
          locationId
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          favoriteLocationIds
          visitedLocationIds
          locations {
            id
            locationId
            isFavorite
            status
            note
            campaignBlockedAt
            blacklistedAt
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            subscriptions {
              id
              planId
              payStatus
              sessionId
              nextPayDate
              paidAt
              unsubscribedAt
              used
              lastUsedAt
              orderId
              unsubscribeRequestedAt
              startDate
              expireDate
              updatedAt
              createdAt
            }
            registeredAt
            salesDate
            updatedAt
            createdAt
          }
          status
          registeredAt
          campaignBlockedAt
          note
          removedAt
          updatedAt
          createdAt
          points {
            items {
              id
              locationId
              storeId
              type
              name
              method
              amount
              origin
              provider
              providerCustomerId
              providerShopNo
              providerSyncedAt
              currency
              point
              extraPoint
              extraExpire
              items {
                type
                itemId
                name
                parentId
                point
                amount
                quantity
              }
              quantity
              note
              orderId
              referId
              orderNumberPrefix
              orderNumber
              customerId
              pointTransactionCustomerId
              expiredAt
              salesDate
              eventId
              updatedAt
              createdAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          credits {
            items {
              id
              locationId
              storeId
              name
              type
              amount
              origin
              note
              currency
              parentId
              orderId
              orderNumberPrefix
              orderNumber
              customerId
              creditTransactionCustomerId
              description
              salesDate
              createdAt
              updatedAt
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
            }
            nextToken
          }
          _delta
          orders {
            items {
              id
              orderLocationId
              numberPrefix
              number
              beeper
              enterpriseId
              storeId
              customerId
              orderCustomerId
              state
              amount
              amountPaid
              origin
              subOrigin
              originId
              customerProvider
              providerCustomerId
              customerProviderShopNo
              amountChanged
              amountReturned
              tax
              currency
              quantity
              shippingType
              diningOption
              diningState
              retailOption
              retailState
              mergeGroupId
              mergeBlocked
              deliveredAt
              name
              phone
              address
              zip
              customerGender
              customerAge
              customerCountry
              receivers {
                id
                type
                shipmentSeq
                provision
                name
                phone
                zip
                address1
                address2
                addressState
                addressCity
                addressStreet
                addressFull
                note
                shippingCompanyCode
                shippingAcceptCount
                shippingStartCount
                trackingNumber
                providerShippingId
                providerSyncStatus
                providerSyncError
                providerSyncedAt
                issuedAt
                privacyAgreedAt
                waybillMeta
              }
              tableId
              tableIds
              parentDeviceId
              deviceId
              reserveDate
              pickupDate
              shippingDate
              items {
                id
                type
                index
                category
                classificationIds
                productId
                modifierId
                name
                description
                amount
                price
                parentId
                providerProductId
                providerOptionId
                providerProductName
                providerOptionName
                matchType
                matchedQuantity
                receiverId
                shippingLocationId
                returnShippingLocationId
                referType
                referId
                campaignId
                eventId
                requestId
                quantity
                sku
                tax
                taxRate
                diningOption
                diningState
                retailOption
                retailState
                confirmedAt
                shippedAt
                deliveredAt
                discountable
                discountQuantity
                discountIncludeIds
                discountExcludeIds
                discountMethod
                discountValue
                orderedQuantity
                voidQuantity
                paidQuantity
                readyQuantity
                receivedQuantity
                inventoryReason
                point
                note
                salesDate
                createdAt
              }
              createdEmployeeId
              createdDeviceId
              updatedDeviceId
              shippingLocationId
              returnShippingLocationId
              confirmedEmployeeId
              importedAt
              confirmedAt
              createdAt
              paidAt
              salesDate
              returnedAt
              reopenedAt
              shippedAt
              returnShippedAt
              returnSalesDate
              updatedAt
              noticeCount
              visitorCount
              totalPoint
              pointSaved
              receiptId
              receiptNumber
              receiptCount
              alarmCustomerId
              receiptCustomerId
              note
              request
              charges {
                id
                method
                extraMethod
                gateway
                amount
                tax
                taxRefundAmount
                supplyAmount
                taxFreeAmount
                amountRefunded
                createdEmployeeId
                createdDeviceId
                salesDate
                createdAt
                creditTransactionId
                balance
                splitType
                pg
                van
                origin
                originId
                note
                brand
                name
                ident
                installment
                transactionId
                approver
                issuerCode
                acquirer
                acquirerCode
                acquirerName
                refundable
                recurring
                approvalCode
                approvalDate
                approvalNumber
                terminalId
              }
              exchanges {
                exchangeGroupId
                amount
                currency
                chargeIds
                providerClaimId
                salesDate
                createdAt
              }
              returns {
                exchangeGroupId
                amount
                currency
                refundId
                refundIds
                providerClaimId
                receiverId
                shippingFee
                shippingPayType
                settled
                settledAt
                salesDate
                createdAt
              }
              fee
              revision
              _delta
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              customer {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              orderCustomer {
                id
                enterpriseId
                storeId
                locationId
                customerId
                provider
                providerCustomerId
                shopNo
                tier
                tierId
                customerCreatedAt
                ident
                identType
                type
                name
                nameKeyword
                phone
                email
                birth
                ageGroup
                gender
                status
                registeredAt
                salesDate
                campaignBlockedAt
                blacklistedAt
                isFavorite
                note
                removedAt
                updatedAt
                createdAt
                _delta
                timestamp
                expdate
              }
            }
            nextToken
          }
          location {
            id
            name
            type
            code
            brand
            brandId
            provider
            address
            zip
            phone
            logo {
              key
              bucket
              region
              level
              url
              xsmall
              small
            }
            representative
            businessNumber
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            businessHours {
              sun {
                open
                close
              }
              mon {
                open
                close
              }
              tue {
                open
                close
              }
              wed {
                open
                close
              }
              thu {
                open
                close
              }
              fri {
                open
                close
              }
              sat {
                open
                close
              }
            }
            storeId
            state
            menuPlanId
            payments {
              refund
              barcode
              barcodeVan
              barcodeTerminalId
            }
            policy {
              locationCost
              loyaltyCost
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mini {
              defaultItemName
            }
            orderPlanId
            menu {
              board {
                textSize
                columnSize
                enableFavorite
              }
              navOrder
            }
            menus {
              parentId
              position
              page
              pageTitle
            }
            favMenus {
              parentId
              position
              page
              pageTitle
            }
            catMenus {
              title
              index
              ids
              parentId
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            waiting {
              status
              waitingOptions {
                id
                type
                name
                required
                updatedAt
                createdAt
              }
              waitingMinutes
              waitingMinutesHide
              hasForeigner
              foreignerMethod
              notifications {
                created
                ready
                requested
                cancelled
              }
              notices {
                createdNotice
                requestedNotice
              }
              settings {
                autoCancel
                autoCancelMinutes
              }
              updatedAt
              createdAt
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            tables {
              id
              width
              height
              name
              axisX
              axisY
              screenHeight
              screenWidth
              initialX
              initialY
              shape
              layout {
                x
                y
                w
                h
              }
              color
              orderId
              disabled
            }
            boardTables {
              title
              index
              items {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
            }
            gridTables {
              id
              name
              orderId
              index
              page
            }
            modifierSoldoutIds
            delivery {
              baemin
              coupang
              yogiyo
              enableGenProd
              updatedAt
              createdAt
            }
            createdAt
            updatedAt
            sales {
              startedAt
              endedAt
              reserves
              actualBalance
              currency
              note
              estimateBalance
              detail {
                totalSales
                totalRefund
                totalTax
                totalDiscount
                supplyAmount
                totalSalesCount
              }
              reservesHistories {
                type
                amount
                note
                createdEmployeeId
                createdAt
              }
            }
          }
          store {
            id
            enterpriseId
            info {
              name
              phone
              email
              representative
              businessType
              businessNumber
              industryType
              sendNumber
              currency
              address
              zip
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              csPhone
            }
            policy {
              multiLocation
              provider {
                key
                ident
                customer
                customerQr
                coupon
                inventory
                inventoryLocationId
                locationId
                userId
                userPassword
              }
            }
            currency
            payments {
              card
              cardJoined
              cash
              credit
              refund
            }
            devices {
              id
              ident
              locationId
              system
              ipAddress
              brand
              model
              name
              type
              deviceType
              display {
                height
                width
              }
              protocol
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              barcodeReader
              appVersion
              sysVersion
              status
              password
              msgToken
              parentId
              childId
              sleepMode
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              terminalId
              printOptions {
                port
                baudRate
                receipt
                receiptButtonHide
                storeNameHide
                bills
                refund
                salesEnd
                order
                orderBeep
                orderCount
                orderExcludeIds
                delivery
              }
              updatedAt
              createdAt
            }
            plans {
              menus {
                id
                name
                mode
                size
                updatedAt
                createdAt
              }
              orders {
                id
                name
                updatedAt
                createdAt
              }
            }
            taxes {
              id
              type
              name
              enabled
              rate
              method
              targetType
            }
            receipt {
              salesSlip
              orderList
              barcode
              footnote
              phone
              orderNumberHide
              storeNameHide
              orderSheetFontSize
              billsBusinessInfo
              giftFootnote
              giftReceipt
              enReceipt
            }
            subscription {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              updatedAt
              createdAt
            }
            view {
              order {
                excludeColumns
              }
              itemReport {
                excludeColumns
              }
              summaryReport {
                excludeColumns
              }
              shippingOrder {
                excludeColumns
              }
              trsItemReport {
                excludeColumns
              }
              customReport {
                excludeColumns
              }
            }
            settings {
              mode
              table
              diningOption
              retailOption
              orderAlarm
              orderConfirm
              addressInput
              autoPay
              autoReturnItem
              autoSoldout
              menuGridSize
              menuMode
              tableMode
              orderNotify
              orderNotifySkippable
              disablePhonePrefix
              autoCloseScreen
              orderNumberPrefix {
                pos
                kiosk
                menuOrder
              }
              orderMgmt {
                kiosk
                menuorder
                delivery
                pos
              }
              reportBasis
              orderOrigins
              beeper {
                active
                coverage
                skippable
              }
              kioskOptions {
                mode
                isActive
                tableId
                orderId
                callable
                payable
                enableDiningOption
                resetTime
                columnSize
              }
              customerOptions {
                countries
                ages
                gender
              }
            }
            item {
              attributes {
                name
                type
                value
              }
              actualPrice
              skuMgmt
              barcodeMgmt
              stockTrack
              variablePrice
              locationCreatable
            }
            inventory {
              attributes {
                name
                type
                value
              }
              expiryDateMgmt
              expiryDateAlertDays
              hqWhExposureEnabled
              hqWhExposureLocIds
              hqWhUnexposureLocIds
              customAdjustDateEnabled
            }
            customer {
              attributes {
                name
                type
                value
              }
            }
            billing {
              key
              businessNumber
              name
              email
              phone
              contanctName
              contactName
              address
              zip
              card {
                pg
                number
                name
                expMonth
                expYear
                identify
                password
                billingKey
              }
            }
            credit {
              autoCharge
              autoChargeCredit
              autoChargeQuantity
              alertCredit
            }
            kakao {
              agency
              key
              channelId
              categoryCode
              status
              updatedAt
              createdAt
            }
            review {
              status
              campaignId
              updatedAt
              createdAt
            }
            kiosk {
              status
              callable
              payable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              exchangeTicket
              columnSize
              discounts {
                condition
                couponId
              }
              menuDescription
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              titles
              titlePosition
              updatedAt
              createdAt
            }
            menuOrder {
              callOptions {
                index
                label
              }
              orderable
              menus {
                title
                index
                ids
                parentId
              }
              multilingual
              displayImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              columnSize
              fontSize
              notice
              resetTime
              enableCash
              boardType
            }
            kds {
              layout
              alerts {
                urgent
                warning
              }
              disabledProdIds
              orderNotify
            }
            mirror {
              images {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              video {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorImages {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              mirrorVideo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              methods
              multilingual
              layout
              featuredPosition
              titles
              pointTitleIndexs
              textColor
              pointColor
              displayColor
              featuredColor
              featuredImage {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
            }
            loyalty {
              status
              provider
              sharePolicy
              type
              grade
              conditionType
              conditionSubType
              condition {
                minAmount
                perAmount
                minTime
                rate
                expirationPeriod
                excludeProdIds
                excludeLocIds
                discountPointSavable
              }
              conditionItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              conditionTiers {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardType
              rewardSubType
              reward {
                requirePoint
                requireOrderAmount
                minUsePoint
                minRequireRate
                maxUsePoint
              }
              rewardItems {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardRates {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardAmounts {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCashs {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardCoupons {
                id
                itemId
                name
                parentId
                rate
                point
                amount
              }
              rewardDelayDays
              rewardDelayIssueTime
              incentives {
                fulfill
                fulfillPoint
                fulfillCampaignId
                birth
                birthPoint
                birthCampaignId
              }
              notification {
                register
                registerCampainId
                save
                saveCampaignId
                use
                useCampaignId
                expire
                expireCampaignId
              }
            }
            market {
              status
              account {
                ident
                holder
                bank
                bankCode
                number
                businessNumber
              }
              paused
              takeoutDiscount
              creditDiscount
              takeout
              intro
              notice
              bookTable
              bookTableNote
              depositAmount
              delivery
              deliveryFee {
                start
                end
                fee
              }
              waitingTime
              itemIds
              updatedAt
              createdAt
            }
            notification {
              options {
                type
                email
                sms
              }
            }
            groups {
              items {
                id
                name
                type
                storeGroupsId
                locationGroupsId
                key
                count
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            locations {
              items {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              nextToken
            }
          }
          customer {
            id
            ident
            identType
            type
            name
            addresses {
              id
              main
              detail
              storeId
            }
            phone
            email
            birth
            agreements {
              privacy
              provider
              eula
              marketing
              updatedAt
              createdAt
            }
            ageGroup
            gender
            updatedAt
            createdAt
            stores {
              items {
                id
                customerId
                storeId
                isFavorite
                locationId
                favoriteLocationIds
                visitedLocationIds
                status
                registeredAt
                campaignBlockedAt
                note
                removedAt
                updatedAt
                createdAt
                _delta
              }
              nextToken
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getStoreCustomerDelta = /* GraphQL */ `
  query GetStoreCustomerDelta($id: ID!) {
    getStoreCustomerDelta(id: $id) {
      id
      customerId
      storeId
      locationId
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      campaignBlockedAt
      isFavorite
      favoriteLocationIds
      visitedLocationIds
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
      customer {
        id
        ident
        identType
        type
        name
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        updatedAt
        createdAt
        stores {
          items {
            id
            customerId
            storeId
            sources {
              id
              type
              name
              ident
              createdAt
            }
            isFavorite
            locationId
            point {
              used
              saved
              extra
              lastSavedAt
              lastTransactedAt
            }
            credit {
              deposit
              withdraw
              balance
              lastTransactedAt
            }
            favoriteLocationIds
            visitedLocationIds
            locations {
              id
              locationId
              isFavorite
              status
              note
              campaignBlockedAt
              blacklistedAt
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              subscriptions {
                id
                planId
                payStatus
                sessionId
                nextPayDate
                paidAt
                unsubscribedAt
                used
                lastUsedAt
                orderId
                unsubscribeRequestedAt
                startDate
                expireDate
                updatedAt
                createdAt
              }
              registeredAt
              salesDate
              updatedAt
              createdAt
            }
            status
            registeredAt
            campaignBlockedAt
            note
            removedAt
            updatedAt
            createdAt
            points {
              items {
                id
                locationId
                storeId
                type
                name
                method
                amount
                origin
                provider
                providerCustomerId
                providerShopNo
                providerSyncedAt
                currency
                point
                extraPoint
                extraExpire
                quantity
                note
                orderId
                referId
                orderNumberPrefix
                orderNumber
                customerId
                pointTransactionCustomerId
                expiredAt
                salesDate
                eventId
                updatedAt
                createdAt
              }
              nextToken
            }
            credits {
              items {
                id
                locationId
                storeId
                name
                type
                amount
                origin
                note
                currency
                parentId
                orderId
                orderNumberPrefix
                orderNumber
                customerId
                creditTransactionCustomerId
                description
                salesDate
                createdAt
                updatedAt
              }
              nextToken
            }
            _delta
            orders {
              items {
                id
                orderLocationId
                numberPrefix
                number
                beeper
                enterpriseId
                storeId
                customerId
                orderCustomerId
                state
                amount
                amountPaid
                origin
                subOrigin
                originId
                customerProvider
                providerCustomerId
                customerProviderShopNo
                amountChanged
                amountReturned
                tax
                currency
                quantity
                shippingType
                diningOption
                diningState
                retailOption
                retailState
                mergeGroupId
                mergeBlocked
                deliveredAt
                name
                phone
                address
                zip
                customerGender
                customerAge
                customerCountry
                tableId
                tableIds
                parentDeviceId
                deviceId
                reserveDate
                pickupDate
                shippingDate
                createdEmployeeId
                createdDeviceId
                updatedDeviceId
                shippingLocationId
                returnShippingLocationId
                confirmedEmployeeId
                importedAt
                confirmedAt
                createdAt
                paidAt
                salesDate
                returnedAt
                reopenedAt
                shippedAt
                returnShippedAt
                returnSalesDate
                updatedAt
                noticeCount
                visitorCount
                totalPoint
                pointSaved
                receiptId
                receiptNumber
                receiptCount
                alarmCustomerId
                receiptCustomerId
                note
                request
                fee
                revision
                _delta
              }
              nextToken
            }
            location {
              id
              name
              type
              code
              brand
              brandId
              provider
              address
              zip
              phone
              logo {
                key
                bucket
                region
                level
                url
                xsmall
                small
              }
              representative
              businessNumber
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              storeId
              state
              menuPlanId
              payments {
                refund
                barcode
                barcodeVan
                barcodeTerminalId
              }
              policy {
                locationCost
                loyaltyCost
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mini {
                defaultItemName
              }
              orderPlanId
              menu {
                navOrder
              }
              menus {
                parentId
                position
                page
                pageTitle
              }
              favMenus {
                parentId
                position
                page
                pageTitle
              }
              catMenus {
                title
                index
                ids
                parentId
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              waiting {
                status
                waitingMinutes
                waitingMinutesHide
                hasForeigner
                foreignerMethod
                updatedAt
                createdAt
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              tables {
                id
                width
                height
                name
                axisX
                axisY
                screenHeight
                screenWidth
                initialX
                initialY
                shape
                color
                orderId
                disabled
              }
              boardTables {
                title
                index
              }
              gridTables {
                id
                name
                orderId
                index
                page
              }
              modifierSoldoutIds
              delivery {
                baemin
                coupang
                yogiyo
                enableGenProd
                updatedAt
                createdAt
              }
              createdAt
              updatedAt
              sales {
                startedAt
                endedAt
                reserves
                actualBalance
                currency
                note
                estimateBalance
              }
            }
            store {
              id
              enterpriseId
              info {
                name
                phone
                email
                representative
                businessType
                businessNumber
                industryType
                sendNumber
                currency
                address
                zip
                csPhone
              }
              policy {
                multiLocation
              }
              currency
              payments {
                card
                cardJoined
                cash
                credit
                refund
              }
              devices {
                id
                ident
                locationId
                system
                ipAddress
                brand
                model
                name
                type
                deviceType
                protocol
                barcodeReader
                appVersion
                sysVersion
                status
                password
                msgToken
                parentId
                childId
                sleepMode
                terminalId
                updatedAt
                createdAt
              }
              taxes {
                id
                type
                name
                enabled
                rate
                method
                targetType
              }
              receipt {
                salesSlip
                orderList
                barcode
                footnote
                phone
                orderNumberHide
                storeNameHide
                orderSheetFontSize
                billsBusinessInfo
                giftFootnote
                giftReceipt
                enReceipt
              }
              subscription {
                status
                updatedAt
                createdAt
              }
              settings {
                mode
                table
                diningOption
                retailOption
                orderAlarm
                orderConfirm
                addressInput
                autoPay
                autoReturnItem
                autoSoldout
                menuGridSize
                menuMode
                tableMode
                orderNotify
                orderNotifySkippable
                disablePhonePrefix
                autoCloseScreen
                reportBasis
                orderOrigins
              }
              item {
                actualPrice
                skuMgmt
                barcodeMgmt
                stockTrack
                variablePrice
                locationCreatable
              }
              inventory {
                expiryDateMgmt
                expiryDateAlertDays
                hqWhExposureEnabled
                hqWhExposureLocIds
                hqWhUnexposureLocIds
                customAdjustDateEnabled
              }
              billing {
                key
                businessNumber
                name
                email
                phone
                contanctName
                contactName
                address
                zip
              }
              credit {
                autoCharge
                autoChargeCredit
                autoChargeQuantity
                alertCredit
              }
              kakao {
                agency
                key
                channelId
                categoryCode
                status
                updatedAt
                createdAt
              }
              review {
                status
                campaignId
                updatedAt
                createdAt
              }
              kiosk {
                status
                callable
                payable
                multilingual
                exchangeTicket
                columnSize
                menuDescription
                titles
                titlePosition
                updatedAt
                createdAt
              }
              menuOrder {
                orderable
                multilingual
                columnSize
                fontSize
                notice
                resetTime
                enableCash
                boardType
              }
              kds {
                layout
                disabledProdIds
                orderNotify
              }
              mirror {
                methods
                multilingual
                layout
                featuredPosition
                titles
                pointTitleIndexs
                textColor
                pointColor
                displayColor
                featuredColor
              }
              loyalty {
                status
                provider
                sharePolicy
                type
                grade
                conditionType
                conditionSubType
                rewardType
                rewardSubType
                rewardDelayDays
                rewardDelayIssueTime
              }
              market {
                status
                paused
                takeoutDiscount
                creditDiscount
                takeout
                intro
                notice
                bookTable
                bookTableNote
                depositAmount
                delivery
                waitingTime
                itemIds
                updatedAt
                createdAt
              }
              groups {
                nextToken
              }
              createdAt
              updatedAt
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              locations {
                nextToken
              }
            }
            customer {
              id
              ident
              identType
              type
              name
              addresses {
                id
                main
                detail
                storeId
              }
              phone
              email
              birth
              agreements {
                privacy
                provider
                eula
                marketing
                updatedAt
                createdAt
              }
              ageGroup
              gender
              updatedAt
              createdAt
              stores {
                nextToken
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;
export const listStoreCustomerDeltas = /* GraphQL */ `
  query ListStoreCustomerDeltas(
    $filter: ModelStoreCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCustomerDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        storeId
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        campaignBlockedAt
        isFavorite
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listStoreCustomerDeltaByStore = /* GraphQL */ `
  query ListStoreCustomerDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreCustomerDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        storeId
        locationId
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        campaignBlockedAt
        isFavorite
        favoriteLocationIds
        visitedLocationIds
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
        customer {
          id
          ident
          identType
          type
          name
          addresses {
            id
            main
            detail
            storeId
          }
          phone
          email
          birth
          agreements {
            privacy
            provider
            eula
            marketing
            updatedAt
            createdAt
          }
          ageGroup
          gender
          updatedAt
          createdAt
          stores {
            items {
              id
              customerId
              storeId
              sources {
                id
                type
                name
                ident
                createdAt
              }
              isFavorite
              locationId
              point {
                used
                saved
                extra
                lastSavedAt
                lastTransactedAt
              }
              credit {
                deposit
                withdraw
                balance
                lastTransactedAt
              }
              favoriteLocationIds
              visitedLocationIds
              locations {
                id
                locationId
                isFavorite
                status
                note
                campaignBlockedAt
                blacklistedAt
                registeredAt
                salesDate
                updatedAt
                createdAt
              }
              status
              registeredAt
              campaignBlockedAt
              note
              removedAt
              updatedAt
              createdAt
              points {
                nextToken
              }
              credits {
                nextToken
              }
              _delta
              orders {
                nextToken
              }
              location {
                id
                name
                type
                code
                brand
                brandId
                provider
                address
                zip
                phone
                representative
                businessNumber
                storeId
                state
                menuPlanId
                orderPlanId
                modifierSoldoutIds
                createdAt
                updatedAt
              }
              store {
                id
                enterpriseId
                currency
                createdAt
                updatedAt
              }
              customer {
                id
                ident
                identType
                type
                name
                phone
                email
                birth
                ageGroup
                gender
                updatedAt
                createdAt
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getLocationCustomerDelta = /* GraphQL */ `
  query GetLocationCustomerDelta($id: ID!, $locationId: ID!) {
    getLocationCustomerDelta(id: $id, locationId: $locationId) {
      id
      enterpriseId
      storeId
      locationId
      customerId
      provider
      providerCustomerId
      shopNo
      tier
      tierId
      customerCreatedAt
      ident
      identType
      type
      name
      nameKeyword
      payments {
        id
        method
        pg
        number
        name
        expMonth
        expYear
        billingKey
        updatedAt
        createdAt
      }
      attributes {
        name
        type
        value
      }
      addresses {
        id
        main
        detail
        storeId
      }
      phone
      email
      birth
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      ageGroup
      gender
      tags {
        tagId
        createdLocationId
      }
      point {
        used
        saved
        extra
        lastSavedAt
        lastTransactedAt
      }
      credit {
        deposit
        withdraw
        balance
        lastTransactedAt
      }
      status
      registeredAt
      salesDate
      campaignBlockedAt
      blacklistedAt
      isFavorite
      locations {
        id
        locationId
        isFavorite
        status
        note
        campaignBlockedAt
        blacklistedAt
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        registeredAt
        salesDate
        updatedAt
        createdAt
      }
      subscriptions {
        id
        planId
        payStatus
        sessionId
        nextPayDate
        paidAt
        unsubscribedAt
        used
        lastUsedAt
        orderId
        unsubscribeRequestedAt
        startDate
        expireDate
        updatedAt
        createdAt
      }
      note
      sources {
        id
        type
        name
        ident
        createdAt
      }
      removedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listLocationCustomerDeltas = /* GraphQL */ `
  query ListLocationCustomerDeltas(
    $id: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelLocationCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLocationCustomerDeltas(
      id: $id
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationCustomerDeltaByStore = /* GraphQL */ `
  query ListLocationCustomerDeltaByStore(
    $storeId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationCustomerDeltaByStore(
      storeId: $storeId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationCustomerDeltaByLocation = /* GraphQL */ `
  query ListLocationCustomerDeltaByLocation(
    $locationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationCustomerDeltaByLocation(
      locationId: $locationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listLocationCustomerDeltaByCustomer = /* GraphQL */ `
  query ListLocationCustomerDeltaByCustomer(
    $customerId: ID
    $storeId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationCustomerDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationCustomerDeltaByCustomer(
      customerId: $customerId
      storeId: $storeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enterpriseId
        storeId
        locationId
        customerId
        provider
        providerCustomerId
        shopNo
        tier
        tierId
        customerCreatedAt
        ident
        identType
        type
        name
        nameKeyword
        payments {
          id
          method
          pg
          number
          name
          expMonth
          expYear
          billingKey
          updatedAt
          createdAt
        }
        attributes {
          name
          type
          value
        }
        addresses {
          id
          main
          detail
          storeId
        }
        phone
        email
        birth
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        ageGroup
        gender
        tags {
          tagId
          createdLocationId
        }
        point {
          used
          saved
          extra
          lastSavedAt
          lastTransactedAt
        }
        credit {
          deposit
          withdraw
          balance
          lastTransactedAt
        }
        status
        registeredAt
        salesDate
        campaignBlockedAt
        blacklistedAt
        isFavorite
        locations {
          id
          locationId
          isFavorite
          status
          note
          campaignBlockedAt
          blacklistedAt
          point {
            used
            saved
            extra
            lastSavedAt
            lastTransactedAt
          }
          credit {
            deposit
            withdraw
            balance
            lastTransactedAt
          }
          subscriptions {
            id
            planId
            payStatus
            sessionId
            nextPayDate
            paidAt
            unsubscribedAt
            used
            lastUsedAt
            orderId
            unsubscribeRequestedAt
            startDate
            expireDate
            updatedAt
            createdAt
          }
          registeredAt
          salesDate
          updatedAt
          createdAt
        }
        subscriptions {
          id
          planId
          payStatus
          sessionId
          nextPayDate
          paidAt
          unsubscribedAt
          used
          lastUsedAt
          orderId
          unsubscribeRequestedAt
          startDate
          expireDate
          updatedAt
          createdAt
        }
        note
        sources {
          id
          type
          name
          ident
          createdAt
        }
        removedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getAlertEventHistory = /* GraphQL */ `
  query GetAlertEventHistory($id: ID!) {
    getAlertEventHistory(id: $id) {
      id
      type
      parentId
      subParentId
      storeId
      locationId
      title
      message
      updatedAt
      createdAt
    }
  }
`;
export const listAlertEventHistorys = /* GraphQL */ `
  query ListAlertEventHistorys(
    $filter: ModelAlertEventHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlertEventHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        parentId
        subParentId
        storeId
        locationId
        title
        message
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const listAlertEventHistoryByLocation = /* GraphQL */ `
  query ListAlertEventHistoryByLocation(
    $locationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAlertEventHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlertEventHistoryByLocation(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        parentId
        subParentId
        storeId
        locationId
        title
        message
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const getCustomerRequestDelta = /* GraphQL */ `
  query GetCustomerRequestDelta($id: ID!) {
    getCustomerRequestDelta(id: $id) {
      id
      storeId
      locationId
      messages
      orderId
      tableId
      parentDeviceId
      childDeviceId
      confirmedAt
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listCustomerRequestDeltas = /* GraphQL */ `
  query ListCustomerRequestDeltas(
    $filter: ModelCustomerRequestDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerRequestDeltas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        messages
        orderId
        tableId
        parentDeviceId
        childDeviceId
        confirmedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listCustomerRequestDeltaByLocation = /* GraphQL */ `
  query ListCustomerRequestDeltaByLocation(
    $locationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerRequestDeltaByLocation(
      locationId: $locationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        messages
        orderId
        tableId
        parentDeviceId
        childDeviceId
        confirmedAt
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const getWaitingDelta = /* GraphQL */ `
  query GetWaitingDelta($id: ID!) {
    getWaitingDelta(id: $id) {
      id
      storeId
      locationId
      status
      cancelledAt
      enteredAt
      readyAt
      requestedAt
      language
      number
      phone
      email
      visitors
      counter
      msgFailReason
      optionItems {
        optionId
        optionName
        optionItemId
        optionItemName
        quantity
      }
      agreements {
        privacy
        provider
        eula
        marketing
        updatedAt
        createdAt
      }
      salesDate
      updatedAt
      createdAt
      _delta
      timestamp
      expdate
    }
  }
`;
export const listWaitingDeltas = /* GraphQL */ `
  query ListWaitingDeltas(
    $filter: ModelWaitingDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWaitingDeltas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeId
        locationId
        status
        cancelledAt
        enteredAt
        readyAt
        requestedAt
        language
        number
        phone
        email
        visitors
        counter
        msgFailReason
        optionItems {
          optionId
          optionName
          optionItemId
          optionItemName
          quantity
        }
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        salesDate
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listWaitingDeltaByLocation = /* GraphQL */ `
  query ListWaitingDeltaByLocation(
    $locationId: ID
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWaitingDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWaitingDeltaByLocation(
      locationId: $locationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        status
        cancelledAt
        enteredAt
        readyAt
        requestedAt
        language
        number
        phone
        email
        visitors
        counter
        msgFailReason
        optionItems {
          optionId
          optionName
          optionItemId
          optionItemName
          quantity
        }
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        salesDate
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
export const listWaitingDeltaByLocationSalesDate = /* GraphQL */ `
  query ListWaitingDeltaByLocationSalesDate(
    $locationId: ID
    $salesDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWaitingDeltaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWaitingDeltaByLocationSalesDate(
      locationId: $locationId
      salesDate: $salesDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        locationId
        status
        cancelledAt
        enteredAt
        readyAt
        requestedAt
        language
        number
        phone
        email
        visitors
        counter
        msgFailReason
        optionItems {
          optionId
          optionName
          optionItemId
          optionItemName
          quantity
        }
        agreements {
          privacy
          provider
          eula
          marketing
          updatedAt
          createdAt
        }
        salesDate
        updatedAt
        createdAt
        _delta
        timestamp
        expdate
      }
      nextToken
    }
  }
`;
